(function () {
    "use strict";

    window.USD_TO_BRL_RATE = 1;
    window.USD_TO_EUR_RATE = 1;
    window.formatCurrency = function (amountInUSD) {
        if (window.isAssistCardBR) {
            return 'R$ ' + (amountInUSD * window.USD_TO_BRL_RATE).toFixed(2);
        }
        if (window.isAssistCardES) {
            return '€' + (amountInUSD * window.USD_TO_EUR_RATE).toFixed(2);
        }
        return '$' + parseFloat(amountInUSD).toFixed(2);
    };

    // Detect Brazilian page — combine all signals
    window.isAssistCardBR = /^\/pt(\/|$)/.test(window.location.pathname)
        || document.body.classList.contains('assist-card-br')
        || document.documentElement.lang === 'pt-BR'
        || window.isAssistCardBR === true;
    if (window.isAssistCardBR) {
        document.documentElement.classList.add('assist-card-br');
    }

    // Detect Spain/EUR landing — rely on theme.liquid flag / body class
    window.isAssistCardES = document.body.classList.contains('assist-card-es')
        || window.isAssistCardES === true;
    if (window.isAssistCardES) {
        document.documentElement.classList.add('assist-card-es');
    }

    // Capture the landing/origin URL of the session so purchases made from
    // shared templates/collections can be attributed to the landing page
    const LANDING_STORAGE_KEY = "tusim_landing_url";
    (function captureLandingUrl() {
        try {
            let landingUrl = sessionStorage.getItem(LANDING_STORAGE_KEY);
            if (!landingUrl) {
                const currentUrl = window.location.href;
                const referrer = document.referrer;
                const currentIsLanding =
                    window.location.pathname.includes("/pages/");
                const referrerIsLanding =
                    referrer &&
                    new URL(referrer, currentUrl).origin ===
                    window.location.origin &&
                    new URL(referrer, currentUrl).pathname.includes("/pages/");

                if (referrerIsLanding) {
                    // User came from an internal landing page
                    landingUrl = referrer;
                } else if (currentIsLanding) {
                    // User is currently on a landing page
                    landingUrl = currentUrl;
                } else {
                    landingUrl = currentUrl;
                }
                sessionStorage.setItem(LANDING_STORAGE_KEY, landingUrl);
                log("[TuSim:Landing] Landing URL captured", landingUrl);
            }
            window.TuSimLandingUrl = landingUrl;
        } catch (err) {
            error("[TuSim:Landing] Error capturing landing URL", err);
            window.TuSimLandingUrl = null;
        }
    })();

    // Wait for Feathers to be available
    if (typeof feathers === "undefined") {
        console.error(
            "[TuSim:Widget] Feathers client not loaded. Please include the Feathers script before this widget.",
        );
        return;
    }

    // Helper: Return travelDate string "YYYY-MM-DD" as activationDate (same day, no timezone conversion)
    function getActivationDate(travelDateStr) {
        if (!travelDateStr) return null;

        let str = String(travelDateStr).trim();
        const yearMatch = str.match(/^(\d{4,5})-(\d{2})-(\d{2})$/);
        if (!yearMatch) return null;

        const year = parseInt(yearMatch[1].slice(-4));
        const month = yearMatch[2];
        const day = yearMatch[3];

        if (year < 2024 || year > 2030) return null;

        return `${year}-${month}-${day}`;
    }

    function isValidDate(dateStr) {
        if (!dateStr) return false;
        const str = String(dateStr).trim();
        const match = str.match(/^(\d{4,5})-(\d{2})-(\d{2})$/);
        if (!match) return false;
        const year = parseInt(match[1]);
        if (year < 2024 || year > 2030) return false;
        const date = new Date(`${year}-${match[2]}-${match[3]}T00:00:00`);
        return !isNaN(date.getTime());
    }

    function getClaritySessionId() {
        try {
            if (typeof window.clarity === "function") {
                return window.clarity("get", "currentUserId") || null;
            }
        } catch (err) {
            error("[TuSim:Clarity] Error getting session id", err);
        }
        return null;
    }

    function getPartnerName() {
        if (window.isGlobal66) {
            return "Global 66";
        }

        const bodyClasses = document.body.className;

        if (
            bodyClasses.includes("assist-card") ||
            bodyClasses.includes("assistcard")
        ) {
            return "AssistCard";
        }

        if (bodyClasses.includes("viajes-exito")) {
            return "ViajesExito";
        }

        if (bodyClasses.includes("samsonite")) {
            return "Samsonite";
        }

        if (bodyClasses.includes("royal-scenic") || bodyClasses.includes("royalscenic")) {
            return "RoyalScenic";
        }

        const pathname = window.location.pathname;

        if (pathname.includes("assist-card")) {
            return "AssistCard";
        }

        if (pathname.includes("viajes-exito")) {
            return "ViajesExito";
        }

        if (pathname.includes("samsonite")) {
            return "Samsonite";
        }

        if (pathname.includes("royal-scenic") || pathname.includes("royalscenic")) {
            return "RoyalScenic";
        }

        const productTitle = document.querySelector(".product__title");
        if (productTitle) {
            const title = productTitle.textContent.toLowerCase();
            if (title.includes("assist") || title.includes("assistcard")) {
                return "AssistCard";
            }
            if (title.includes("viajes") && title.includes("exito")) {
                return "ViajesExito";
            }
            if (title.includes("samsonite")) {
                return "Samsonite";
            }
            if (title.includes("royal scenic") || title.includes("royalscenic")) {
                return "RoyalScenic";
            }
        }

        return null;
    }

    const TUSIM_CONFIG = {
        apiUrl: "https://qzutrwmuwa.us-east-1.awsapprunner.com",
        jwtToken:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpYXQiOjE3Njk2MjA1NTksImF1ZCI6Imh0dHBzOi8vbWFpbi5kM2d3cHZybWRjOWozbi5hbXBsaWZ5YXBwLmNvbSIsInN1YiI6IjM1MSIsImp0aSI6ImNlYTU5YTkyLTliMzgtNDQzMS05MmFkLWQ1Y2NkMzU5YWI4YyJ9.LkYBHKm-QRUiKjv8dqJqJd2NESfUR1yDC1YQ_JINc7c",
        organizationId: 6,
        organizationBranchId: 9,
        partnerName: getPartnerName(),
        shopifyStorefrontToken: null,
        stripePublishableKey:
            "pk_live_51QuD7wAnDVaimCP1DclQHX0VqLXpmtRKpoFTdk59KjIsuXg52gs7GJn17ssAKrUp6x2LKy7iqzq8tn1Rj07Gu9jC00enpWymcA",
    };

    const LANG = window.isAssistCardBR ? "br" : (window.isRoyalScenic ? "en" : "es");
    const T = {
        es: {
            addedToCart: "agregado al carrito",
            itemsInCart: "producto(s) en el carrito",
            viewCart: "Ver Carrito",
            yourCart: "Tu Carrito",
            cartEmpty: "Tu carrito está vacío",
            addProductsContinue: "Agrega productos para continuar",
            quantity: "Cantidad",
            remove: "Eliminar",
            discount2x1: "Descuento 2x1",
            shipping: "Envío",
            pending: "Pendiente",
            free: "Gratis",
            continueShopping: "Seguir Comprando",
            checkout: "Finalizar Compra",
            items: "artículo(s)",
            orderSummary: "Resumen de tu compra",
            physicalSim: "SIM Física",
            customerDetails: "Datos del cliente",
            firstName: "Nombre *",
            firstNamePlaceholder: "Ej: Juan",
            lastName: "Apellido *",
            lastNamePlaceholder: "Ej: Pérez",
            emailPlaceholder: "correo@ejemplo.com",
            phone: "Teléfono *",
            phonePlaceholder: "+57 300 123 4567",
            idLabel: "DNI / Identificación *",
            shippingAddressLabel: "Dirección de envío",
            country: "País *",
            selectCountry: "Selecciona un país...",
            address: "Dirección *",
            addressPlaceholder: "Calle, número, apartamento",
            city: "Ciudad *",
            cityPlaceholder: "Ciudad",
            department: "Departamento *",
            departmentPlaceholder: "Departamento",
            paymentInfo: "Información de pago *",
            paymentDesc: "Ingresa los datos de tu tarjeta de crédito o débito para completar el pago.",
            paymentMethod: "Método de pago *",
            selectPaymentMethod: "Selecciona un método de pago",
            creditCard: "Tarjeta de crédito/débito",
            efectyPayment: "Efecty - Pago en efectivo",
            pseBank: "Banco PSE *",
            loadingBanks: "Cargando bancos...",
            idType: "Tipo de identificación *",
            selectIdType: "Selecciona tipo de identificación",
            cc: "Cédula de Ciudadanía",
            ce: "Cédula de Extranjería",
            passport: "Pasaporte",
            discountCode: "¿Tienes un código de descuento?",
            discountPlaceholder: "Ej: ASSISTCARD10",
            apply: "Aplicar",
            pay: "Pagar",
            continuePayment: "Continuar con el pago",
            validating: "Validando...",
            processing: "Procesando...",
            selectShippingCountry: "Selecciona el país de envío",
            shippingSubtitle: "Necesitamos saber a dónde enviar tu SIM física",
            cancel: "Cancelar",
            confirm: "Confirmar",
            addNewCard: "Agregar Nueva Tarjeta",
            cardNumber: "Número de Tarjeta *",
            cardHolder: "Nombre del Titular *",
            cardHolderPlaceholder: "Como aparece en la tarjeta",
            month: "Mes *",
            year: "Año *",
            docType: "Tipo de Documento *",
            docSelect: "Seleccione",
            docNumber: "Número de Documento *",
            saveCard: "Guardar Tarjeta",
            validPhone: "Ingresa un número de teléfono válido",
            validPhoneAlt: "Número de teléfono inválido. Por favor, verifica el número.",
            enterCode: "Por favor ingresa un código",
            enterEmail: "Por favor ingresa tu email primero",
            noShipping: "No hay envío disponible para este país. Por favor selecciona otro país.",
            noShippingSelected: "No hay envío disponible para el país seleccionado. Por favor selecciona otro país.",
            notAvailable: "No disponible",
            cardDigits: "El número de tarjeta debe tener entre 13 y 19 dígitos",
            cardInvalid: "El número de tarjeta no es válido",
            monthRange: "El mes debe estar entre 01 y 12",
            cardExpired: "La tarjeta ha expirado",
            cvvLength: "El CVV debe tener 3 o 4 dígitos",
            cvvNumbers: "El CVV solo debe contener números",
            holderMinLength: "El nombre del titular debe tener al menos 3 caracteres",
            validEmail: "Por favor, ingresa un email válido",
            cardSaveError: "Error al guardar la tarjeta. Por favor, verifica los datos e intenta nuevamente.",
            cardSaveErrorAlt: "Error al guardar la tarjeta. Por favor, intenta nuevamente.",
            paymentInitError: "Error al inicializar el sistema de pago. Por favor, recarga la página.",
            cardInfoComplete: "Por favor, completa la información de la tarjeta para continuar",
            cardDataComplete: "Por favor, completa correctamente todos los datos de la tarjeta",
            processOrderError: "Error al procesar el pedido. Por favor, intenta nuevamente.",
            planNoPrice: "El plan no tiene precio configurado",
            processPaymentError: "Error al procesar el pago",
            processOrderErrorAlt: "Error al procesar la orden. Por favor, intenta nuevamente.",
            addCardError: "Por favor agrega una tarjeta de crédito/débito",
            selectBank: "Por favor selecciona un banco",
            selectIdTypeErr: "Por favor selecciona el tipo de identificación",
            validateDiscountError: "Error al validar el código de descuento",
            formCaptureError: "Error al capturar datos del formulario. Por favor, verifica que los selectores estén visibles en la página.",
            planConfigError: "No se encontró un plan configurado para este producto y no se pudo obtener el precio de Shopify. Por favor, configura el metafield custom.plan_id en la variante o contacta al administrador.",
            planDetailsError: "Error al obtener los detalles del plan. Por favor, intenta nuevamente.",
            addToCartError: "Error al agregar el plan al carrito. Por favor, intenta nuevamente.",
            cartEmptyError: "Tu carrito está vacío. Agrega productos de TuSim para continuar.",
            paymentApproved: "¡Pago aprobado!",
            orderProcessed: "Tu orden ha sido procesada exitosamente. Revisa tu correo para más detalles.",
            purchaseSuccess: "¡Compra exitosa!",
            productsProcessed: "producto(s) procesado(s). Revisa tu correo para más detalles.",
            paymentPending: "Tu pago está en proceso",
            paymentPendingMsg: "Te notificaremos por correo electrónico cuando se complete la transacción.",
            paymentError: "Error en el pago",
            orderSuccess: "¡Orden creada exitosamente!",
            orderProcessedMsg: "Tu orden ha sido procesada. Revisa tu correo para más detalles.",
            accept: "Aceptar",
            orderPrefix: "Orden #",
            subtotal: "Subtotal",
            dias: "días",
            invalidDate: "Fecha no válida. Selecciona una fecha del calendario.",
            yearRangeStart: "El año debe estar entre ",
            yearRangeEnd: " y ",
            genericError: "Ha ocurrido un error",
            fieldNotAllowed: "Campo no permitido: ",
            saving: "Guardando...",
            cardType: "Tipo: ",
            cardEnding: " terminada en ",
            cardSelected: "Tarjeta seleccionada",
            openCartLabel: "Abrir carrito de compras",
            total: "Total",
            errorLoadingBanks: "Error al cargar bancos",
            discountApplied: "Código aplicado correctamente",
            paymentStatus: "Estado del pago: ",
            statusLabel: "Estado: ",
            discountLabel: "Descuento",
            percentDiscount: "% de descuento)",
            applied: "Aplicado",
            shopifyProductFallback: "Producto de Shopify",
            addToCartBtn: "Agregar al carrito",
            discountCodeApplied: "Código ",
            discountCodeCorrectly: " aplicado correctamente",
        },
        en: {
            addedToCart: "added to your cart",
            itemsInCart: "item(s) in your cart",
            viewCart: "View Cart",
            yourCart: "Your Cart",
            cartEmpty: "Your cart is empty",
            addProductsContinue: "Add products to continue",
            quantity: "Quantity",
            remove: "Remove",
            discount2x1: "2x1 Discount",
            shipping: "Shipping",
            pending: "Pending",
            free: "Free",
            continueShopping: "Continue Shopping",
            checkout: "Checkout",
            items: "item(s)",
            orderSummary: "Order Summary",
            physicalSim: "Physical SIM",
            customerDetails: "Customer Details",
            firstName: "First Name *",
            firstNamePlaceholder: "Ex: John",
            lastName: "Last Name *",
            lastNamePlaceholder: "Ex: Doe",
            emailPlaceholder: "email@example.com",
            phone: "Phone *",
            phonePlaceholder: "+1 416 123 4567",
            idLabel: "ID / Passport *",
            shippingAddressLabel: "Shipping Address",
            country: "Country *",
            selectCountry: "Select a country...",
            address: "Address *",
            addressPlaceholder: "Street, number, apartment",
            city: "City *",
            cityPlaceholder: "City",
            department: "State / Province *",
            departmentPlaceholder: "State",
            paymentInfo: "Payment Information *",
            paymentDesc: "Enter your credit or debit card details to complete payment.",
            paymentMethod: "Payment Method *",
            selectPaymentMethod: "Select a payment method",
            creditCard: "Credit/Debit Card",
            efectyPayment: "Efecty - Cash Payment",
            pseBank: "PSE Bank *",
            loadingBanks: "Loading banks...",
            idType: "ID Type *",
            selectIdType: "Select ID Type",
            cc: "National ID (CC)",
            ce: "Foreigner ID (CE)",
            passport: "Passport",
            discountCode: "Do you have a discount code?",
            discountPlaceholder: "Ex: ROYALSCENIC10",
            apply: "Apply",
            pay: "Pay",
            continuePayment: "Continue to Payment",
            validating: "Validating...",
            processing: "Processing...",
            selectShippingCountry: "Select shipping country",
            shippingSubtitle: "We need to know where to send your physical SIM",
            cancel: "Cancel",
            confirm: "Confirm",
            addNewCard: "Add New Card",
            cardNumber: "Card Number *",
            cardHolder: "Cardholder Name *",
            cardHolderPlaceholder: "As it appears on the card",
            month: "Month *",
            year: "Year *",
            docType: "Document Type *",
            docSelect: "Select",
            docNumber: "Document Number *",
            saveCard: "Save Card",
            validPhone: "Enter a valid phone number",
            validPhoneAlt: "Please enter a valid phone number",
            enterCode: "Please enter a code",
            enterEmail: "Please enter your email first",
            noShipping: "Shipping is not available for this country. Please select another country.",
            noShippingSelected: "Shipping is not available for the selected country. Please select another country.",
            notAvailable: "Not available",
            cardDigits: "Card number must be between 13 and 19 digits",
            cardInvalid: "Card number is not valid",
            monthRange: "Month must be between 01 and 12",
            cardExpired: "Card has expired",
            cvvLength: "CVV must be 3 or 4 digits",
            cvvNumbers: "CVV must only contain numbers",
            holderMinLength: "Cardholder name must be at least 3 characters",
            validEmail: "Please enter a valid email",
            cardSaveError: "Error saving card. Please verify the data and try again.",
            cardSaveErrorAlt: "Error saving card. Please try again.",
            paymentInitError: "Error initializing payment system. Please reload the page.",
            cardInfoComplete: "Please complete the card information to continue",
            cardDataComplete: "Please complete all card details correctly",
            processOrderError: "Error processing order. Please try again.",
            planNoPrice: "Plan has no configured price",
            processPaymentError: "Error processing payment",
            processOrderErrorAlt: "Error processing order. Please try again.",
            addCardError: "Please add a credit/debit card",
            selectBank: "Please select a bank",
            selectIdTypeErr: "Please select the ID type",
            validateDiscountError: "Error validating discount code",
            formCaptureError: "Error capturing form data. Please verify that the selectors are visible on the page.",
            planConfigError: "No configured plan found for this product and the Shopify price could not be obtained. Please configure the custom.plan_id metafield in the variant or contact the administrator.",
            planDetailsError: "Error getting plan details. Please try again.",
            addToCartError: "Error adding plan to cart. Please try again.",
            cartEmptyError: "Your cart is empty. Add TuSim products to continue.",
            paymentApproved: "Payment approved!",
            orderProcessed: "Your order has been processed successfully. Check your email for more details.",
            purchaseSuccess: "Purchase successful!",
            productsProcessed: "product(s) processed. Check your email for more details.",
            paymentPending: "Your payment is being processed",
            paymentPendingMsg: "We will notify you by email when the transaction is complete.",
            paymentError: "Payment error",
            orderSuccess: "Order created successfully!",
            orderProcessedMsg: "Your order has been processed. Check your email for more details.",
            accept: "Accept",
            orderPrefix: "Order #",
            subtotal: "Subtotal",
            dias: "days",
            invalidDate: "Invalid date. Please select a date from the calendar.",
            yearRangeStart: "Year must be between ",
            yearRangeEnd: " and ",
            genericError: "An error occurred",
            fieldNotAllowed: "Field not allowed: ",
            saving: "Saving...",
            cardType: "Type: ",
            cardEnding: " ending in ",
            cardSelected: "Card selected",
            openCartLabel: "Open shopping cart",
            total: "Total",
            errorLoadingBanks: "Error loading banks",
            discountApplied: "Discount applied successfully",
            paymentStatus: "Payment status: ",
            statusLabel: "Status: ",
            discountLabel: "Discount",
            percentDiscount: "% discount)",
            applied: "Applied",
            shopifyProductFallback: "Shopify Product",
            addToCartBtn: "Add to cart",
            discountCodeApplied: "Code ",
            discountCodeCorrectly: " applied successfully",
        },
        br: {
            addedToCart: "adicionado ao carrinho",
            itemsInCart: "item(ns) no seu carrinho",
            viewCart: "Ver Carrinho",
            yourCart: "Seu Carrinho",
            cartEmpty: "Seu carrinho está vazio",
            addProductsContinue: "Adicione produtos para continuar",
            quantity: "Quantidade",
            remove: "Remover",
            discount2x1: "Desconto 2x1",
            shipping: "Frete",
            pending: "Pendente",
            free: "Grátis",
            continueShopping: "Continuar Comprando",
            checkout: "Finalizar Compra",
            items: "item(ns)",
            orderSummary: "Resumo do seu pedido",
            physicalSim: "SIM Física",
            customerDetails: "Dados do cliente",
            firstName: "Nome *",
            firstNamePlaceholder: "Ex: João",
            lastName: "Sobrenome *",
            lastNamePlaceholder: "Ex: Silva",
            emailPlaceholder: "email@exemplo.com",
            phone: "Telefone *",
            phonePlaceholder: "+55 11 91234 5678",
            idLabel: "CPF / Documento *",
            shippingAddressLabel: "Endereço de entrega",
            country: "País *",
            selectCountry: "Selecione um país...",
            address: "Endereço *",
            addressPlaceholder: "Rua, número, apartamento",
            city: "Cidade *",
            cityPlaceholder: "Cidade",
            department: "Estado *",
            departmentPlaceholder: "Estado",
            paymentInfo: "Informações de pagamento *",
            paymentDesc: "Insira os dados do seu cartão de crédito ou débito para concluir o pagamento.",
            paymentMethod: "Método de pagamento *",
            selectPaymentMethod: "Selecione um método de pagamento",
            creditCard: "Cartão de crédito/débito",
            efectyPayment: "Efecty - Pagamento em dinheiro",
            pseBank: "Banco PSE *",
            loadingBanks: "Carregando bancos...",
            idType: "Tipo de documento *",
            selectIdType: "Selecione o tipo de documento",
            cc: "CPF",
            ce: "RNE",
            passport: "Passaporte",
            discountCode: "Você tem um código de desconto?",
            discountPlaceholder: "Ex: ASSISTCARD10",
            apply: "Redimir",
            pay: "Pagar",
            continuePayment: "Continuar com o pagamento",
            validating: "Validando...",
            processing: "Processando...",
            selectShippingCountry: "Selecione o país de entrega",
            shippingSubtitle: "Precisamos saber para onde enviar sua SIM física",
            cancel: "Cancelar",
            confirm: "Confirmar",
            addNewCard: "Adicionar Novo Cartão",
            cardNumber: "Número do Cartão *",
            cardHolder: "Nome no Cartão *",
            cardHolderPlaceholder: "Como aparece no cartão",
            month: "Mês *",
            year: "Ano *",
            docType: "Tipo de Documento *",
            docSelect: "Selecione",
            docNumber: "Número do Documento *",
            saveCard: "Salvar Cartão",
            validPhone: "Insira um número de telefone válido",
            validPhoneAlt: "Número de telefone inválido. Por favor, verifique o número.",
            enterCode: "Por favor, insira um código",
            enterEmail: "Por favor, insira seu email primeiro",
            noShipping: "Frete não disponível para este país. Por favor, selecione outro país.",
            noShippingSelected: "Frete não disponível para o país selecionado. Por favor, selecione outro país.",
            notAvailable: "Não disponível",
            cardDigits: "O número do cartão deve ter entre 13 e 19 dígitos",
            cardInvalid: "O número do cartão não é válido",
            monthRange: "O mês deve estar entre 01 e 12",
            cardExpired: "O cartão expirou",
            cvvLength: "O CVV deve ter 3 ou 4 dígitos",
            cvvNumbers: "O CVV deve conter apenas números",
            holderMinLength: "O nome no cartão deve ter pelo menos 3 caracteres",
            validEmail: "Por favor, insira um email válido",
            cardSaveError: "Erro ao salvar o cartão. Por favor, verifique os dados e tente novamente.",
            cardSaveErrorAlt: "Erro ao salvar o cartão. Por favor, tente novamente.",
            paymentInitError: "Erro ao inicializar o sistema de pagamento. Por favor, recarregue a página.",
            cardInfoComplete: "Por favor, preencha as informações do cartão para continuar",
            cardDataComplete: "Por favor, preencha corretamente todos os dados do cartão",
            processOrderError: "Erro ao processar o pedido. Por favor, tente novamente.",
            planNoPrice: "O plano não tem preço configurado",
            processPaymentError: "Erro ao processar o pagamento",
            processOrderErrorAlt: "Erro ao processar o pedido. Por favor, tente novamente.",
            addCardError: "Por favor, adicione um cartão de crédito/débito",
            selectBank: "Por favor, selecione um banco",
            selectIdTypeErr: "Por favor, selecione o tipo de documento",
            validateDiscountError: "Erro ao validar o código de desconto",
            formCaptureError: "Erro ao capturar dados do formulário. Por favor, verifique se os seletores estão visíveis na página.",
            planConfigError: "Nenhum plano configurado encontrado para este produto e não foi possível obter o preço do Shopify. Por favor, configure o metafield custom.plan_id na variante ou entre em contato com o administrador.",
            planDetailsError: "Erro ao obter os detalhes do plano. Por favor, tente novamente.",
            addToCartError: "Erro ao adicionar o plano ao carrinho. Por favor, tente novamente.",
            cartEmptyError: "Seu carrinho está vazio. Adicione produtos TuSim para continuar.",
            paymentApproved: "Pagamento aprovado!",
            orderProcessed: "Seu pedido foi processado com sucesso. Verifique seu email para mais detalhes.",
            purchaseSuccess: "Compra realizada com sucesso!",
            productsProcessed: "produto(ns) processado(s). Verifique seu email para mais detalhes.",
            paymentPending: "Seu pagamento está em processamento",
            paymentPendingMsg: "Notificaremos por email quando a transação for concluída.",
            paymentError: "Erro no pagamento",
            orderSuccess: "Pedido criado com sucesso!",
            orderProcessedMsg: "Seu pedido foi processado. Verifique seu email para mais detalhes.",
            accept: "Aceitar",
            orderPrefix: "Pedido #",
            subtotal: "Subtotal",
            dias: "dias",
            invalidDate: "Data inválida. Selecione uma data no calendário.",
            yearRangeStart: "O ano deve estar entre ",
            yearRangeEnd: " e ",
            genericError: "Ocorreu um erro",
            fieldNotAllowed: "Campo não permitido: ",
            saving: "Salvando...",
            cardType: "Tipo: ",
            cardEnding: " terminada em ",
            cardSelected: "Cartão selecionado",
            openCartLabel: "Abrir carrinho de compras",
            total: "Total",
            errorLoadingBanks: "Erro ao carregar bancos",
            discountApplied: "Cupom aplicado com sucesso",
            paymentStatus: "Status do pagamento: ",
            statusLabel: "Status: ",
            discountLabel: "Desconto",
            percentDiscount: "% de desconto)",
            applied: "Aplicado",
            shopifyProductFallback: "Produto Shopify",
            addToCartBtn: "Adicionar ao carrinho",
            discountCodeApplied: "Cupom ",
            discountCodeCorrectly: " aplicado com sucesso",
        },
    };

    // Initialize Feathers client
    const app = feathers();
    const restClient = feathers.rest(TUSIM_CONFIG.apiUrl);
    app.configure(restClient.fetch(window.fetch.bind(window)));

    // Configure authentication
    app.hooks({
        before: {
            all: [
                (context) => {
                    context.params.headers = {
                        ...context.params.headers,
                        Authorization: `Bearer ${TUSIM_CONFIG.jwtToken}`,
                    };
                    return context;
                },
            ],
        },
    });

    function log(message, data) {
        console.log(`[TuSim:Widget] ${message}`, data || "");
    }

    function error(message, err) {
        console.error(`[TuSim:Widget] ${message}`, err || "");
    }

    // Country code to name mapping
    const COUNTRY_CODE_MAP = {
        "CO": "Colombia",
        "US": "Estados Unidos",
        "MX": "México",
        "AR": "Argentina",
        "CL": "Chile",
        "PE": "Perú",
        "BR": "Brasil",
        "ES": "España",
        "GB": "Reino Unido",
        "CA": "Canadá",
        "FR": "Francia",
        "DE": "Alemania",
        "IT": "Italia",
        "JP": "Japón",
        "KR": "Corea del Sur",
        "AU": "Australia",
        "CN": "China",
        "IN": "India",
        "VE": "Venezuela",
        "EC": "Ecuador",
        "PA": "Panamá",
        "CR": "Costa Rica",
        "GT": "Guatemala",
        "DO": "República Dominicana",
        "UY": "Uruguay",
        "PY": "Paraguay",
        "BO": "Bolivia",
        "SV": "El Salvador",
        "HN": "Honduras",
        "NI": "Nicaragua",
        "PT": "Portugal",
        "NL": "Países Bajos",
        "BE": "Bélgica",
        "CH": "Suiza",
        "AT": "Austria",
        "SE": "Suecia",
        "NO": "Noruega",
        "DK": "Dinamarca",
        "FI": "Finlandia",
        "PL": "Polonia",
        "CZ": "República Checa",
        "GR": "Grecia",
        "IE": "Irlanda",
        "NZ": "Nueva Zelanda",
        "TH": "Tailandia",
        "SG": "Singapur",
        "MY": "Malasia",
        "PH": "Filipinas",
        "ID": "Indonesia",
        "VN": "Vietnam",
        "AE": "Emiratos Árabes Unidos",
        "SA": "Arabia Saudí",
        "IL": "Israel",
        "TR": "Turquía",
        "EG": "Egipto",
        "ZA": "Sudáfrica",
    };

    function getCountryFromCode(code) {
        return COUNTRY_CODE_MAP[code?.toUpperCase()] || null;
    }

    async function getUserCountryByIP() {
        try {
            log("[TuSim:GeoIP] Fetching user country by IP...");
            const response = await fetch("https://ipapi.co/json/");

            if (!response.ok) {
                throw new Error("IP API request failed");
            }

            const data = await response.json();
            const countryCode = data.country_code?.toUpperCase();

            log("[TuSim:GeoIP] User country detected", {
                countryCode,
                countryName: getCountryFromCode(countryCode),
                ip: data.ip
            });

            return countryCode || "CO";
        } catch (err) {
            error("[TuSim:GeoIP] Error detecting country by IP", err);
            return "CO";
        }
    }

    function getPhonePrefixForCountry(countryCode) {
        const prefixMap = {
            "CO": "+57",
            "US": "+1",
            "MX": "+52",
            "AR": "+54",
            "CL": "+56",
            "PE": "+51",
            "BR": "+55",
            "ES": "+34",
            "GB": "+44",
            "CA": "+1",
            "FR": "+33",
            "DE": "+49",
            "IT": "+39",
            "JP": "+81",
            "KR": "+82",
            "AU": "+61",
            "CN": "+86",
            "IN": "+91",
            "VE": "+58",
            "EC": "+593",
            "PA": "+507",
            "CR": "+506",
            "GT": "+502",
            "DO": "+1",
            "UY": "+598",
            "PY": "+595",
            "BO": "+591",
            "SV": "+503",
            "HN": "+504",
            "NI": "+505",
            "PT": "+351",
            "NL": "+31",
            "BE": "+32",
            "CH": "+41",
            "AT": "+43",
            "SE": "+46",
            "NO": "+47",
            "DK": "+45",
            "FI": "+358",
            "PL": "+48",
            "CZ": "+420",
            "GR": "+30",
            "IE": "+353",
            "NZ": "+64",
            "TH": "+66",
            "SG": "+65",
            "MY": "+60",
            "PH": "+63",
            "ID": "+62",
            "VN": "+84",
            "AE": "+971",
            "SA": "+966",
            "IL": "+972",
            "TR": "+90",
            "EG": "+20",
            "ZA": "+27",
        };

        return prefixMap[countryCode] || "+57";
    }

    async function loadStripe() {
        if (stripeInstance) {
            return stripeInstance;
        }

        try {
            if (!TUSIM_CONFIG.stripePublishableKey) {
                throw new Error(
                    "Stripe publishable key is not configured. Please set TUSIM_CONFIG.stripePublishableKey.",
                );
            }

            if (typeof Stripe === "undefined") {
                log("[TuSim:Stripe] Loading Stripe.js script");
                await new Promise((resolve, reject) => {
                    const script = document.createElement("script");
                    script.src = "https://js.stripe.com/v3/";
                    script.onload = () => {
                        log("[TuSim:Stripe] Stripe.js script loaded");
                        resolve();
                    };
                    script.onerror = (err) => {
                        error("[TuSim:Stripe] Failed to load Stripe.js script", err);
                        reject(new Error("Failed to load Stripe.js library"));
                    };
                    document.head.appendChild(script);
                });
            }

            if (!TUSIM_CONFIG.stripePublishableKey) {
                throw new Error("Stripe publishable key is not configured");
            }

            stripeInstance = Stripe(TUSIM_CONFIG.stripePublishableKey);
            log("[TuSim:Stripe] Stripe instance created successfully");
            return stripeInstance;
        } catch (err) {
            error("[TuSim:Stripe] Error loading Stripe", err);
            throw err;
        }
    }

    async function initializeStripeElements() {
        try {
            const stripe = await loadStripe();

            if (!stripeElements) {
                stripeElements = stripe.elements();
                log("[TuSim:Stripe] Stripe Elements initialized");
            }

            return { stripe, elements: stripeElements };
        } catch (err) {
            error("[TuSim:Stripe] Error initializing Stripe Elements", err);
            throw err;
        }
    }

    // Cart Management Functions
    const CART_STORAGE_KEY = "tusim_cart";

    function is2x1PromotionEnabled() {
        const isLanding = !!TUSIM_CONFIG.partnerName;
        return window.TuSimThemeSettings && window.TuSimThemeSettings.enable2x1Promotion === true && !isLanding && !window.isRoyalScenic;
    }

    function calculate2x1Discount(items) {
        if (!is2x1PromotionEnabled()) {
            return 0;
        }

        const productGroups = {};

        items.forEach(item => {
            if (item.type === "shipping" || !item.price) return;

            const groupKey = item.plan_id
                ? `plan_${item.plan_id}`
                : item.shopifyData?.variantId
                    ? `variant_${item.shopifyData.variantId}`
                    : `product_${item.id}`;

            if (!productGroups[groupKey]) {
                productGroups[groupKey] = {
                    items: [],
                    price: item.price
                };
            }
            productGroups[groupKey].items.push(item);
        });

        let totalDiscount = 0;

        Object.values(productGroups).forEach(group => {
            const totalQuantity = group.items.reduce((sum, item) => sum + (item.quantity || 1), 0);

            if (totalQuantity >= 2) {
                const freeItems = Math.floor(totalQuantity / 2);
                const paidItems = totalQuantity - freeItems;
                totalDiscount += group.price * freeItems;
                log("[TuSim:2x1] Applied discount", {
                    groupKey: group.items[0]?.id,
                    totalQuantity,
                    paidItems,
                    freeItems,
                    discount: group.price * freeItems
                });
            }
        });

        return totalDiscount;
    }

    function isNPromotionEnabled() {
        const isLanding = !!TUSIM_CONFIG.partnerName;
        return window.TuSimThemeSettings && window.TuSimThemeSettings.enableNPromotion === true && !isLanding && !window.isRoyalScenic;
    }

    function getNPromotionPercentage() {
        return (window.TuSimThemeSettings && window.TuSimThemeSettings.discountNPercentage) || 15;
    }

    function calculateNDiscount(baseTotal, discount2x1) {
        if (!isNPromotionEnabled()) {
            return 0;
        }
        const percentage = getNPromotionPercentage();
        const after2x1 = Math.max(0, baseTotal - discount2x1);
        const discount = after2x1 * (percentage / 100);
        log("[TuSim:PromoN] Applied discount", { percentage, baseTotal, discount2x1, after2x1, discount });
        return discount;
    }

    function applyNDiscountToItems(items) {
        if (!isNPromotionEnabled()) return items;
        const percentage = getNPromotionPercentage();
        const discountFactor = (100 - percentage) / 100;
        items.forEach(item => {
            if (item.plan && item.plan.price) {
                item.plan.price = item.plan.price * discountFactor;
                if (item.plan.price_cop) {
                    item.plan.price_cop = item.plan.price_cop * discountFactor;
                }
            }
        });
        return items;
    }

    function apply2x1DiscountToItems(items) {
        if (!is2x1PromotionEnabled()) {
            return items;
        }

        // Deep copy items to avoid mutating the original cart
        const discountedItems = JSON.parse(JSON.stringify(items));
        const productGroups = {};

        discountedItems.forEach(item => {
            if (item.type === "shipping" || !item.plan || !item.plan.price) return;

            const groupKey = item.plan_id
                ? `plan_${item.plan_id}`
                : item.shopifyData?.variantId
                    ? `variant_${item.shopifyData.variantId}`
                    : `product_${item.id}`;

            if (!productGroups[groupKey]) {
                productGroups[groupKey] = {
                    items: [],
                    price: item.plan.price
                };
            }
            productGroups[groupKey].items.push(item);
        });

        Object.values(productGroups).forEach(group => {
            const totalQuantity = group.items.reduce((sum, item) => sum + (item.quantity || 1), 0);

            if (totalQuantity >= 2) {
                const freeItems = Math.floor(totalQuantity / 2); // 2x1 gives 1 free for every 2 items
                const discountRatio = (totalQuantity - freeItems) / totalQuantity;

                group.items.forEach(item => {
                    item.plan.price = item.plan.price * discountRatio;
                    if (item.plan.price_cop) {
                        item.plan.price_cop = item.plan.price_cop * discountRatio;
                    }
                });
            }
        });

        return discountedItems;
    }

    function getCart() {
        try {
            const cartStr = localStorage.getItem(CART_STORAGE_KEY);
            const cart = cartStr ? JSON.parse(cartStr) : { items: [], total: 0, baseTotal: 0, discount: 0 };
            if (!window.isRoyalScenic) {
                window.isRoyalScenic = cart.items.some(
                    item =>
                        (item.shopifyProduct && item.shopifyProduct.title && item.shopifyProduct.title.toLowerCase().includes('royal scenic')) ||
                        (item.plan && item.plan.name && item.plan.name.toLowerCase().includes('royal scenic'))
                );
            }

            const baseTotal = cart.items.reduce(
                (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                0,
            );
            const discount = calculate2x1Discount(cart.items);
            const discountN = calculateNDiscount(baseTotal, discount);
            cart.total = Math.max(0, baseTotal - discount - discountN);
            cart.baseTotal = baseTotal;
            cart.discount = discount;
            cart.discountN = discountN;

            return cart;
        } catch (err) {
            error("[TuSim:Cart] Error reading cart from localStorage", err);
            return { items: [], total: 0, baseTotal: 0, discount: 0, discountN: 0 };
        }
    }

    async function addToCart(item) {
        try {
            const cart = getCart();
            const cartItem = {
                ...item,
                id: Date.now() + Math.random(), // Ensure unique ID
            };
            cart.items.push(cartItem);

            const isPhysicalSim =
                cartItem.shopifyData && cartItem.shopifyData.simType === "physical";

            if (isPhysicalSim && !hasShippingInCart(cart)) {
                log(
                    "[TuSim:Shipping] Physical SIM detected, adding free shipping placeholder",
                );
                const shippingItem = {
                    id: Date.now() + Math.random(),
                    type: "shipping",
                    country_code: null,
                    country_name: null,
                    custom_name: "Envío",
                    price: 0,
                    quantity: 1,
                    pending: true,
                };
                cart.items.push(shippingItem);
                log("[TuSim:Shipping] Free shipping placeholder added to cart");
            }

            const baseTotal = cart.items.reduce(
                (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                0,
            );
            const discount = calculate2x1Discount(cart.items);
            const discountN = calculateNDiscount(baseTotal, discount);
            cart.total = Math.max(0, baseTotal - discount - discountN);
            cart.baseTotal = baseTotal;
            cart.discount = discount;
            cart.discountN = discountN;
            localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
            log("[TuSim:Cart] Item added to cart", {
                itemId: cartItem.id,
                itemsCount: cart.items.length,
            });
            return cart;
        } catch (err) {
            error("[TuSim:Cart] Error adding item to cart", err);
            return getCart();
        }
    }

    function removeFromCart(itemId) {
        try {
            const cart = getCart();
            const initialCount = cart.items.length;
            cart.items = cart.items.filter((item) => item.id !== itemId);

            if (!hasPhysicalSimInCart(cart)) {
                const shippingItem = getShippingItem(cart);
                if (shippingItem) {
                    cart.items = cart.items.filter((item) => item.id !== shippingItem.id);
                    log("[TuSim:Shipping] Shipping removed - no physical SIMs in cart");
                }
            }

            const baseTotal = cart.items.reduce(
                (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                0,
            );
            const discount = calculate2x1Discount(cart.items);
            const discountN = calculateNDiscount(baseTotal, discount);
            cart.total = Math.max(0, baseTotal - discount - discountN);
            cart.baseTotal = baseTotal;
            cart.discount = discount;
            cart.discountN = discountN;
            localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
            log("[TuSim:Cart] Item removed from cart", {
                itemId,
                removedCount: initialCount - cart.items.length,
            });
            return cart;
        } catch (err) {
            error("[TuSim:Cart] Error removing item from cart", err);
            return getCart();
        }
    }

    function clearCart() {
        try {
            localStorage.removeItem(CART_STORAGE_KEY);
            log("[TuSim:Cart] Cart cleared");
        } catch (err) {
            error("[TuSim:Cart] Error clearing cart", err);
        }
    }

    async function getShippingRate(countryCode) {
        try {
            log("[TuSim:Shipping] Fetching shipping rate", { countryCode });
            const result = await app.service("shipping-rates").find({
                query: {
                    country_code: countryCode,
                    is_active: true,
                    $limit: 1,
                },
            });

            if (result.data && result.data.length > 0) {
                const shippingRate = result.data[0];
                log("[TuSim:Shipping] Shipping rate found", {
                    countryCode,
                    price: shippingRate.price,
                    customName: shippingRate.custom_name,
                });
                return {
                    price: parseFloat(shippingRate.price) || 0,
                    custom_name: shippingRate.custom_name || shippingRate.country_name,
                    country_code: shippingRate.country_code,
                    country_name: shippingRate.country_name,
                };
            }

            log("[TuSim:Shipping] No shipping rate found for country", {
                countryCode,
            });
            return null;
        } catch (err) {
            error("[TuSim:Shipping] Error fetching shipping rate", err);
            return null;
        }
    }

    async function captureShippingCountry() {
        return new Promise((resolve) => {
            const existingModal = document.getElementById(
                "tusim-shipping-country-modal",
            );
            if (existingModal) existingModal.remove();

            const overlay = document.createElement("div");
            overlay.id = "tusim-shipping-country-modal";
            overlay.innerHTML = `
        <div class="tusim-shipping-country-container">
          <div class="tusim-shipping-country-header">
            <h3>${T[LANG].selectShippingCountry}</h3>
            <p class="tusim-shipping-country-subtitle">${T[LANG].shippingSubtitle}</p>
          </div>
          <div class="tusim-shipping-country-content">
            <select id="tusim-country-select" class="tusim-country-select">
              <option value="">Selecciona un país...</option>
              <option value="US">Estados Unidos</option>
              <option value="MX">México</option>
              <option value="CO">Colombia</option>
              <option value="CA">Canadá</option>
              <option value="ES">España</option>
              <option value="FR">Francia</option>
              <option value="IT">Italia</option>
              <option value="DE">Alemania</option>
              <option value="GB">Reino Unido</option>
              <option value="BR">Brasil</option>
              <option value="AR">Argentina</option>
              <option value="CL">Chile</option>
              <option value="PE">Perú</option>
              <option value="DO">República Dominicana</option>
              <option value="EC">Ecuador</option>
              <option value="PA">Panamá</option>
              <option value="CR">Costa Rica</option>
              <option value="GT">Guatemala</option>
              <option value="HN">Honduras</option>
              <option value="NI">Nicaragua</option>
              <option value="SV">El Salvador</option>
              <option value="UY">Uruguay</option>
              <option value="PY">Paraguay</option>
              <option value="BO">Bolivia</option>
              <option value="VE">Venezuela</option>
              <option value="PT">Portugal</option>
              <option value="NL">Países Bajos</option>
              <option value="BE">Bélgica</option>
              <option value="CH">Suiza</option>
              <option value="AT">Austria</option>
              <option value="SE">Suecia</option>
              <option value="NO">Noruega</option>
              <option value="DK">Dinamarca</option>
              <option value="FI">Finlandia</option>
              <option value="PL">Polonia</option>
              <option value="CZ">República Checa</option>
              <option value="GR">Grecia</option>
              <option value="IE">Irlanda</option>
              <option value="AU">Australia</option>
              <option value="NZ">Nueva Zelanda</option>
              <option value="JP">Japón</option>
              <option value="KR">Corea del Sur</option>
              <option value="CN">China</option>
              <option value="IN">India</option>
              <option value="TH">Tailandia</option>
              <option value="SG">Singapur</option>
              <option value="MY">Malasia</option>
              <option value="PH">Filipinas</option>
              <option value="ID">Indonesia</option>
              <option value="VN">Vietnam</option>
              <option value="AE">Emiratos Árabes Unidos</option>
              <option value="SA">Arabia Saudí</option>
              <option value="IL">Israel</option>
              <option value="TR">Turquía</option>
              <option value="EG">Egipto</option>
              <option value="ZA">Sudáfrica</option>
            </select>
          </div>
          <div class="tusim-shipping-country-footer">
            <button id="tusim-country-cancel" class="tusim-country-btn tusim-country-btn-cancel">${T[LANG].cancel}</button>
            <button id="tusim-country-confirm" class="tusim-country-btn tusim-country-btn-confirm" disabled>${T[LANG].confirm}</button>
          </div>
        </div>
        <style>
          #tusim-shipping-country-modal {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            background: rgba(0, 0, 0, 0.5) !important;
            backdrop-filter: blur(4px) !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            z-index: 999999 !important;
            padding: 20px !important;
          }
          .tusim-shipping-country-container {
            background: white !important;
            border-radius: 12px !important;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
            max-width: 500px !important;
            width: 100% !important;
            padding: 24px !important;
          }
          .tusim-shipping-country-header h3 {
            margin: 0 0 8px 0 !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            color: #0a2540 !important;
          }
          .tusim-shipping-country-subtitle {
            margin: 0 0 20px 0 !important;
            font-size: 14px !important;
            color: #697386 !important;
          }
          .tusim-country-select {
            width: 100% !important;
            padding: 12px 16px !important;
            border: 1px solid #e3e8ef !important;
            border-radius: 8px !important;
            font-size: 15px !important;
            color: #0a2540 !important;
            background: white !important;
            cursor: pointer !important;
          }
          .tusim-country-select:focus {
            outline: none !important;
            border-color: #00d4aa !important;
            box-shadow: 0 0 0 3px rgba(0, 212, 170, 0.1) !important;
          }
          .tusim-shipping-country-footer {
            display: flex !important;
            gap: 12px !important;
            margin-top: 24px !important;
            justify-content: flex-end !important;
          }
          .tusim-country-btn {
            padding: 10px 20px !important;
            border-radius: 8px !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            cursor: pointer !important;
            border: none !important;
            transition: all 0.2s !important;
          }
          .tusim-country-btn-cancel {
            background: #f7f9fc !important;
            color: #697386 !important;
          }
          .tusim-country-btn-cancel:hover {
            background: #edf1f7 !important;
          }
          .tusim-country-btn-confirm {
            background: #00d4aa !important;
            color: white !important;
          }
          .tusim-country-btn-confirm:hover:not(:disabled) {
            background: #00c389 !important;
          }
          .tusim-country-btn-confirm:disabled {
            background: #e3e8ef !important;
            color: #a8b2c1 !important;
            cursor: not-allowed !important;
          }
        </style>
      `;

            document.body.appendChild(overlay);

            const select = document.getElementById("tusim-country-select");
            const confirmBtn = document.getElementById("tusim-country-confirm");
            const cancelBtn = document.getElementById("tusim-country-cancel");

            select.addEventListener("change", () => {
                confirmBtn.disabled = !select.value;
            });

            confirmBtn.addEventListener("click", () => {
                if (select.value) {
                    overlay.remove();
                    resolve(select.value);
                }
            });

            cancelBtn.addEventListener("click", () => {
                overlay.remove();
                resolve(null);
            });

            overlay.addEventListener("click", (e) => {
                if (e.target === overlay) {
                    overlay.remove();
                    resolve(null);
                }
            });
        });
    }

    function hasPhysicalSimInCart(cart) {
        return cart.items.some(
            (item) => item.shopifyData && item.shopifyData.simType === "physical",
        );
    }

    function hasShippingInCart(cart) {
        return cart.items.some((item) => item.type === "shipping");
    }

    function getShippingItem(cart) {
        return cart.items.find((item) => item.type === "shipping");
    }

    function getPlanIdsFromDOM() {
        const planIds = {
            5: null,
            7: null,
            10: null,
            15: null,
            20: null,
            30: null,
        };

        const durations = [5, 7, 10, 15, 20, 30];
        durations.forEach((dur) => {
            const planElement =
                document.querySelector(`[data-tusim-plan-id-${dur}]`) ||
                document.querySelector(`[data-plan-id-${dur}]`);
            if (planElement) {
                planIds[dur] =
                    parseInt(planElement.getAttribute(`data-tusim-plan-id-${dur}`)) ||
                    parseInt(planElement.getAttribute(`data-plan-id-${dur}`));
            }
        });

        return planIds;
    }

    function getPlanIdsFromGlobal() {
        if (window.TuSimConfig && window.TuSimConfig.planIds) {
            return window.TuSimConfig.planIds;
        }
        return null;
    }

    function normalizeText(text) {
        return text
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim();
    }

    function extractBaseProductName(productName) {
        const normalized = normalizeText(productName);

        const commonWordsToRemove = [
            /\d+\s*d[ií]as?/gi,
            /\d+\s*days?/gi,
            /\d+d/gi,
            /ilimitados?/gi,
            /unlimited/gi,
            /4glte/gi,
            /4g\s*lte/gi,
            /lte/gi,
            /esim/gi,
            /e-sim/gi,
            /f[ií]sica/gi,
            /physical/gi,
            /simcard/gi,
            /sim\s*card/gi,
            /planes?\s*por/gi,
            /plan/gi,
        ];

        let baseName = normalized;
        for (const pattern of commonWordsToRemove) {
            baseName = baseName.replace(pattern, "");
        }

        baseName = baseName.replace(/\s+/g, " ").trim();

        log("[TuSim:Plan] Extracted base product name", {
            original: productName,
            baseName,
        });

        return baseName;
    }

    function extractCountryName(productName) {
        const normalized = normalizeText(productName);

        const countryPatterns = [
            { pattern: /ee\.?\s*uu\.?|eeuu|estados\s*unidos/i, name: "EE.UU" },
            { pattern: /mexico|m[eé]xico/i, name: "Mexico" },
            { pattern: /colombia/i, name: "Colombia" },
            { pattern: /canada|canad[aá]/i, name: "Canada" },
            { pattern: /europa/i, name: "Europa" },
            { pattern: /espana|españa/i, name: "España" },
            { pattern: /francia/i, name: "Francia" },
            { pattern: /italia/i, name: "Italia" },
            { pattern: /alemania/i, name: "Alemania" },
            { pattern: /reino\s*unido|uk|inglaterra/i, name: "Reino Unido" },
            { pattern: /brasil|brazil/i, name: "Brasil" },
            { pattern: /argentina/i, name: "Argentina" },
            { pattern: /chile/i, name: "Chile" },
            { pattern: /peru|per[uú]/i, name: "Peru" },
            {
                pattern: /rep[uú]blica\s*dominicana|rep\.?\s*dominicana|dominicana/i,
                name: "Rep. Dominicana",
            },
        ];

        for (const { pattern, name } of countryPatterns) {
            if (pattern.test(productName) || pattern.test(normalized)) {
                return name;
            }
        }

        const words = normalized.split(/\s+/).filter((word) => {
            const stopWords = [
                "planes",
                "plan",
                "por",
                "dias",
                "days",
                "ilimitado",
                "unlimited",
                "esim",
                "fisica",
                "physical",
            ];
            return word.length > 2 && !stopWords.includes(word);
        });

        return words[0] || null;
    }

    function generateCountrySearchVariations(countryName) {
        if (!countryName) return [];

        const variations = [countryName];
        const normalized = normalizeText(countryName);

        const countryAliases = {
            "ee.uu": ["eeuu", "estados unidos", "usa", "united states"],
            mexico: ["méxico"],
            canada: ["canadá"],
            espana: ["españa"],
            "reino unido": ["uk", "inglaterra", "united kingdom"],
            "rep. dominicana": [
                "república dominicana",
                "republica dominicana",
                "rep. dominicana",
                "rep dominicana",
                "dominicana",
            ],
            "república dominicana": [
                "rep. dominicana",
                "rep dominicana",
                "republica dominicana",
                "dominicana",
            ],
            "republica dominicana": [
                "rep. dominicana",
                "rep dominicana",
                "república dominicana",
                "dominicana",
            ],
        };

        const aliases = countryAliases[normalized] || [];
        variations.push(...aliases);

        return [...new Set(variations)];
    }

    function extractDurationFromText(text) {
        if (!text) return null;

        const normalized = normalizeText(text);

        const durationPatterns = [
            /(\d+)\s*d[ií]as?/i,
            /(\d+)\s*days?/i,
            /(\d+)d\b/i,
        ];

        for (const pattern of durationPatterns) {
            let match = normalized.match(pattern);
            if (!match) {
                match = text.match(pattern);
            }
            if (match) {
                const duration = match[1];
                log("[TuSim:Plan] Extracted duration from text", {
                    original: text,
                    normalized,
                    duration,
                });
                return duration;
            }
        }

        return null;
    }

    function extractDataPlanType(text) {
        if (!text) return null;

        const normalized = normalizeText(text);

        if (normalized.includes("ilimitado") || normalized.includes("unlimited")) {
            return "ilimitado";
        }

        const gbPattern = /(\d+)\s*gb/i;
        const match = normalized.match(gbPattern);
        if (match) {
            return `gb-${match[1]}`;
        }

        return null;
    }

    async function findPlanByProductInfo(
        productName,
        duration,
        simType,
        variantTitle = null,
        shopifyPrice = null,
    ) {
        try {
            const baseProductName = extractBaseProductName(productName);
            const normalizedProductName = normalizeText(productName);

            let searchDuration = duration;
            let searchDataPlanType = null;

            if (variantTitle) {
                if (!searchDuration) {
                    const extractedDuration = extractDurationFromText(variantTitle);
                    if (extractedDuration) {
                        searchDuration = extractedDuration;
                        log("[TuSim:Plan] Using duration extracted from variant title", {
                            variantTitle,
                            duration: searchDuration,
                        });
                    }
                }

                searchDataPlanType = extractDataPlanType(variantTitle);
                if (searchDataPlanType) {
                    log("[TuSim:Plan] Extracted data plan type from variant title", {
                        variantTitle,
                        dataPlanType: searchDataPlanType,
                    });
                }
            }

            if (!searchDataPlanType && productName) {
                searchDataPlanType = extractDataPlanType(productName);
                if (searchDataPlanType) {
                    log("[TuSim:Plan] Extracted data plan type from product name", {
                        productName,
                        dataPlanType: searchDataPlanType,
                    });
                }
            }

            if (!searchDuration) {
                log("[TuSim:Plan] No duration available for search");
                return null;
            }

            const searchDurationStr = String(searchDuration).trim();

            log("[TuSim:Plan] Searching plan by product info", {
                productName,
                duration: searchDurationStr,
                simType,
                variantTitle,
                shopifyPrice,
                searchDataPlanType,
                baseProductName,
                normalizedProductName,
            });

            let allPlans = [];

            const searchTerms = [baseProductName, normalizedProductName]
                .filter(Boolean)
                .filter((term, index, self) => self.indexOf(term) === index);

            for (const searchTerm of searchTerms) {
                try {
                    log("[TuSim:Plan] Searching with term", { searchTerm });
                    const plansData = await app.service("plans").find({
                        query: {
                            searchTerm: searchTerm,
                            status: "active",
                            $limit: 200,
                        },
                    });

                    const plans = plansData.data || plansData;
                    log("[TuSim:Plan] Search result", {
                        searchTerm,
                        found: plans && Array.isArray(plans) ? plans.length : 0,
                        plans:
                            plans && Array.isArray(plans)
                                ? plans.map((p) => ({
                                    id: p.id,
                                    name: p.name,
                                    price: p.price,
                                    duration: p.duration,
                                }))
                                : [],
                    });

                    if (plans && Array.isArray(plans) && plans.length > 0) {
                        allPlans = allPlans.concat(plans);
                    }
                } catch (err) {
                    log("[TuSim:Plan] Search failed", {
                        searchTerm,
                        error: err.message,
                    });
                    continue;
                }
            }

            if (allPlans.length === 0) {
                log(
                    "[TuSim:Plan] No plans found by product name, trying country name variations",
                );

                const countryName = extractCountryName(productName);
                if (countryName) {
                    const countryVariations =
                        generateCountrySearchVariations(countryName);
                    log("[TuSim:Plan] Extracted country name", {
                        countryName,
                        variations: countryVariations,
                    });

                    for (const variation of countryVariations) {
                        try {
                            log("[TuSim:Plan] Searching with country variation", {
                                variation,
                            });
                            const plansData = await app.service("plans").find({
                                query: {
                                    searchTerm: variation,
                                    status: "active",
                                    $limit: 200,
                                },
                            });

                            const plans = plansData.data || plansData;
                            log("[TuSim:Plan] Country search result", {
                                variation,
                                found: plans && Array.isArray(plans) ? plans.length : 0,
                                plans:
                                    plans && Array.isArray(plans)
                                        ? plans.map((p) => ({
                                            id: p.id,
                                            name: p.name,
                                            price: p.price,
                                            duration: p.duration,
                                        }))
                                        : [],
                            });

                            if (plans && Array.isArray(plans) && plans.length > 0) {
                                allPlans = allPlans.concat(plans);
                            }
                        } catch (err) {
                            log("[TuSim:Plan] Country search failed", {
                                variation,
                                error: err.message,
                            });
                            continue;
                        }
                    }
                }
            }

            if (allPlans.length === 0) {
                log("[TuSim:Plan] No plans found by product name or country");
                return null;
            }

            const uniquePlans = Array.from(
                new Map(allPlans.map((plan) => [plan.id, plan])).values(),
            );

            log("[TuSim:Plan] Found unique plans", {
                count: uniquePlans.length,
                plans: uniquePlans.map((p) => ({
                    id: p.id,
                    name: p.name,
                    duration: p.duration,
                    price: p.price,
                })),
            });

            const priceTolerance =
                shopifyPrice && shopifyPrice > 0
                    ? Math.max(shopifyPrice * 0.1, 1)
                    : 0.01;

            log("[TuSim:Plan] Filtering plans by name and price", {
                baseProductName,
                shopifyPrice,
                priceTolerance,
                uniquePlansCount: uniquePlans.length,
            });

            const countryName = extractCountryName(productName);
            const countryVariations = countryName
                ? generateCountrySearchVariations(countryName)
                : [];

            const matchingPlans = uniquePlans.map((plan) => {
                const planName = normalizeText(plan.name);
                const planPrice = parseFloat(plan.price) || 0;
                const planDuration = String(plan.duration || "").trim();
                const planDurationNormalized = normalizeText(planDuration);
                const planDurationFromName = extractDurationFromText(plan.name);
                const searchDurationNormalized = normalizeText(searchDurationStr);
                const planDataPlanType = extractDataPlanType(plan.name);

                const baseProductNameNormalized = normalizeText(baseProductName);
                const planNameNormalized = normalizeText(plan.name);

                let nameMatches =
                    planNameNormalized.includes(baseProductNameNormalized) ||
                    baseProductNameNormalized.includes(
                        planNameNormalized.split(/\s+/)[0],
                    );

                if (!nameMatches && countryName) {
                    const normalizedCountry = normalizeText(countryName);
                    nameMatches = countryVariations.some((variation) => {
                        const normalizedVariation = normalizeText(variation);
                        const countryInPlan =
                            planNameNormalized.includes(normalizedVariation) ||
                            planNameNormalized
                                .split(/\s+/)
                                .some(
                                    (word) =>
                                        normalizedVariation.includes(word) ||
                                        word.includes(normalizedVariation),
                                );
                        return countryInPlan;
                    });
                }

                if (!nameMatches && baseProductNameNormalized) {
                    const baseWords = baseProductNameNormalized
                        .split(/\s+/)
                        .filter((w) => w.length > 1);
                    const planWords = planNameNormalized
                        .split(/\s+/)
                        .filter((w) => w.length > 1);
                    const matchingWords = baseWords.filter((word) =>
                        planWords.some(
                            (planWord) => planWord.includes(word) || word.includes(planWord),
                        ),
                    );
                    nameMatches =
                        matchingWords.length >= Math.min(2, baseWords.length) ||
                        (baseWords.length === 1 && matchingWords.length === 1);
                }

                let priceMatches = true;
                if (shopifyPrice !== null && shopifyPrice > 0) {
                    const priceDiff = Math.abs(planPrice - shopifyPrice);
                    priceMatches = priceDiff <= priceTolerance;
                }

                const durationMatches =
                    !searchDurationStr ||
                    normalizeText(planDuration) === normalizeText(searchDurationStr) ||
                    planDurationNormalized === searchDurationNormalized ||
                    planDurationFromName === searchDurationStr ||
                    planNameNormalized.match(new RegExp(`\\b${normalizeText(searchDurationStr)}\\b`));

                const dataPlanTypeMatches =
                    !searchDataPlanType ||
                    planDataPlanType === searchDataPlanType ||
                    (searchDataPlanType === "ilimitado" &&
                        (planNameNormalized.includes("ilimitado") ||
                            planNameNormalized.includes("unlimited"))) ||
                    (searchDataPlanType &&
                        searchDataPlanType.startsWith("gb-") &&
                        planNameNormalized.includes(
                            searchDataPlanType.replace("gb-", "") + "gb",
                        ));

                const match = nameMatches && priceMatches && durationMatches;
                const perfectMatch = match && dataPlanTypeMatches;

                if (match) {
                    log("[TuSim:Plan] ✅ Plan matches criteria", {
                        planId: plan.id,
                        planName: plan.name,
                        planPrice,
                        shopifyPrice,
                        planDuration,
                        planDurationNormalized,
                        planDurationFromName,
                        searchDuration: searchDurationStr,
                        searchDurationNormalized,
                        nameMatches,
                        priceMatches,
                        durationMatches,
                        dataPlanTypeMatches,
                        perfectMatch,
                        searchDataPlanType,
                        planDataPlanType,
                        baseProductName,
                        baseProductNameNormalized,
                        planNameNormalized,
                    });
                } else {
                    log("[TuSim:Plan] ❌ Plan does not match", {
                        planId: plan.id,
                        planName: plan.name,
                        planPrice,
                        shopifyPrice,
                        planDuration,
                        planDurationNormalized,
                        planDurationFromName,
                        searchDuration: searchDurationStr,
                        searchDurationNormalized,
                        nameMatches,
                        priceMatches,
                        durationMatches,
                        dataPlanTypeMatches,
                        perfectMatch,
                        searchDataPlanType,
                        planDataPlanType,
                        baseProductName,
                        baseProductNameNormalized,
                        planNameNormalized,
                    });
                }

                return {
                    plan,
                    nameMatches,
                    priceMatches,
                    durationMatches,
                    dataPlanTypeMatches,
                    fullMatch: match,
                    perfectMatch: perfectMatch,
                    priceDiff: shopifyPrice ? Math.abs(planPrice - shopifyPrice) : 0,
                };
            });

            log("[TuSim:Plan] All plans evaluated", {
                totalPlans: matchingPlans.length,
                plansWithFullMatch: matchingPlans.filter((m) => m.fullMatch).length,
                plansWithNameAndDuration: matchingPlans.filter(
                    (m) => m.nameMatches && m.durationMatches,
                ).length,
                allPlans: matchingPlans.map((m) => ({
                    id: m.plan.id,
                    name: m.plan.name,
                    price: m.plan.price,
                    duration: m.plan.duration,
                    nameMatches: m.nameMatches,
                    priceMatches: m.priceMatches,
                    durationMatches: m.durationMatches,
                    fullMatch: m.fullMatch,
                })),
            });

            const perfectMatches = matchingPlans.filter((m) => m.perfectMatch);
            const fullMatches = matchingPlans.filter(
                (m) => m.fullMatch && !m.perfectMatch,
            );
            const nameDurationMatches = matchingPlans.filter(
                (m) => m.nameMatches && m.durationMatches && !m.fullMatch,
            );

            log("[TuSim:Plan] Matching plans found", {
                perfectMatches: perfectMatches.length,
                fullMatches: fullMatches.length,
                nameDurationMatches: nameDurationMatches.length,
                perfectMatchPlans: perfectMatches.map((m) => ({
                    id: m.plan.id,
                    name: m.plan.name,
                    price: m.plan.price,
                    duration: m.plan.duration,
                    dataPlanType: extractDataPlanType(m.plan.name),
                })),
                fullMatchPlans: fullMatches.map((m) => ({
                    id: m.plan.id,
                    name: m.plan.name,
                    price: m.plan.price,
                    duration: m.plan.duration,
                })),
                nameDurationMatchPlans: nameDurationMatches.map((m) => ({
                    id: m.plan.id,
                    name: m.plan.name,
                    price: m.plan.price,
                    duration: m.plan.duration,
                    priceDiff: m.priceDiff,
                })),
            });

            let bestMatch = null;

            if (perfectMatches.length > 0) {
                perfectMatches.sort((a, b) => a.priceDiff - b.priceDiff);
                bestMatch = perfectMatches[0].plan;
                log("[TuSim:Plan] ✅ Using perfect match (includes data plan type)", {
                    planId: bestMatch.id,
                    planName: bestMatch.name,
                    planPrice: bestMatch.price,
                    shopifyPrice,
                    searchDataPlanType,
                    planDataPlanType: extractDataPlanType(bestMatch.name),
                });
            } else if (fullMatches.length > 0) {
                fullMatches.sort((a, b) => a.priceDiff - b.priceDiff);
                bestMatch = fullMatches[0].plan;
                log("[TuSim:Plan] Using full match (name, price, duration)", {
                    planId: bestMatch.id,
                    planName: bestMatch.name,
                    planPrice: bestMatch.price,
                    shopifyPrice,
                });
            } else if (nameDurationMatches.length > 0) {
                nameDurationMatches.sort((a, b) => a.priceDiff - b.priceDiff);
                bestMatch = nameDurationMatches[0].plan;
                log(
                    "[TuSim:Plan] Using best match by name and duration (price may differ)",
                    {
                        planId: bestMatch.id,
                        planName: bestMatch.name,
                        planPrice: bestMatch.price,
                        shopifyPrice,
                        priceDiff: nameDurationMatches[0].priceDiff,
                    },
                );
            }

            if (bestMatch) {
                log("[TuSim:Plan] ✅ Found matching plan", {
                    id: bestMatch.id,
                    name: bestMatch.name,
                    duration: bestMatch.duration,
                    price: bestMatch.price,
                    shopifyPrice,
                });
                return bestMatch.id;
            }

            log("[TuSim:Plan] ❌ No matching plan found after scoring");
            return null;
        } catch (err) {
            error("[TuSim:Plan] Error finding plan", err);
            return null;
        }
    }

    async function checkLandingPageEnabled() {
        try {
            // Landing pages have a partner (AssistCard, ViajesExito, etc.) and use Stripe
            // Product pages don't have a partner and use MercadoPago
            isLandingPage = !!TUSIM_CONFIG.partnerName;

            if (isLandingPage) {
                log(
                    `✅ Landing page detected (Partner: ${TUSIM_CONFIG.partnerName}) - Widget ACTIVATED (Stripe only)`,
                );
            } else {
                log(
                    "✅ Product page detected (No partner) - Widget ACTIVATED (Stripe: Tarjeta, MercadoPago: PSE/Efecty)",
                );
            }

            return { enabled: true, planIds: null };
        } catch (err) {
            error("Error checking landing page", err);
            return { enabled: false, planIds: null };
        }
    }

    function getMetafieldValue(product, namespace, key) {
        if (!product.metafields) return null;

        const metafield = product.metafields.find(
            (m) => m.namespace === namespace && m.key === key,
        );

        return metafield ? parseInt(metafield.value) : null;
    }

    function findButtonByText(textPatterns) {
        const allButtons = document.querySelectorAll("button");
        for (const button of allButtons) {
            const text = (button.textContent || button.innerText || "").trim();
            for (const pattern of textPatterns) {
                if (text.toLowerCase().includes(pattern.toLowerCase())) {
                    return button;
                }
            }
        }
        return null;
    }

    function findActiveButton(selectors) {
        for (const selector of selectors) {
            const elements = document.querySelectorAll(selector);
            for (const el of elements) {
                if (
                    el.classList.contains("active") ||
                    el.checked ||
                    el.getAttribute("aria-pressed") === "true" ||
                    el.classList.contains("selected")
                ) {
                    return el;
                }
            }
        }
        return null;
    }

    async function captureShopifyFormData() {
        try {
            log("Capturing Shopify form data...");

            let simType = "esim";
            let duration = "10";
            let quantity = 1;
            let travelDate = new Date().toISOString().split("T")[0];

            const simTypeSelectors = [
                '[name="sim-type"]',
                "[data-sim-type]",
                '[id*="sim-type"]',
                '[id*="simType"]',
                'input[type="radio"][name*="sim"]',
                'button[data-value*="sim"]',
            ];

            const simTypeElement = findActiveButton(simTypeSelectors);
            if (simTypeElement) {
                const value =
                    simTypeElement.value ||
                    simTypeElement.textContent ||
                    simTypeElement.getAttribute("data-value") ||
                    "";
                const valueLower = value.toLowerCase();
                if (
                    valueLower.includes("física") ||
                    valueLower.includes("physical") ||
                    valueLower.includes("simcard")
                ) {
                    simType = "physical";
                    log("Found SIM type: physical", value);
                } else {
                    log("Found SIM type: esim", value);
                }
            } else {
                const simTypeButton = findButtonByText(["física", "physical", "esim"]);
                if (simTypeButton) {
                    const text = (simTypeButton.textContent || "").toLowerCase();
                    if (text.includes("física") || text.includes("physical")) {
                        simType = "physical";
                        log("Found SIM type via button text: physical");
                    } else {
                        log("Found SIM type via button text: esim");
                    }
                }
            }

            let durationFound = false;
            const durationSelectors = [
                '[name="duration"]',
                "[data-duration]",
                '[id*="duration"]',
                '[id*="tiempo"]',
                'input[type="radio"][name*="duration"]',
                'input[type="radio"][name*="tiempo"]',
                'button[data-value*="dias"]',
                'button[data-value*="días"]',
            ];

            log(
                "[TuSim:Capture] Looking for duration element with selectors",
                durationSelectors,
            );
            const durationElement = findActiveButton(durationSelectors);
            log("[TuSim:Capture] Duration element found?", {
                found: !!durationElement,
                element: durationElement,
                value: durationElement?.value,
                textContent: durationElement?.textContent,
                dataValue: durationElement?.getAttribute("data-value"),
                classList: durationElement?.classList
                    ? Array.from(durationElement.classList)
                    : [],
            });

            if (durationElement) {
                const text =
                    durationElement.value ||
                    durationElement.textContent ||
                    durationElement.getAttribute("data-value") ||
                    "";
                const textLower = text.toLowerCase();
                log("[TuSim:Capture] Parsing duration from text", { text, textLower });

                if (textLower.includes("5") && !textLower.includes("15")) {
                    duration = "5";
                    durationFound = true;
                    log("Found duration: 5", text);
                } else if (textLower.includes("7")) {
                    duration = "7";
                    durationFound = true;
                    log("Found duration: 7", text);
                } else if (textLower.includes("10")) {
                    duration = "10";
                    durationFound = true;
                    log("Found duration: 10", text);
                } else if (textLower.includes("15")) {
                    duration = "15";
                    durationFound = true;
                    log("Found duration: 15", text);
                } else if (textLower.includes("20")) {
                    duration = "20";
                    durationFound = true;
                    log("Found duration: 20", text);
                } else if (textLower.includes("30")) {
                    duration = "30";
                    durationFound = true;
                    log("Found duration: 30", text);
                } else {
                    log("Found duration: 10 (default)", text);
                }
            } else {
                log(
                    "[TuSim:Capture] No duration element with findActiveButton, trying findButtonByText",
                );
                const durationButton = findButtonByText([
                    "5 días",
                    "5 dias",
                    "7 días",
                    "7 dias",
                    "10 días",
                    "10 dias",
                    "15 días",
                    "15 dias",
                    "20 días",
                    "20 dias",
                    "30 días",
                    "30 dias",
                ]);
                log("[TuSim:Capture] Duration button via text search", {
                    found: !!durationButton,
                    button: durationButton,
                });

                if (durationButton) {
                    const text = (durationButton.textContent || "").toLowerCase();
                    if (text.includes("5") && !text.includes("15")) {
                        duration = "5";
                        durationFound = true;
                        log("Found duration via button text: 5");
                    } else if (text.includes("7")) {
                        duration = "7";
                        durationFound = true;
                        log("Found duration via button text: 7");
                    } else if (text.includes("10")) {
                        duration = "10";
                        durationFound = true;
                        log("Found duration via button text: 10");
                    } else if (text.includes("15")) {
                        duration = "15";
                        durationFound = true;
                        log("Found duration via button text: 15");
                    } else if (text.includes("20")) {
                        duration = "20";
                        durationFound = true;
                        log("Found duration via button text: 20");
                    } else if (text.includes("30")) {
                        duration = "30";
                        durationFound = true;
                        log("Found duration via button text: 30");
                    } else {
                        log("Found duration via button text: 10 (default)");
                    }
                } else {
                    log(
                        "[TuSim:Capture] No duration button found, will try variant title",
                    );
                }
            }

            const quantitySelectors = [
                '[name="quantity"]',
                'input[type="number"]',
                '[id*="quantity"]',
                '[id*="cantidad"]',
            ];

            for (const selector of quantitySelectors) {
                const input = document.querySelector(selector);
                if (input && input.value) {
                    quantity = parseInt(input.value) || 1;
                    log("Found quantity", quantity);
                    break;
                }
            }

            const travelDateSelectors = [
                '[name="travel-date"]',
                '[name="travelDate"]',
                "[data-travel-date]",
                '[id*="travel-date"]',
                '[id*="travelDate"]',
                'input[type="date"]',
            ];

            let travelDateInputExists = false;
            let travelDateFromInput = false;
            for (const selector of travelDateSelectors) {
                const input = document.querySelector(selector);
                if (input) {
                    travelDateInputExists = true;
                    if (input.value) {
                        travelDate = input.value;
                        travelDateFromInput = true;
                        log("Found travel date", travelDate);
                        break;
                    }
                }
            }

            // NEW: Si el input de fecha está presente pero quedó vacío -> error bajo el input
            // y NO ejecutar la acción de agregar al carrito (bloqueo).
            if (travelDateInputExists && !travelDateFromInput) {
                log(
                    "[TuSim:Capture] Travel date input is present but empty, blocking add to cart",
                    { travelDateInputExists, travelDateFromInput },
                );
                const dateInput =
                    document.querySelector('#delivery_date') ||
                    document.querySelector('[name="travel-date"]') ||
                    document.querySelector('[name="travelDate"]');
                if (dateInput) {
                    let errorEl = dateInput.parentElement.querySelector('.tusim-date-error');
                    if (!errorEl) {
                        errorEl = document.createElement('span');
                        errorEl.className = 'tusim-date-error';
                        errorEl.style.cssText =
                            'color:#e74c3c;font-size:12px;display:none;margin-top:4px;';
                        dateInput.parentElement.appendChild(errorEl);
                    }
                    errorEl.textContent = T[LANG].invalidDate;
                    errorEl.style.display = 'block';
                    dateInput.style.borderColor = '#e74c3c';
                }
                window.__tusimDateBlocked = true;
                return null;
            }

            if (travelDate && !isValidDate(travelDate)) {
                log('[TuSim:Capture] Invalid travel date detected', { travelDate });
                const dateInput = document.querySelector('#delivery_date');
                if (dateInput) {
                    let errorEl = dateInput.parentElement.querySelector('.tusim-date-error');
                    if (!errorEl) {
                        errorEl = document.createElement('span');
                        errorEl.className = 'tusim-date-error';
                        errorEl.style.cssText = 'color:#e74c3c;font-size:12px;display:none;margin-top:4px;';
                        dateInput.parentElement.appendChild(errorEl);
                    }
                    errorEl.textContent = T[LANG].invalidDate;
                    errorEl.style.display = 'block';
                    dateInput.style.borderColor = '#e74c3c';
                }
                window.__tusimDateBlocked = true;
                return null;
            }

            let variantId = null;
            let variantTitle = null;
            const variantSelectors = [
                'select[name="id"]',
                'input[name="id"]',
                '[name="variant-id"]',
                "[data-variant-id]",
            ];

            // Try to get currently selected variant from Shopify's global product object
            if (
                typeof window.ShopifyAnalytics !== "undefined" &&
                window.ShopifyAnalytics.meta?.product?.variants
            ) {
                const variants = window.ShopifyAnalytics.meta.product.variants;
                log("[TuSim:Capture] Found Shopify Analytics variants", variants);
                // This might help but we need the current selected one
            }

            // Check for product JSON in page
            const productJsonScript = document.querySelector(
                'script[data-product-json], script[type="application/json"][data-product]',
            );
            if (productJsonScript) {
                try {
                    const productData = JSON.parse(productJsonScript.textContent);
                    log("[TuSim:Capture] Found product data in page", productData);
                } catch (e) {
                    log("[TuSim:Capture] Could not parse product JSON");
                }
            }

            for (const selector of variantSelectors) {
                const element = document.querySelector(selector);
                log(`[TuSim:Capture] Checking variant selector: ${selector}`, {
                    found: !!element,
                    tagName: element?.tagName,
                    value: element?.value,
                    allOptions:
                        element?.tagName === "SELECT"
                            ? Array.from(element.options).map((opt) => ({
                                value: opt.value,
                                text: opt.text,
                                selected: opt.selected,
                            }))
                            : "N/A",
                });
                if (element) {
                    if (element.tagName === "SELECT") {
                        variantId = element.value;
                        const selectedOption = element.options[element.selectedIndex];
                        variantTitle = selectedOption ? selectedOption.text : null;
                    } else {
                        variantId =
                            element.value || element.getAttribute("data-variant-id");
                    }
                    if (variantId) {
                        log("Found variant ID from input", { variantId, variantTitle });
                        break;
                    }
                }
            }

            // Additional attempt: Look for variant in URL hash or query params
            const urlParams = new URLSearchParams(window.location.search);
            const variantFromUrl = urlParams.get("variant");
            if (variantFromUrl) {
                log("[TuSim:Capture] Found variant in URL", variantFromUrl);
                variantId = variantFromUrl;
            }

            // Check variant title from exposed metafields to detect SIM type
            if (
                variantId &&
                window.TUSIM_VARIANT_METAFIELDS &&
                window.TUSIM_VARIANT_METAFIELDS[variantId]
            ) {
                const variantData = window.TUSIM_VARIANT_METAFIELDS[variantId];
                if (variantData.title) {
                    const variantTitleLower = variantData.title.toLowerCase();
                    log("[TuSim:Capture] Checking variant title for SIM type", {
                        variantTitle: variantData.title,
                        variantTitleLower,
                    });

                    if (
                        variantTitleLower.includes("física") ||
                        variantTitleLower.includes("fisica") ||
                        variantTitleLower.includes("physical") ||
                        variantTitleLower.includes("simcard") ||
                        variantTitleLower.includes("sim card")
                    ) {
                        simType = "physical";
                        log(
                            "[TuSim:Capture] Detected SIM type as physical from variant title",
                            variantData.title,
                        );
                    } else if (
                        variantTitleLower.includes("esim") ||
                        variantTitleLower.includes("e-sim") ||
                        variantTitleLower.includes("digital")
                    ) {
                        simType = "esim";
                        log(
                            "[TuSim:Capture] Detected SIM type as esim from variant title",
                            variantData.title,
                        );
                    }
                }
            }

            // Also check variant title from Shopify Analytics if available
            if (
                variantId &&
                typeof window.ShopifyAnalytics !== "undefined" &&
                window.ShopifyAnalytics.meta?.product?.variants
            ) {
                const variants = window.ShopifyAnalytics.meta.product.variants;
                const variant = variants.find(
                    (v) => v.id == variantId || String(v.id) === String(variantId),
                );
                if (variant && variant.title) {
                    const variantTitleLower = variant.title.toLowerCase();
                    log(
                        "[TuSim:Capture] Checking Shopify Analytics variant title for SIM type",
                        {
                            variantTitle: variant.title,
                            variantTitleLower,
                        },
                    );

                    if (
                        variantTitleLower.includes("física") ||
                        variantTitleLower.includes("fisica") ||
                        variantTitleLower.includes("physical") ||
                        variantTitleLower.includes("simcard") ||
                        variantTitleLower.includes("sim card")
                    ) {
                        simType = "physical";
                        log(
                            "[TuSim:Capture] Detected SIM type as physical from Shopify Analytics variant title",
                            variant.title,
                        );
                    } else if (
                        variantTitleLower.includes("esim") ||
                        variantTitleLower.includes("e-sim") ||
                        variantTitleLower.includes("digital")
                    ) {
                        simType = "esim";
                        log(
                            "[TuSim:Capture] Detected SIM type as esim from Shopify Analytics variant title",
                            variant.title,
                        );
                    }
                }
            }

            // Also check variantTitle if we got it from select element
            if (variantTitle) {
                const variantTitleLower = variantTitle.toLowerCase();
                log(
                    "[TuSim:Capture] Checking variant title from select element for SIM type",
                    {
                        variantTitle,
                        variantTitleLower,
                    },
                );

                if (
                    variantTitleLower.includes("física") ||
                    variantTitleLower.includes("fisica") ||
                    variantTitleLower.includes("physical") ||
                    variantTitleLower.includes("simcard") ||
                    variantTitleLower.includes("sim card")
                ) {
                    simType = "physical";
                    log(
                        "[TuSim:Capture] Detected SIM type as physical from select variant title",
                        variantTitle,
                    );
                } else if (
                    variantTitleLower.includes("esim") ||
                    variantTitleLower.includes("e-sim") ||
                    variantTitleLower.includes("digital")
                ) {
                    simType = "esim";
                    log(
                        "[TuSim:Capture] Detected SIM type as esim from select variant title",
                        variantTitle,
                    );
                }
            }

            const result = { simType, duration, quantity, travelDate, variantId, claritySessionId: getClaritySessionId() };
            log("Captured form data", result);
            return result;
        } catch (err) {
            error("[TuSim:Capture] Error capturing form data", err);
            log("Returning default values due to error");
            return {
                simType: "esim",
                duration: "10",
                quantity: 1,
                travelDate: new Date().toISOString().split("T")[0],
                variantId: null,
                claritySessionId: getClaritySessionId(),
            };
        }
    }

    async function getProductWithVariantMetafields(productHandle) {
        try {
            log("[TuSim:Product] Fetching product with variant metafields", {
                productHandle,
            });

            // Try to get from product.json with metafields parameter
            const response = await fetch(
                `/products/${productHandle}.json?view=metafields`,
            );

            if (!response.ok) {
                log("[TuSim:Product] Failed to fetch product", {
                    status: response.status,
                });
                return null;
            }

            const data = await response.json();
            const product = data.product || data;

            log("[TuSim:Product] Product fetched", {
                title: product.title,
                variantsCount: product.variants?.length,
                hasMetafields: !!product.metafields,
            });

            return product;
        } catch (err) {
            error("[TuSim:Product] Error fetching product", err);
            return null;
        }
    }

    async function getVariantPlanId(productHandle, variantId) {
        try {
            if (!productHandle || !variantId) {
                log("[TuSim:Variant] Missing productHandle or variantId", {
                    productHandle,
                    variantId,
                });
                return null;
            }

            log("[TuSim:Variant] Getting plan ID for variant", {
                productHandle,
                variantId,
            });

            // Priority 1: Try to get from exposed metafields in the page
            if (
                window.TUSIM_VARIANT_METAFIELDS &&
                window.TUSIM_VARIANT_METAFIELDS[variantId]
            ) {
                const variantData = window.TUSIM_VARIANT_METAFIELDS[variantId];
                log("[TuSim:Variant] Found variant in exposed metafields", {
                    variantId,
                    variantData,
                });

                if (variantData.plan_id) {
                    const planId = parseInt(variantData.plan_id);
                    log("[TuSim:Variant] ✅ Got plan ID from exposed metafields", {
                        variantId,
                        planId,
                        variantTitle: variantData.title,
                    });
                    return planId;
                } else {
                    log("[TuSim:Variant] ⚠️ Variant found but no plan_id", {
                        variantId,
                        variantTitle: variantData.title,
                    });
                }
            } else {
                log(
                    "[TuSim:Variant] ⚠️ TUSIM_VARIANT_METAFIELDS not found or variant not in it",
                    {
                        variantId,
                        hasGlobalObject: !!window.TUSIM_VARIANT_METAFIELDS,
                        availableVariants: window.TUSIM_VARIANT_METAFIELDS
                            ? Object.keys(window.TUSIM_VARIANT_METAFIELDS)
                            : [],
                    },
                );
            }

            // Priority 2: Try to get the product with metafields from API
            const product = await getProductWithVariantMetafields(productHandle);

            if (!product) {
                log("[TuSim:Variant] Failed to fetch product");
                return null;
            }

            log("[TuSim:Variant] Product has variants", {
                count: product.variants?.length,
                variantIds: product.variants?.map((v) => ({
                    id: v.id,
                    title: v.title,
                    hasMetafields: !!v.metafields,
                })),
            });

            const variant = product.variants?.find((v) => v.id == variantId);
            if (!variant) {
                log("[TuSim:Variant] Variant not found", {
                    searchingFor: variantId,
                    availableIds: product.variants?.map((v) => v.id),
                });
                return null;
            }

            log("[TuSim:Variant] Found variant", {
                id: variant.id,
                title: variant.title,
                metafields: variant.metafields,
                hasMetafields: !!variant.metafields && variant.metafields.length > 0,
            });

            // Check if variant has metafields array
            if (variant.metafields && Array.isArray(variant.metafields)) {
                const planIdMetafield = variant.metafields.find(
                    (m) => m.namespace === "custom" && m.key === "plan_id",
                );

                if (planIdMetafield) {
                    const planId = parseInt(planIdMetafield.value);
                    log("[TuSim:Variant] ✅ Found plan ID from metafield", {
                        planId,
                        variantTitle: variant.title,
                    });
                    return planId;
                }

                log("[TuSim:Variant] ❌ No plan_id metafield found on variant", {
                    variantTitle: variant.title,
                    availableMetafields: variant.metafields.map(
                        (m) => `${m.namespace}.${m.key}`,
                    ),
                });
            } else {
                log(
                    "[TuSim:Variant] ⚠️ Variant has no metafields or metafields not exposed",
                    {
                        variantTitle: variant.title,
                    },
                );
            }

            // Return variant object to extract duration from title later
            return { variant, planId: null };
        } catch (err) {
            error("[TuSim:Variant] Error getting variant plan ID", err);
            return null;
        }
    }

    let stripeInstance = null;
    let stripeElements = null;
    let cardElement = null;
    let paymentIntentClientSecret = null;
    let isLandingPage = false;

    let appliedDiscountCode = null;
    let appliedDiscountPercentage = 0;
    let discountValidationResult = null;

    function validateCardNumber(cardNumber) {
        const cleaned = cardNumber.replace(/\s/g, "");
        if (cleaned.length < 13 || cleaned.length > 19) {
            return {
                valid: false,
                error: "El número de tarjeta debe tener entre 13 y 19 dígitos",
            };
        }

        // Luhn algorithm validation
        let sum = 0;
        let isEven = false;
        for (let i = cleaned.length - 1; i >= 0; i--) {
            let digit = parseInt(cleaned[i]);
            if (isEven) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            sum += digit;
            isEven = !isEven;
        }

        if (sum % 10 !== 0) {
            return { valid: false, error: "El número de tarjeta no es válido" };
        }

        return { valid: true };
    }

    function validateExpiryMonth(month) {
        const num = parseInt(month);
        if (isNaN(num) || num < 1 || num > 12) {
            return { valid: false, error: "El mes debe estar entre 01 y 12" };
        }
        return { valid: true };
    }

    function validateExpiryYear(year) {
        const num = parseInt(year);
        const currentYear = new Date().getFullYear();
        if (isNaN(num) || num < currentYear || num > currentYear + 20) {
            return {
                valid: false,
                error: `El año debe estar entre ${currentYear} y ${currentYear + 20}`,
            };
        }
        return { valid: true };
    }

    function validateExpiryDate(month, year) {
        const monthValid = validateExpiryMonth(month);
        if (!monthValid.valid) return monthValid;

        const yearValid = validateExpiryYear(year);
        if (!yearValid.valid) return yearValid;

        const expiryDate = new Date(parseInt(year), parseInt(month) - 1);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (expiryDate < today) {
            return { valid: false, error: "La tarjeta ha expirado" };
        }

        return { valid: true };
    }

    function validateCVV(cvv) {
        if (!cvv || cvv.length < 3 || cvv.length > 4) {
            return { valid: false, error: "El CVV debe tener 3 o 4 dígitos" };
        }
        if (!/^\d+$/.test(cvv)) {
            return { valid: false, error: "El CVV solo debe contener números" };
        }
        return { valid: true };
    }

    function formatCardNumber(value) {
        const cleaned = value.replace(/\s/g, "");
        const groups = cleaned.match(/.{1,4}/g);
        return groups ? groups.join(" ") : cleaned;
    }

    function determineCardType(cardNumber) {
        const cleaned = cardNumber.replace(/\s/g, "");
        if (cleaned.startsWith("4")) {
            return "visa";
        } else if (/^5[1-5]/.test(cleaned)) {
            return "mastercard";
        } else if (/^3[47]/.test(cleaned)) {
            return "amex";
        } else if (/^6/.test(cleaned)) {
            return "discover";
        }
        return "unknown";
    }

    function parseApiError(errorText, defaultMessage = "Ha ocurrido un error") {
        try {
            const errorObj = JSON.parse(errorText);

            if (errorObj.message) {
                let message = errorObj.message;

                if (
                    errorObj.data &&
                    Array.isArray(errorObj.data) &&
                    errorObj.data.length > 0
                ) {
                    const validationErrors = errorObj.data
                        .map((err) => {
                            if (err.message) {
                                return err.message;
                            }
                            if (err.additionalProperty) {
                                return `Campo no permitido: ${err.additionalProperty}`;
                            }
                            return null;
                        })
                        .filter(Boolean);

                    if (validationErrors.length > 0) {
                        message = validationErrors.join(". ");
                    }
                }

                if (errorObj.cause && Array.isArray(errorObj.cause)) {
                    const causeMessages = errorObj.cause
                        .map((cause) => {
                            if (cause.description) {
                                return cause.description;
                            }
                            if (cause.message) {
                                return cause.message;
                            }
                            return null;
                        })
                        .filter(Boolean);

                    if (causeMessages.length > 0) {
                        message = causeMessages.join(". ");
                    }
                }

                return message;
            }

            return errorObj.message || errorText || defaultMessage;
        } catch (e) {
            if (errorText && errorText.length < 200) {
                return errorText;
            }
            return defaultMessage;
        }
    }

    function showErrorMessage(elementId, message) {
        const errorDiv = document.getElementById(elementId);
        if (errorDiv) {
            errorDiv.textContent = message;
            errorDiv.style.display = "block";
            errorDiv.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }

    async function addNewCreditCard(cardData) {
        try {
            log("[TuSim:Card] Adding new credit card", { cardData });

            const response = await fetch(
                `${TUSIM_CONFIG.apiUrl}/credit-card-tokenizer`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${TUSIM_CONFIG.jwtToken}`,
                    },
                    body: JSON.stringify({
                        organization_id: TUSIM_CONFIG.organizationId,
                        organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                        number: cardData.cardNumber.replace(/\s/g, ""),
                        holder: cardData.cardHolder,
                        expiryMonth: cardData.expiryMonth.padStart(2, "0"),
                        expiryYear: cardData.expiryYear,
                        cvv: cardData.cvv,
                        type: cardData.documentType,
                        dni: cardData.documentNumber,
                        email: cardData.email,
                        skip_save: true,
                        is_final_customer: true,
                        firstName: cardData.cardHolder.split(" ")[0] || cardData.cardHolder,
                        lastName: cardData.cardHolder.split(" ").slice(1).join(" ") || "",
                    }),
                },
            );

            if (!response.ok) {
                const errorText = await response.text();
                const errorMessage = parseApiError(
                    errorText,
                    T[LANG].cardSaveError,
                );
                throw new Error(errorMessage);
            }

            const result = await response.json();
            log("[TuSim:Card] Card added successfully", result);
            return result;
        } catch (err) {
            error("[TuSim:Card] Error adding card", err);
            throw err;
        }
    }

    function showAddCardDialog(onSuccess) {
        const overlay = document.createElement("div");
        overlay.id = "tusim-add-card-dialog";
        overlay.innerHTML = `
      <div class="tusim-modal">
        <h2>Agregar Nueva Tarjeta</h2>
        <form id="tusim-add-card-form">
          <div class="tusim-form-group">
            <label>Número de Tarjeta *</label>
            <input type="text" name="cardNumber" id="tusim-card-number" maxlength="19" placeholder="1234 5678 9012 3456" required>
            <div id="tusim-card-type" style="margin-top: 4px; font-size: 12px; color: #666;"></div>
          </div>
          <div class="tusim-form-group">
            <label>Nombre del Titular *</label>
            <input type="text" name="cardHolder" placeholder="Como aparece en la tarjeta" required>
          </div>
          <div class="tusim-form-row">
            <div class="tusim-form-group">
              <label>Mes *</label>
              <input type="text" name="expiryMonth" maxlength="2" placeholder="MM" required>
            </div>
            <div class="tusim-form-group">
              <label>Año *</label>
              <input type="text" name="expiryYear" maxlength="4" placeholder="YYYY" required>
            </div>
            <div class="tusim-form-group">
              <label>CVV *</label>
              <input type="password" name="cvv" maxlength="4" placeholder="123" required>
            </div>
          </div>
          <div class="tusim-form-row tusim-document-row">
            <div class="tusim-form-group">
              <label>Tipo de Documento *</label>
              <select name="documentType" required>
                <option value="">Seleccione</option>
                <option value="CC">CC</option>
                <option value="DNI">DNI</option>
              </select>
            </div>
            <div class="tusim-form-group">
              <label>Número de Documento *</label>
              <input type="text" name="documentNumber" required>
            </div>
          </div>
          <div class="tusim-form-group">
            <label>Email *</label>
            <input type="email" name="email" placeholder="correo@ejemplo.com" required>
          </div>
          <div class="tusim-form-actions">
            <button type="button" id="tusim-add-card-cancel" data-tusim-internal="true">Cancelar</button>
            <button type="submit" id="tusim-add-card-submit" data-tusim-internal="true">${T[LANG].saveCard}</button>
          </div>
        </form>
        <div id="tusim-add-card-error" style="display:none; color:#e74c3c; margin-top:10px; padding:10px; background:#fee; border:1px solid #fcc; border-radius:4px; font-size:14px;"></div>
      </div>
      <style>
        #tusim-add-card-dialog {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: rgba(0,0,0,0.7) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 1000000 !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        #tusim-add-card-dialog .tusim-modal {
          background: white !important;
          padding: 30px !important;
          border-radius: 8px !important;
          max-width: 500px !important;
          width: 90% !important;
          max-height: 90vh !important;
          overflow-y: auto !important;
          position: relative !important;
          z-index: 1000001 !important;
        }
        .tusim-form-group {
          margin-bottom: 16px;
        }
        .tusim-form-row {
          display: grid !important;
          grid-template-columns: repeat(3, 1fr) !important;
          gap: 12px !important;
          margin-bottom: 16px !important;
        }
        .tusim-document-row {
          grid-template-columns: 1fr 1fr !important;
        }
        .tusim-document-row .tusim-form-group {
          width: 100% !important;
          margin-bottom: 0 !important;
        }
        .tusim-form-group label {
          display: block;
          margin-bottom: 6px;
          font-weight: 500;
        }
        .tusim-form-group input,
        .tusim-form-group select {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          box-sizing: border-box;
          font-size: 14px;
        }
        .tusim-form-actions {
          display: flex;
          gap: 12px;
          margin-top: 24px;
          justify-content: flex-end;
        }
        .tusim-form-actions button {
          padding: 12px 24px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
        .tusim-form-actions button[type="button"] {
          background: #f5f5f5;
        }
        .tusim-form-actions button[type="submit"] {
          background: #7c3aed;
          color: white;
        }
        .tusim-form-actions button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      </style>
    `;

        document.body.appendChild(overlay);

        // Format card number as user types
        const cardNumberInput = document.getElementById("tusim-card-number");
        if (cardNumberInput) {
            cardNumberInput.addEventListener("input", (e) => {
                const value = e.target.value.replace(/\s/g, "");
                const formatted = formatCardNumber(value);
                e.target.value = formatted;

                // Show card type
                const cardTypeDiv = document.getElementById("tusim-card-type");
                if (value.length >= 4) {
                    const cardType = determineCardType(value);
                    if (cardType !== "unknown") {
                        cardTypeDiv.textContent = `${T[LANG].cardType}${cardType.toUpperCase()}`;
                        cardTypeDiv.style.color = "#7c3aed";
                    } else {
                        cardTypeDiv.textContent = "";
                    }
                } else {
                    cardTypeDiv.textContent = "";
                }
            });
        }

        document
            .getElementById("tusim-add-card-cancel")
            ?.addEventListener("click", () => {
                overlay.remove();
            });

        document
            .getElementById("tusim-add-card-form")
            ?.addEventListener("submit", async (e) => {
                e.preventDefault();
                const submitBtn = document.getElementById("tusim-add-card-submit");
                const errorDiv = document.getElementById("tusim-add-card-error");

                submitBtn.disabled = true;
                submitBtn.textContent = T[LANG].saving;
                errorDiv.style.display = "none";

                const formData = new FormData(e.target);
                const cardData = {
                    cardNumber: formData.get("cardNumber").replace(/\s/g, ""),
                    cardHolder: formData.get("cardHolder"),
                    expiryMonth: formData.get("expiryMonth").padStart(2, "0"),
                    expiryYear: formData.get("expiryYear"),
                    cvv: formData.get("cvv"),
                    documentType: formData.get("documentType"),
                    documentNumber: formData.get("documentNumber"),
                    email: formData.get("email"),
                };

                // Validate card number
                const cardValidation = validateCardNumber(cardData.cardNumber);
                if (!cardValidation.valid) {
                    showErrorMessage("tusim-add-card-error", cardValidation.error);
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                    return;
                }

                // Validate expiry date
                const expiryValidation = validateExpiryDate(
                    cardData.expiryMonth,
                    cardData.expiryYear,
                );
                if (!expiryValidation.valid) {
                    showErrorMessage("tusim-add-card-error", expiryValidation.error);
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                    return;
                }

                // Validate CVV
                const cvvValidation = validateCVV(cardData.cvv);
                if (!cvvValidation.valid) {
                    showErrorMessage("tusim-add-card-error", cvvValidation.error);
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                    return;
                }

                // Validate card holder
                if (!cardData.cardHolder || cardData.cardHolder.trim().length < 3) {
                    showErrorMessage(
                        "tusim-add-card-error",
                        "El nombre del titular debe tener al menos 3 caracteres",
                    );
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                    return;
                }

                // Validate email
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(cardData.email)) {
                    showErrorMessage(
                        "tusim-add-card-error",
                        "Por favor, ingresa un email válido",
                    );
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                    return;
                }

                try {
                    const result = await addNewCreditCard(cardData);
                    overlay.remove();
                    const cardInfo = {
                        cardNumber: cardData.cardNumber,
                        cvv: cardData.cvv,
                        cardType:
                            result?.card_type || determineCardType(cardData.cardNumber),
                        token: result?.token,
                        mercadopago_customer_id: result?.mercadopago_customer_id,
                        mercadopago_credit_card_id: result?.mercadopago_credit_card_id,
                        last_four: result?.last_four || cardData.cardNumber.slice(-4),
                    };
                    onSuccess(null, cardInfo);
                } catch (err) {
                    const errorMessage =
                        err.message ||
                        T[LANG].cardSaveErrorAlt;
                    showErrorMessage("tusim-add-card-error", errorMessage);
                    submitBtn.disabled = false;
                    submitBtn.textContent = T[LANG].saveCard;
                }
            });
    }

    let cardElementComplete = false;

    function updateSubmitButton() {
        const submitBtn = document.getElementById("tusim-submit-btn");
        if (submitBtn) {
            let isValid = false;

            // First validate required form fields
            const firstName = document
                .querySelector('[name="firstName"]')
                ?.value?.trim();
            const lastName = document
                .querySelector('[name="lastName"]')
                ?.value?.trim();
            const email = document.querySelector('[name="email"]')?.value?.trim();
            const phone = document.querySelector('[name="phone"]')?.value?.trim();
            const dni = document.querySelector('[name="dni"]')?.value?.trim();

            const formFieldsValid =
                !!firstName && !!lastName && !!email && !!phone && !!dni;

            if (!formFieldsValid) {
                submitBtn.disabled = true;
                log("[TuSim:Form] Update submit button - Form fields incomplete", {
                    firstName: !!firstName,
                    lastName: !!lastName,
                    email: !!email,
                    phone: !!phone,
                    dni: !!dni,
                });
                return;
            }

            // Validate shipping for physical SIMs
            // Calculate hasPhysicalSim dynamically
            const cart = getCart();
            const cartItems = cart?.items || [];
            const summaryContainer = document.querySelector(".tusim-order-summary");
            const isCartCheckout = summaryContainer?.querySelector(
                ".tusim-summary-total-only",
            );
            const hasPhysicalSim = isCartCheckout
                ? cartItems.some(
                    (item) =>
                        item.shopifyData && item.shopifyData.simType === "physical",
                )
                : cartItems.length > 0 &&
                cartItems[0]?.shopifyData?.simType === "physical";

            if (hasPhysicalSim) {
                const shippingItem = getShippingItem(cart);
                if (
                    shippingItem &&
                    (shippingItem.pending || shippingItem.unavailable)
                ) {
                    submitBtn.disabled = true;
                    log("[TuSim:Form] Update submit button - Shipping unavailable", {
                        pending: shippingItem.pending,
                        unavailable: shippingItem.unavailable,
                    });
                    return;
                }
            }

            if (isLandingPage) {
                // Landing page: Validate Stripe card element is complete and valid
                isValid = !!cardElement && cardElementComplete;
            } else {
                // Product page (web): Validate payment method selection
                const paymentMethodSelect = document.getElementById(
                    "tusim-payment-method",
                );
                const selectedMethod = paymentMethodSelect?.value;

                if (!selectedMethod) {
                    isValid = false;
                } else if (selectedMethod === "credit_card") {
                    // Web: Validate Stripe card element for credit card
                    isValid = !!cardElement && cardElementComplete;
                } else if (selectedMethod === "pse") {
                    const bankSelect = document.getElementById("tusim-pse-bank-select");
                    const typeIdSelect = document.getElementById("tusim-pse-type-id");
                    isValid = !!bankSelect?.value && !!typeIdSelect?.value;
                } else if (selectedMethod === "efecty") {
                    const typeIdSelect = document.getElementById("tusim-efecty-type-id");
                    isValid = !!typeIdSelect?.value;
                } else {
                    isValid = false;
                }
            }

            submitBtn.disabled = !isValid;
            log("[TuSim:Form] Update submit button", {
                isLandingPage,
                isValid,
                formFieldsValid,
                selectedMethod: !isLandingPage
                    ? document.getElementById("tusim-payment-method")?.value
                    : null,
            });
        }
    }

    function showSelectedCardInfo(cardId, lastFour, cardType) {
        const container = document.getElementById("tusim-cards-container");
        if (container) {
            container.innerHTML = `
        <div class="tusim-card-item selected">
          <div class="tusim-card-content">
            <div class="tusim-card-icon">💳</div>
            <div class="tusim-card-info">
              <div class="tusim-card-title">
                ${cardType}${T[LANG].cardEnding}${lastFour}
              </div>
              <div class="tusim-card-subtitle">
                ${T[LANG].cardSelected}
              </div>
            </div>
          </div>
        </div>
      `;
        }
    }

    function showAddToCartConfirmation(plan, cart, shopifyProduct) {
        log("[TuSim:Cart] Showing add to cart confirmation");

        // Remove existing notification if any
        const existing = document.getElementById("tusim-cart-notification");
        if (existing) existing.remove();

        const productName = shopifyProduct ? shopifyProduct.title : plan.name;

        const notification = document.createElement("div");
        notification.id = "tusim-cart-notification";
        notification.innerHTML = `
      <div class="tusim-notification-content">
        <div class="tusim-notification-icon">✓</div>
        <div class="tusim-notification-text">
          <strong>${productName}</strong> ${T[LANG].addedToCart}
          <br><small>${cart.items.length} ${T[LANG].itemsInCart}</small>
        </div>
        <button onclick="window.TuSimWidget.openCart()" class="tusim-view-cart-btn">
          ${T[LANG].viewCart}
        </button>
      </div>
      <style>
        #tusim-cart-notification {
          position: fixed !important;
          top: 24px !important;
          right: 24px !important;
          z-index: 999999 !important;
          animation: slideInRight 0.25s cubic-bezier(0.16, 1, 0.3, 1) !important;
        }
        
        @keyframes slideInRight {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutRight {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(400px);
            opacity: 0;
          }
        }
        
        .tusim-notification-content {
          background: #ffffff !important;
          border-radius: 8px !important;
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.1) !important;
          padding: 16px 18px !important;
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 380px !important;
          max-width: 450px !important;
          border: 1px solid #e3e8ef !important;
        }
        
        .tusim-notification-icon {
          width: 36px !important;
          height: 36px !important;
          background: linear-gradient(135deg, #00d4aa 0%, #00c389 100%) !important;
          color: white !important;
          border-radius: 50% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 20px !important;
          font-weight: 700 !important;
          flex-shrink: 0 !important;
          box-shadow: 0 4px 12px rgba(0, 212, 170, 0.3) !important;
        }
        
        .tusim-notification-text {
          flex: 1 !important;
          font-size: 14px !important;
          color: #0a2540 !important;
          line-height: 1.4 !important;
        }
        
        .tusim-notification-text strong {
          display: block !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          margin-bottom: 4px !important;
          font-size: 15px !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-notification-text small {
          color: #697386 !important;
          font-size: 13px !important;
        }
        
        .tusim-view-cart-btn {
          background: #635bff !important;
          color: white !important;
          border: none !important;
          padding: 9px 16px !important;
          border-radius: 6px !important;
          cursor: pointer !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          white-space: nowrap !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 2px 6px rgba(99, 91, 255, 0.2) !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-view-cart-btn:hover {
          background: #5651e0 !important;
          box-shadow: 0 4px 10px rgba(99, 91, 255, 0.3) !important;
          transform: translateY(-1px) !important;
        }
        
        .tusim-view-cart-btn:active {
          transform: translateY(0) !important;
        }
        
        @media (max-width: 480px) {
          #tusim-cart-notification {
            right: 12px !important;
            left: 12px !important;
            top: 12px !important;
          }
          
          .tusim-notification-content {
            min-width: auto !important;
            max-width: none !important;
            padding: 14px !important;
          }
        }
      </style>
    `;

        document.body.appendChild(notification);

        // Auto-hide after 3 seconds
        setTimeout(() => {
            if (notification.parentElement) {
                notification.style.animation = "slideOutRight 0.3s ease-in";
                setTimeout(() => notification.remove(), 300);
            }
        }, 3000);
    }

    function createCartBadge() {
        if (document.getElementById("tusim-cart-badge")) {
            log("[TuSim:Cart] Cart badge already exists");
            return;
        }

        log("[TuSim:Cart] Creating cart badge");

        const badge = document.createElement("div");
        badge.id = "tusim-cart-badge";
        badge.innerHTML = `
      <button class="tusim-cart-button" aria-label="Abrir carrito de compras">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        <span class="tusim-cart-count">0</span>
      </button>
      <style>
        #tusim-cart-badge {
          position: fixed !important;
          bottom: 70px !important;
          right: 14px !important;
          z-index: 2147483647 !important;
          visibility: visible !important;
          display: block !important;
        }
        
        .tusim-cart-button {
          background: #635bff !important;
          color: white !important;
          border: none !important;
          border-radius: 50% !important;
          width: 56px !important;
          height: 56px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          box-shadow: 0 8px 24px rgba(99, 91, 255, 0.32), 0 0 1px rgba(0, 0, 0, 0.1) !important;
          transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
          position: relative !important;
        }
        
        .tusim-cart-button:hover {
          transform: translateY(-2px) scale(1.05) !important;
          box-shadow: 0 12px 32px rgba(99, 91, 255, 0.4), 0 0 1px rgba(0, 0, 0, 0.1) !important;
          background: #5651e0 !important;
        }
        
        .tusim-cart-button:active {
          transform: translateY(0) scale(0.98) !important;
          box-shadow: 0 4px 16px rgba(99, 91, 255, 0.24) !important;
        }
        
        .tusim-cart-button svg {
          width: 26px !important;
          height: 26px !important;
        }
        
        .tusim-cart-count {
          position: absolute !important;
          top: -6px !important;
          right: -6px !important;
          background: #ff5b5b !important;
          color: white !important;
          border-radius: 50% !important;
          min-width: 22px !important;
          height: 22px !important;
          display: none !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          border: 2px solid #ffffff !important;
          padding: 0 5px !important;
          box-shadow: 0 2px 8px rgba(255, 91, 91, 0.4) !important;
          animation: pulse 0.4s ease-out !important;
        }
        
        @keyframes pulse {
          0% { transform: scale(0.8); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        
        .tusim-cart-count.visible {
          display: flex !important;
        }
        
        @media (max-width: 480px) {
          #tusim-cart-badge {
            bottom: 80px !important;
            right: 20px !important;
          }
          
          .tusim-cart-button {
            width: 52px !important;
            height: 52px !important;
          }
          
          .tusim-cart-button svg {
            width: 24px !important;
            height: 24px !important;
          }
        }
      </style>
    `;

        badge.querySelector(".tusim-cart-button").addEventListener("click", () => {
            log("[TuSim:Cart] Cart button clicked");
            openCartModal();
        });

        document.body.appendChild(badge);
        const cart = getCart();
        const productCount = cart.items.filter(
            (item) => item.type !== "shipping",
        ).length;
        updateCartBadge(productCount);
        log("[TuSim:Cart] Cart badge created and appended to body");

        // Force visibility
        setTimeout(() => {
            const badgeElement = document.getElementById("tusim-cart-badge");
            if (badgeElement) {
                badgeElement.style.visibility = "visible";
                badgeElement.style.display = "block";
                log("[TuSim:Cart] Cart badge visibility forced");
            } else {
                error("[TuSim:Cart] Cart badge not found after creation");
            }
        }, 100);
    }

    function updateCartBadge(count) {
        const badge = document.getElementById("tusim-cart-badge");
        if (badge) {
            const cart = getCart();
            const productCount = cart.items.filter(
                (item) => item.type !== "shipping",
            ).length;
            const countEl = badge.querySelector(".tusim-cart-count");
            countEl.textContent = productCount;
            if (productCount > 0) {
                countEl.classList.add("visible");
            } else {
                countEl.classList.remove("visible");
            }
            log("[TuSim:Cart] Badge updated", { productCount, totalItems: count });
        }
    }

    function openCartModal() {
        log("[TuSim:Cart] Opening cart modal");

        // Remove existing cart modal if any
        const existing = document.getElementById("tusim-cart-modal");
        if (existing) existing.remove();

        const cart = getCart();

        const overlay = document.createElement("div");
        overlay.id = "tusim-cart-modal";
        overlay.innerHTML = `
      <div class="tusim-cart-container">
        <div class="tusim-cart-header">
          <h2>${T[LANG].yourCart} ${cart.items.filter((item) => item.type !== "shipping").length > 0
                ? `(${cart.items.filter((item) => item.type !== "shipping").length})`
                : ""
            }</h2>
          <button class="tusim-close-btn" data-action="close">&times;</button>
        </div>
        
        <div class="tusim-cart-items">
          ${(() => {
                const productItems = cart.items.filter(
                    (item) => item.type !== "shipping",
                );
                return productItems.length === 0
                    ? `<p class="tusim-empty-cart">${T[LANG].cartEmpty}<br><small>${T[LANG].addProductsContinue}</small></p>`
                    : productItems
                        .map(
                            (item) => `
                        <div class="tusim-cart-item" data-item-id="${item.id}">
                          <div class="tusim-item-details">
                            <h3>${item.shopifyProduct
                                    ? item.shopifyProduct.title
                                    : item.plan.name
                                }</h3>
                            <p class="tusim-item-meta">
                              ${item.plan?.duration || ""} • 
                              ${item.shopifyData?.simType === "esim"
                                    ? "eSIM"
                                    : item.shopifyData?.simType === "physical"
                                        ? "SIM Física"
                                        : ""
                                } • 
                              ${T[LANG].quantity}: ${item.quantity}
                            </p>
                            ${item.plan?.coverage
                                    ? `<p class="tusim-item-coverage">${item.plan.coverage}</p>`
                                    : ""
                                }
                          </div>
                          <div class="tusim-item-right">
                            <div class="priceContainer">
                              <div class="tusim-item-price">${window.formatCurrency(
                                    (item.price || 0) * item.quantity)}
                              </div>
                              <span>${window.isAssistCardBR ? "BRL" : "USD"}</span>
                            </div>
                            <button class="tusim-remove-item" data-action="remove" data-item-id="${item.id
                                }" title="${T[LANG].remove}">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      `,
                        )
                        .join("");
            })()}
        </div>
        
        ${cart.items.length > 0
                ? (() => {
                    const productItems = cart.items.filter(
                        (item) => item.type !== "shipping",
                    );
                    const shippingItem = cart.items.find(
                        (item) => item.type === "shipping",
                    );
                    const subtotal = productItems.reduce(
                        (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                        0,
                    );
                    const shipping =
                        shippingItem && !shippingItem.pending
                            ? (shippingItem.price || 0) * (shippingItem.quantity || 1)
                            : 0;
                    const shippingPending = shippingItem && shippingItem.pending;
                    const discount = cart.discount || 0;
                    const discountN = cart.discountN || 0;
                    const total = subtotal + shipping - discount - discountN;
                    return `
          <div class="tusim-cart-footer">
            <div class="tusim-cart-summary">
              <div class="tusim-cart-subtotal">
                <span>${T[LANG].subtotal}</span>
                <span>${window.formatCurrency(subtotal)}</span>
              </div>
              ${discount > 0
                            ? `<div class="tusim-cart-discount">
                <span>${T[LANG].discount2x1}</span>
                <span class="tusim-discount-text">-${window.formatCurrency(discount)}</span>
              </div>`
                            : ""
                        }
              ${discountN > 0
                            ? `<div class="tusim-cart-discount">
                <span>${T[LANG].discountLabel} ${getNPromotionPercentage()}%:</span>
                <span class="tusim-discount-text">-${window.formatCurrency(discountN)}</span>
              </div>`
                            : ""
                        }
              <div class="tusim-cart-shipping">
                <span>${T[LANG].shipping}</span>
                <span class="${shippingPending ? "tusim-shipping-pending" : shipping === 0 ? "tusim-free-shipping-text" : ""}">${shippingPending
                            ? (T[LANG].pending)
                            : shipping === 0
                                ? (T[LANG].free)
                                : `${window.formatCurrency(shipping)}`
                        }</span>
              </div>
              <div class="tusim-cart-total">
                <span>${T[LANG].total}</span>
                <strong>${window.formatCurrency(total)}</strong>
              </div>
            </div>
            <div class="tusim-cart-actions">
              <button class="tusim-continue-shopping" data-action="continue">${T[LANG].continueShopping}</button>
              <button class="tusim-checkout-button" data-action="checkout">${T[LANG].checkout}</button>
            </div>
          </div>
        `;
                })()
                : ""
            }
      </div>
      
      <style>
        #tusim-cart-modal {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: rgba(0, 0, 0, 0.48) !important;
          backdrop-filter: blur(4px) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 999999 !important;
          padding: 20px !important;
          animation: fadeIn 0.15s ease-out !important;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .tusim-cart-container {
          background: #ffffff !important;
          border-radius: 12px !important;
          max-width: 480px !important;
          width: 100% !important;
          max-height: 90vh !important;
          display: flex !important;
          flex-direction: column !important;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.08) !important;
          animation: slideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(16px) scale(0.98);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }
        
        .tusim-cart-header {
          padding: 20px 24px !important;
          border-bottom: 1px solid #e3e8ef !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          background: #fafbfc !important;
          border-radius: 12px 12px 0 0 !important;
        }
        
        .tusim-cart-header h2 {
          margin: 0 !important;
          font-size: 20px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          letter-spacing: -0.02em !important;
        }
        
        .tusim-close-btn {
          background: transparent !important;
          border: none !important;
          font-size: 24px !important;
          color: #8898aa !important;
          cursor: pointer !important;
          padding: 4px !important;
          width: 28px !important;
          height: 28px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 6px !important;
          transition: all 0.15s ease !important;
        }
        
        .tusim-close-btn:hover {
          background: #f0f4f8 !important;
          color: #0a2540 !important;
        }
        
        .tusim-cart-items {
          flex: 1 !important;
          overflow-y: auto !important;
          padding: 20px 24px !important;
        }
        
        .tusim-empty-cart {
          text-align: center !important;
          color: #697386 !important;
          padding: 60px 20px !important;
          font-size: 15px !important;
          line-height: 1.5 !important;
        }
        
        .tusim-empty-cart small {
          display: block !important;
          margin-top: 8px !important;
          font-size: 14px !important;
          color: #8898aa !important;
        }
        
        .tusim-cart-item {
          background: #fafbfc !important;
          border: 1px solid #e3e8ef !important;
          border-radius: 8px !important;
          padding: 16px !important;
          margin-bottom: 12px !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 16px !important;
          transition: all 0.15s ease !important;
        }
        
        .tusim-cart-item:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
          border-color: #cbd6e2 !important;
        }
        
        .tusim-item-details {
          flex: 1 !important;
        }
        
        .tusim-item-details h3 {
          margin: 0 0 6px 0 !important;
          font-size: 15px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-item-meta {
          margin: 0 0 8px 0 !important;
          font-size: 13px !important;
          color: #697386 !important;
          line-height: 1.4 !important;
        }
        
        .tusim-item-planid {
          margin: 8px 0 0 0 !important;
          font-size: 11px !important;
          color: #635bff !important;
          font-weight: 600 !important;
          background: #f6f9fc !important;
          padding: 4px 10px !important;
          border-radius: 6px !important;
          display: inline-block !important;
          border: 1px solid #e3e8ef !important;
        }
        
        .tusim-item-coverage {
          margin: 6px 0 0 0 !important;
          font-size: 12px !important;
          color: #8898aa !important;
        }
        
        .tusim-item-right {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-end !important;
          gap: 8px !important;
        }
        
        .tusim-item-price {
          font-size: 17px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-remove-item {
          background: transparent !important;
          border: none !important;
          color: #ff5b5b !important;
          cursor: pointer !important;
          padding: 6px !important;
          border-radius: 6px !important;
          transition: all 0.15s ease !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        
        .tusim-remove-item:hover {
          background: #fff5f5 !important;
          color: #ff0000 !important;
        }
        
        .tusim-shipping-item {
          background: #f7f9fc !important;
          border-left: 3px solid #00d4aa !important;
        }
        
        .tusim-shipping-item .tusim-item-details h3 {
          color: #00d4aa !important;
        }
        
        .tusim-shipping-item:hover {
          background: #f0f4f8 !important;
        }
        
        .tusim-cart-footer {
          padding: 20px 24px !important;
          border-top: 1px solid #e3e8ef !important;
          background: #fafbfc !important;
          border-radius: 0 0 12px 12px !important;
        }
        
        .tusim-cart-summary {
          margin-bottom: 16px !important;
        }
        
        .tusim-cart-subtotal,
        .tusim-cart-shipping {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 8px 0 !important;
          font-size: 15px !important;
          color: #697386 !important;
        }
        
        .tusim-cart-total {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          margin-top: 12px !important;
          padding-top: 12px !important;
          border-top: 1px solid #e3e8ef !important;
        }
        
        .tusim-cart-total span {
          color: #0a2540 !important;
          font-size: 16px !important;
          font-weight: 600 !important;
        }
        
        .tusim-cart-total strong {
          color: #0a2540 !important;
          font-size: 18px !important;
          font-weight: 700 !important;
        }
        
        .tusim-free-shipping-text {
          color: #00d4aa !important;
          font-weight: 600 !important;
        }
        
        .tusim-free-shipping {
          color: #00d4aa !important;
          font-weight: 600 !important;
        }
        
        .tusim-cart-total strong {
          font-size: 28px !important;
          color: #0a2540 !important;
          font-weight: 700 !important;
          letter-spacing: -0.02em !important;
        }
        
        .tusim-cart-actions {
          display: flex !important;
          gap: 10px !important;
        }
        
        .tusim-continue-shopping {
          flex: 1 !important;
          padding: 14px 20px !important;
          background: #ffffff !important;
          color: #0a2540 !important;
          border: 1px solid #cbd6e2 !important;
          border-radius: 6px !important;
          font-size: 15px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-continue-shopping:hover {
          background: #f6f9fc !important;
          border-color: #a3acb9 !important;
        }
        
        .tusim-checkout-button {
          flex: 2 !important;
          padding: 14px 20px !important;
          background: #635bff !important;
          color: #ffffff !important;
          border: none !important;
          border-radius: 6px !important;
          font-size: 15px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          letter-spacing: -0.01em !important;
          box-shadow: 0 2px 8px rgba(99, 91, 255, 0.24) !important;
        }
        
        .tusim-checkout-button:hover {
          background: #5651e0 !important;
          box-shadow: 0 4px 12px rgba(99, 91, 255, 0.32) !important;
          transform: translateY(-1px) !important;
        }
        
        .tusim-checkout-button:active {
          transform: translateY(0) !important;
        }
        
        @media (max-width: 640px) {
          .tusim-cart-container {
            max-height: 95vh !important;
          }
          
          .tusim-cart-header {
            padding: 16px 20px !important;
          }
          
          .tusim-cart-header h2 {
            font-size: 18px !important;
          }
          
          .tusim-cart-actions {
            flex-direction: column !important;
          }
          
          .tusim-continue-shopping,
          .tusim-checkout-button {
            flex: 1 !important;
          }
        }
        #tusim-cart-modal .priceContainer{
          display: flex;
          gap: 5px;
          flex-wrap: nowrap;
          flex-direction: row;
        }
        #tusim-cart-modal .priceContainer span{
          color: #0a2540;
        }
      </style>
    `;

        document.body.appendChild(overlay);
        attachCartModalListeners(overlay);
    }

    function attachCartModalListeners(overlay) {
        // Close button
        const closeBtn = overlay.querySelector('[data-action="close"]');
        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                log("[TuSim:Cart] Closing cart modal");
                overlay.remove();
            });
        }

        // Click outside to close
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) {
                log("[TuSim:Cart] Closing cart modal (clicked outside)");
                overlay.remove();
            }
        });

        // Remove item buttons
        const removeButtons = overlay.querySelectorAll('[data-action="remove"]');
        removeButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.stopPropagation();
                const itemId = parseFloat(btn.getAttribute("data-item-id"));
                log("[TuSim:Cart] Removing item", { itemId });

                const updatedCart = removeFromCart(itemId);
                updateCartBadge(updatedCart.items.length);

                // Refresh the modal
                overlay.remove();
                openCartModal();
            });
        });

        // Continue shopping button
        const continueBtn = overlay.querySelector('[data-action="continue"]');
        if (continueBtn) {
            continueBtn.addEventListener("click", () => {
                log("[TuSim:Cart] Continue shopping clicked");
                overlay.remove();
            });
        }

        // Checkout button
        const checkoutBtn = overlay.querySelector('[data-action="checkout"]');
        if (checkoutBtn) {
            checkoutBtn.addEventListener("click", async () => {
                log("[TuSim:Cart] Checkout clicked");
                const cart = getCart();

                if (cart.items.length === 0) {
                    alert("Tu carrito está vacío");
                    return;
                }

                overlay.remove();
                showClientForm(cart.items);
            });
        }
    }

    async function loadPseBanks() {
        try {
            log("[TuSim:PSE] Loading PSE banks");

            const banksData = await app.service("mercadopago-pse-banks").find();
            const banks = banksData.data || banksData || [];

            const bankSelect = document.getElementById("tusim-pse-bank-select");
            if (bankSelect) {
                bankSelect.innerHTML = '<option value="">Selecciona tu banco</option>';
                banks.forEach((bank) => {
                    const option = document.createElement("option");
                    option.value = bank.id;
                    option.textContent = bank.description;
                    bankSelect.appendChild(option);
                });
                log("[TuSim:PSE] PSE banks loaded successfully", {
                    count: banks.length,
                });

                // Update submit button after banks are loaded
                updateSubmitButton();
            }
        } catch (err) {
            error("[TuSim:PSE] Error loading PSE banks", err);
            const bankSelect = document.getElementById("tusim-pse-bank-select");
            if (bankSelect) {
                bankSelect.innerHTML =
                    '<option value="">Error al cargar bancos</option>';
            }
            updateSubmitButton();
        }
    }

    async function showClientForm(shopifyDataOrCartItems, planId, plan) {
        // Detect if we're on a landing page based on partner name
        // Landing pages have a partner (AssistCard, ViajesExito, etc.) and use Stripe only
        // Product pages (web) don't have a partner and use Stripe for cards, MercadoPago for PSE/Efecty
        isLandingPage = !!TUSIM_CONFIG.partnerName;

        log("[TuSim:Form] Showing client form", {
            isLandingPage,
            partnerName: TUSIM_CONFIG.partnerName,
            paymentMethod: isLandingPage
                ? "Stripe"
                : "Stripe (Tarjeta) / MercadoPago (PSE/Efecty)",
        });

        // Support both single item and multiple items from cart
        const isCartCheckout = Array.isArray(shopifyDataOrCartItems);
        let cartItems = isCartCheckout ? shopifyDataOrCartItems : [];
        let singleItem = !isCartCheckout
            ? { shopifyData: shopifyDataOrCartItems, planId, plan }
            : null;

        // Check if there are physical SIMs
        const hasPhysicalSim = isCartCheckout
            ? cartItems.some(
                (item) => item.shopifyData && item.shopifyData.simType === "physical",
            )
            : singleItem?.shopifyData?.simType === "physical";

        // Calculate subtotal (products only, excluding shipping)
        const subtotal = isCartCheckout
            ? cartItems
                .filter((item) => item.type !== "shipping")
                .reduce(
                    (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                    0,
                )
            : plan?.price || 0;

        const discount2x1 = isCartCheckout ? calculate2x1Discount(cartItems) : 0;
        const discountN = isCartCheckout ? calculateNDiscount(subtotal, discount2x1) : 0;

        // Initial total (subtotal - discounts + free shipping)
        const total = subtotal - discount2x1 - discountN;

        log("[TuSim:Form] Showing client form", {
            isCartCheckout,
            itemsCount: isCartCheckout ? cartItems.length : 1,
            total,
        });

        const existingOverlay = document.getElementById("tusim-overlay");
        if (existingOverlay) {
            log("[TuSim:Form] Removing existing overlay");
            existingOverlay.remove();
        }

        const overlay = document.createElement("div");
        overlay.id = "tusim-overlay";
        overlay.innerHTML = `
      <div class="tusim-modal">
        <div class="tusim-checkout-header">
          <h2>${T[LANG].checkout}</h2>
          <button type="button" class="tusim-close-btn" id="tusim-cancel" data-tusim-internal="true">&times;</button>
        </div>
        
        ${isCartCheckout
                ? `
        <div class="tusim-order-summary" data-original-total="${(subtotal - discount2x1 - discountN).toFixed(
                    2,
                )}">
          <div class="tusim-summary-total-only">
            <div class="tusim-summary-breakdown">
              <div class="tusim-summary-row">
                <span>Subtotal - ${cartItems.filter((item) => item.type !== "shipping").length} ${T[LANG].items}</span>
                <span>${window.formatCurrency(subtotal)}</span>
              </div>
              ${discount2x1 > 0
                    ? `<div class="tusim-summary-row tusim-cart-discount">
                <span>${T[LANG].discount2x1}</span>
                <span class="tusim-discount-text">-${window.formatCurrency(discount2x1)}</span>
              </div>`
                    : ""
                }
              ${discountN > 0
                    ? `<div class="tusim-summary-row tusim-cart-discount">
                <span>${T[LANG].discountLabel} ${getNPromotionPercentage()}%:</span>
                <span class="tusim-discount-text">-${window.formatCurrency(discountN)}</span>
              </div>`
                    : ""
                }
              ${hasPhysicalSim
                    ? (() => {
                        const shippingItem = cartItems.find(
                            (item) => item.type === "shipping",
                        );
                        const shippingPending =
                            shippingItem && shippingItem.pending;
                        const shippingPrice =
                            shippingItem && !shippingPending
                                ? (shippingItem.price || 0) *
                                (shippingItem.quantity || 1)
                                : 0;
                        return `
                        <div class="tusim-summary-row tusim-shipping-row">
                          <span>${T[LANG].shipping}</span>
                          <span class="tusim-shipping-amount ${shippingPending ? "tusim-shipping-pending" : shippingPrice === 0 ? "tusim-free-shipping-text" : ""}" id="tusim-shipping-display">${shippingPending
                                ? (T[LANG].pending)
                                : shippingPrice === 0
                                    ? (T[LANG].free)
                                    : `${window.formatCurrency(shippingPrice)}`
                            }</span>
                        </div>
                      `;
                    })()
                    : ""
                }
              <div class="tusim-summary-total">
                <span class="tusim-total-label">${T[LANG].total}</span>
                <strong class="tusim-total-amount" id="tusim-total-display">${(() => {
                    const shippingItem = cartItems.find(
                        (item) => item.type === "shipping",
                    );
                    const shippingPrice =
                        shippingItem && !shippingItem.pending
                            ? (shippingItem.price || 0) * (shippingItem.quantity || 1)
                            : 0;
                    const computedTotal = subtotal + shippingPrice - discount2x1 - discountN;
                    return window.formatCurrency(computedTotal);
                })()}</strong>
              </div>
            </div>
          </div>
        </div>
        `
                : plan
                    ? `
        <div class="tusim-order-summary" data-original-price="${plan.price ? plan.price.toFixed(2) : "0.00"
                    }">
          <h3>${T[LANG].orderSummary}</h3>
          <div class="tusim-summary-card">
            <div class="tusim-plan-details">
              <div class="tusim-plan-name">${plan.name}</div>
              <div class="tusim-plan-info">
                <span>${plan.duration} ${T[LANG].dias}</span>
                ${plan.data ? `<span>•</span><span>${plan.data}</span>` : ""}
                <span>•</span>
                <span>${shopifyDataOrCartItems.simType === "esim"
                        ? "eSIM"
                        : (T[LANG].physicalSim)
                    }</span>
              </div>
            </div>
            <div class="tusim-plan-price" data-original-price="${plan.price ? plan.price.toFixed(2) : "0.00"
                    }">${window.formatCurrency(plan.price || 0)}</div>
          </div>
        </div>
        `
                    : ""
            }

        <form id="tusim-client-form">
          <h3>${T[LANG].customerDetails}</h3>
          
          <div class="tusim-form-row">
            <div class="tusim-form-group">
              <label>${T[LANG].firstName}</label>
              <input type="text" name="firstName" placeholder="${T[LANG].firstNamePlaceholder}" required>
            </div>
            <div class="tusim-form-group">
              <label>${T[LANG].lastName}</label>
              <input type="text" name="lastName" placeholder="${T[LANG].lastNamePlaceholder}" required>
            </div>
          </div>
          
          <div class="tusim-form-group">
            <label>Email *</label>
            <input type="email" name="email" placeholder="${T[LANG].emailPlaceholder}" required>
          </div>
          
          <div class="tusim-form-row">
            <div class="tusim-form-group">
              <label>${T[LANG].phone}</label>
              <input type="tel" id="tusim-phone-input" name="phone" placeholder="${T[LANG].phonePlaceholder}" required>
              <div id="tusim-phone-error" style="color: #ef4444; font-size: 12px; margin-top: 4px; display: none;"></div>
            </div>
            <div class="tusim-form-group">
              <label>${T[LANG].idLabel}</label>
              <input type="text" name="dni" placeholder="123456789" required>
            </div>
          </div>
          
          ${hasPhysicalSim
                ? `
          <div class="tusim-shipping-section">
            <h3>${T[LANG].shippingAddressLabel}</h3>
            <div class="tusim-form-group">
              <label>${T[LANG].country}</label>
              <select id="tusim-shipping-country" name="shippingCountry" required style="padding: 10px 12px; border: 1px solid #cbd6e2; border-radius: 6px; font-size: 15px; color: #0a2540; background: #ffffff; width: 100%;">
                <option value="">${T[LANG].selectCountry}</option>
                <option value="US">Estados Unidos</option>
                <option value="MX">México</option>
                <option value="CO">Colombia</option>
                <option value="CA">Canadá</option>
                <option value="ES">España</option>
                <option value="FR">Francia</option>
                <option value="IT">Italia</option>
                <option value="DE">Alemania</option>
                <option value="GB">Reino Unido</option>
                <option value="BR">Brasil</option>
                <option value="AR">Argentina</option>
                <option value="CL">Chile</option>
                <option value="PE">Perú</option>
                <option value="DO">República Dominicana</option>
                <option value="EC">Ecuador</option>
                <option value="PA">Panamá</option>
                <option value="CR">Costa Rica</option>
                <option value="GT">Guatemala</option>
                <option value="HN">Honduras</option>
                <option value="NI">Nicaragua</option>
                <option value="SV">El Salvador</option>
                <option value="UY">Uruguay</option>
                <option value="PY">Paraguay</option>
                <option value="BO">Bolivia</option>
                <option value="VE">Venezuela</option>
                <option value="PT">Portugal</option>
                <option value="NL">Países Bajos</option>
                <option value="BE">Bélgica</option>
                <option value="CH">Suiza</option>
                <option value="AT">Austria</option>
                <option value="SE">Suecia</option>
                <option value="NO">Noruega</option>
                <option value="DK">Dinamarca</option>
                <option value="FI">Finlandia</option>
                <option value="PL">Polonia</option>
                <option value="CZ">República Checa</option>
                <option value="GR">Grecia</option>
                <option value="IE">Irlanda</option>
                <option value="AU">Australia</option>
                <option value="NZ">Nueva Zelanda</option>
                <option value="JP">Japón</option>
                <option value="KR">Corea del Sur</option>
                <option value="CN">China</option>
                <option value="IN">India</option>
                <option value="TH">Tailandia</option>
                <option value="SG">Singapur</option>
                <option value="MY">Malasia</option>
                <option value="PH">Filipinas</option>
                <option value="ID">Indonesia</option>
                <option value="VN">Vietnam</option>
                <option value="AE">Emiratos Árabes Unidos</option>
                <option value="SA">Arabia Saudí</option>
                <option value="IL">Israel</option>
                <option value="TR">Turquía</option>
                <option value="EG">Egipto</option>
                <option value="ZA">Sudáfrica</option>
              </select>
            </div>
            <div class="tusim-form-group">
              <label>${T[LANG].address}</label>
              <input type="text" name="shippingAddress" placeholder="${T[LANG].addressPlaceholder}" required>
            </div>
            <div class="tusim-form-row">
              <div class="tusim-form-group">
                <label>${T[LANG].city}</label>
                <input type="text" name="shippingCity" placeholder="${T[LANG].cityPlaceholder}" required>
              </div>
              <div class="tusim-form-group">
                <label>${T[LANG].department}</label>
                <input type="text" name="shippingDepartment" placeholder="${T[LANG].departmentPlaceholder}" required>
              </div>
            </div>
          </div>
          <style>
            .tusim-shipping-section {
              margin-top: 24px !important;
              padding-top: 24px !important;
              border-top: 1px solid #e3e8ef !important;
            }
            .tusim-shipping-section h3 {
              margin: 0 0 16px 0 !important;
              font-size: 18px !important;
              font-weight: 600 !important;
              color: #0a2540 !important;
            }
          </style>
          `
                : ""
            }
          
          ${isLandingPage
                ? `
          <div class="tusim-form-group">
            <label>${T[LANG].paymentInfo}</label>
            <div id="tusim-stripe-card-element" style="padding: 12px 14px; border: 1px solid #cbd6e2; border-radius: 6px; background: #ffffff; transition: all 0.15s ease;"></div>
            <div id="tusim-stripe-card-error" role="alert" style="color: #ef4444; font-size: 14px; margin-top: 8px; display: none;"></div>
            <p style="margin-top: 8px; font-size: 13px; color: #697386; line-height: 1.4;">
              ${T[LANG].paymentDesc}
            </p>
          </div>
          `
                : `
          <div class="tusim-form-group">
            <label>${T[LANG].paymentMethod}</label>
              <select id="tusim-payment-method" name="paymentMethod" required style="padding: 10px 12px; border: 1px solid #cbd6e2; border-radius: 6px; font-size: 15px; color: #0a2540; background: #ffffff; width: 100%;">
              ${LANG !== "en" && LANG !== "br" ? `<option value="">${T[LANG].selectPaymentMethod}</option>` : ''}
              <option value="credit_card">${T[LANG].creditCard}</option>
              ${LANG !== "en" && LANG !== "br" ? `
              //here payment 
              <option value="efecty">${T[LANG].efectyPayment}</option>
              ` : ''}
            </select>
          </div>
          
          <div id="tusim-credit-card-fields" class="tusim-form-group" style="display: none;">
            <label>${T[LANG].paymentInfo}</label>
            <div id="tusim-stripe-card-element" style="padding: 12px 14px; border: 1px solid #cbd6e2; border-radius: 6px; background: #ffffff; transition: all 0.15s ease;"></div>
            <div id="tusim-stripe-card-error" role="alert" style="color: #ef4444; font-size: 14px; margin-top: 8px; display: none;"></div>
            <p style="margin-top: 8px; font-size: 13px; color: #697386; line-height: 1.4;">
              ${T[LANG].paymentDesc}
            </p>
          </div>
          
          <div id="tusim-pse-fields" class="tusim-form-group" style="display: none;">
            <label>${T[LANG].pseBank}</label>
            <select id="tusim-pse-bank-select" name="pseBank" style="padding: 10px 12px; border: 1px solid #cbd6e2; border-radius: 6px; font-size: 15px; color: #0a2540; background: #ffffff; width: 100%; margin-bottom: 12px;">
              <option value="">${T[LANG].loadingBanks}</option>
            </select>
            
            <label>${T[LANG].idType}</label>
            <select id="tusim-pse-type-id" name="pseTypeId" style="padding: 10px 12px; border: 1px solid #cbd6e2; border-radius: 6px; font-size: 15px; color: #0a2540; background: #ffffff; width: 100%;">
              <option value="">${T[LANG].selectIdType}</option>
              <option value="CC">${T[LANG].cc}</option>
              <option value="CE">${T[LANG].ce}</option>
              <option value="NIT">NIT</option>
              <option value="PP">${T[LANG].passport}</option>
            </select>
          </div>
          
          <div id="tusim-efecty-fields" class="tusim-form-group" style="display: none;">
            <label>${T[LANG].idType}</label>
            <select id="tusim-efecty-type-id" name="efectyTypeId" style="padding: 10px 12px; border: 1px solid #cbd6e2; border-radius: 6px; font-size: 15px; color: #0a2540; background: #ffffff; width: 100%;">
              <option value="">${T[LANG].selectIdType}</option>
              <option value="CC">${T[LANG].cc}</option>
              <option value="CE">${T[LANG].ce}</option>
              <option value="NIT">NIT</option>
              <option value="PP">${T[LANG].passport}</option>
            </select>
          </div>
          `
            }

          <div class="tusim-form-group">
            <label>${T[LANG].discountCode}</label>
            <div style="display: flex; gap: 8px;">
              <input
                type="text"
                id="tusim-discount-code"
                name="discountCode"
                placeholder="${T[LANG].discountPlaceholder}"
                style="flex: 1; text-transform: uppercase;"
              />
              <button
                type="button"
                id="tusim-apply-discount"
                data-tusim-internal="true"
                style="
                  background-color: #552387;
                  color: white;
                  border: none;
                  padding: 10px 20px;
                  border-radius: 4px;
                  cursor: pointer;
                  white-space: nowrap;
                  font-size: 14px;
                  font-weight: 500;
                "
              >
                ${T[LANG].apply}
              </button>
            </div>
            <div
              id="tusim-discount-message"
              style="margin-top: 8px; font-size: 14px; display: none;"
            ></div>
          </div>
          
          <div class="tusim-form-actions">
            <button type="submit" id="tusim-submit-btn" data-tusim-internal="true" class="tusim-submit-button" disabled>
              ${plan
                ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                : (T[LANG].continuePayment)
            }
            </button>
          </div>
        </form>
        <div id="tusim-error" style="display:none;" class="tusim-error-message"></div>
      </div>
      <style>
        #tusim-overlay {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: rgba(0, 0, 0, 0.48) !important;
          backdrop-filter: blur(4px) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 999999 !important;
          visibility: visible !important;
          opacity: 1 !important;
          padding: 20px !important;
          animation: fadeIn 0.15s ease-out !important;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .tusim-modal {
          background: #ffffff !important;
          border-radius: 12px !important;
          max-width: 520px !important;
          width: 100% !important;
          max-height: 90vh !important;
          overflow-y: auto !important;
          position: relative !important;
          z-index: 1000000 !important;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.08) !important;
          animation: slideUp 0.2s cubic-bezier(0.16, 1, 0.3, 1) !important;
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(16px) scale(0.98);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }
        
        .tusim-modal-header {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 20px 24px !important;
          border-bottom: 1px solid #e3e8ef !important;
          background: #fafbfc !important;
          border-radius: 12px 12px 0 0 !important;
        }
        
        .tusim-modal-header h2 {
          margin: 0 !important;
          font-size: 20px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          letter-spacing: -0.02em !important;
        }
        
        .tusim-close-btn {
          background: transparent !important;
          border: none !important;
          font-size: 24px !important;
          color: #8898aa !important;
          cursor: pointer !important;
          line-height: 1 !important;
          padding: 4px !important;
          width: 28px !important;
          height: 28px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 6px !important;
          transition: all 0.15s ease !important;
        }
        
        .tusim-close-btn:hover {
          background: #f0f4f8 !important;
          color: #0a2540 !important;
        }
        
        .tusim-order-summary {
          padding: 0 !important;
          background: #f7f9fc !important;
          border-bottom: 1px solid #e3e8ef !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 10 !important;
          width: 100% !important;
          margin: 0 !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
        }
        
        .tusim-order-summary h3 {
          margin: 0 0 10px 0 !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #697386 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        
        .tusim-summary-card {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          background: #ffffff !important;
          padding: 12px !important;
          border-radius: 8px !important;
          border: 1px solid #e3e8ef !important;
          transition: all 0.15s ease !important;
        }
        
        .tusim-summary-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
        }
        
        .tusim-plan-name {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          margin-bottom: 4px !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-plan-info {
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 4px !important;
          font-size: 12px !important;
          color: #697386 !important;
          line-height: 1.3 !important;
        }
        
        .tusim-plan-id-summary {
          color: #635bff !important;
          font-weight: 600 !important;
          font-size: 11px !important;
          background: #f6f9fc !important;
          padding: 3px 8px !important;
          border-radius: 4px !important;
          border: 1px solid #e3e8ef !important;
        }
        
        .tusim-plan-price {
          font-size: 20px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
          letter-spacing: -0.01em !important;
        }
        
        .tusim-summary-card + .tusim-summary-card {
          margin-top: 10px !important;
        }
        
        .tusim-summary-total {
          margin-top: 16px !important;
          padding-top: 16px !important;
          border-top: 1px solid #e3e8ef !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
        }
        
        .tusim-summary-total span {
          font-size: 15px !important;
          color: #697386 !important;
          font-weight: 500 !important;
        }
        
        .tusim-summary-total strong {
          font-size: 28px !important;
          font-weight: 700 !important;
          color: #0a2540 !important;
          letter-spacing: -0.02em !important;
        }
        
        .tusim-summary-breakdown {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          width: 100% !important;
        }
        
        @media (max-width: 768px) {
          .tusim-summary-breakdown {
            gap: 3px !important;
          }
        }
        
        .tusim-summary-row {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          font-size: 13px !important;
          color: #697386 !important;
          line-height: 1.4 !important;
          padding: 2px 0 !important;
        }
        
        .tusim-summary-total {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          margin-top: 6px !important;
          padding-top: 6px !important;
          border-top: 1px solid #e3e8ef !important;
        }
        
        @media (max-width: 768px) {
          .tusim-summary-total {
            margin-top: 4px !important;
            padding-top: 4px !important;
          }
        }
        
        .tusim-summary-total .tusim-total-label {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #0a2540 !important;
        }
        
        .tusim-summary-total .tusim-total-amount {
          font-size: 18px !important;
          font-weight: 700 !important;
          color: #0a2540 !important;
          letter-spacing: -0.01em !important;
        }
        
        @media (max-width: 768px) {
          .tusim-summary-total .tusim-total-label {
            font-size: 13px !important;
          }
          .tusim-summary-total .tusim-total-amount {
            font-size: 16px !important;
          }
        }
        
        .tusim-shipping-amount {
          font-weight: 500 !important;
          color: #697386 !important;
        }
        
        .tusim-free-shipping-text {
          color: #00d4aa !important;
          font-weight: 600 !important;
        }
        
        .tusim-shipping-pending {
          color: #697386 !important;
          font-weight: 500 !important;
          font-style: italic !important;
        }
        
        .tusim-shipping-unavailable {
          color: #dc2626 !important;
          font-weight: 600 !important;
        }
        
        .tusim-summary-total-only {
          background: #ffffff !important;
          padding: 8px 16px !important;
          border-radius: 0 !important;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          border: none !important;
          width: 100% !important;
          box-sizing: border-box !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
        }
        
        @media (max-width: 768px) {
          .tusim-summary-total-only {
            padding: 6px 12px !important;
          }
        }
        
        .tusim-total-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
        }
        
        .tusim-items-count {
          font-size: 13px !important;
          color: #8898aa !important;
        }
        
        .tusim-total-label {
          font-size: 15px !important;
          color: #697386 !important;
          font-weight: 500 !important;
        }
        
        .tusim-total-amount {
          font-size: 28px !important;
          font-weight: 700 !important;
          color: #0a2540 !important;
          letter-spacing: -0.02em !important;
        }
        
        #tusim-client-form {
          padding: 24px !important;
        }
        
        #tusim-client-form h3 {
          margin: 0 0 20px 0 !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #697386 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        
        .tusim-form-row {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 14px !important;
          margin-bottom: 14px !important;
        }
        
        .tusim-form-group {
          margin-bottom: 14px !important;
        }
        
        .tusim-form-group label {
          display: block !important;
          margin-bottom: 8px !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          color: #0a2540 !important;
        }
        
        .tusim-form-group input,
        .tusim-form-group select {
          width: 100% !important;
          padding: 12px 14px !important;
          border: 1px solid #cbd6e2 !important;
          border-radius: 6px !important;
          box-sizing: border-box !important;
          font-size: 15px !important;
          color: #0a2540 !important;
          background: #ffffff !important;
          transition: all 0.15s ease !important;
        }

        .tusim-payment-method-select {
          width: 100% !important;
          padding: 12px 14px !important;
          border: 1px solid #cbd6e2 !important;
          border-radius: 6px !important;
          box-sizing: border-box !important;
          font-size: 15px !important;
          color: #0a2540 !important;
          background: #ffffff !important;
          transition: all 0.15s ease !important;
          cursor: pointer !important;
        }

        .tusim-payment-method-select:hover {
          border-color: #a3acb9 !important;
        }

        .tusim-payment-method-select:focus {
          outline: none !important;
          border-color: #635bff !important;
          box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.08) !important;
        }

        .tusim-payment-section {
          margin-top: 16px !important;
          padding: 16px !important;
          background: #fafbfc !important;
          border-radius: 8px !important;
          border: 1px solid #e3e8ef !important;
        }
        
        .tusim-form-group input::placeholder {
          color: #a3acb9 !important;
        }
        
        .tusim-form-group input:hover {
          border-color: #a3acb9 !important;
        }
        
        .tusim-form-group input:focus {
          outline: none !important;
          border-color: #635bff !important;
          box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.08) !important;
        }
        
        .tusim-empty-card {
          text-align: center !important;
          color: #697386 !important;
          padding: 20px !important;
          font-size: 14px !important;
          margin: 0 !important;
          background: #fafbfc !important;
          border-radius: 6px !important;
          border: 1px solid #e3e8ef !important;
        }
        
        .tusim-add-card-button {
          width: 100% !important;
          margin-top: 12px !important;
          padding: 12px 16px !important;
          background: #ffffff !important;
          border: 1px solid #cbd6e2 !important;
          border-radius: 6px !important;
          cursor: pointer !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #635bff !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          transition: all 0.15s ease !important;
        }
        
        .tusim-add-card-button:hover {
          background: #f6f9fc !important;
          border-color: #635bff !important;
          box-shadow: 0 2px 8px rgba(99, 91, 255, 0.08) !important;
        }
        
        .tusim-add-card-button span:first-child {
          font-size: 18px !important;
        }
        
        .tusim-card-item {
          border: 1px solid #635bff !important;
          border-radius: 6px !important;
          padding: 14px !important;
          margin-bottom: 10px !important;
          background: #fafbfc !important;
        }
        
        .tusim-card-content {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
        }
        
        .tusim-card-icon {
          font-size: 24px !important;
        }
        
        .tusim-card-info {
          flex: 1 !important;
        }
        
        .tusim-card-title {
          font-weight: 600 !important;
          font-size: 14px !important;
          color: #0a2540 !important;
        }
        
        .tusim-card-subtitle {
          font-size: 12px !important;
          color: #697386 !important;
          margin-top: 4px !important;
        }
        
        .tusim-form-actions {
          margin-top: 24px !important;
        }
        
        .tusim-submit-button {
          width: 100% !important;
          padding: 14px 24px !important;
          background: #635bff !important;
          color: #ffffff !important;
          border: none !important;
          border-radius: 6px !important;
          font-size: 15px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          letter-spacing: -0.01em !important;
          box-shadow: 0 2px 8px rgba(99, 91, 255, 0.24) !important;
        }
        
        .tusim-submit-button:hover:not(:disabled) {
          background: #5651e0 !important;
          box-shadow: 0 4px 12px rgba(99, 91, 255, 0.32) !important;
          transform: translateY(-1px) !important;
        }
        
        .tusim-submit-button:active:not(:disabled) {
          transform: translateY(0) !important;
        }
        
        .tusim-submit-button:disabled {
          opacity: 0.5 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }
        
        .tusim-error-message {
          color: #ff5b5b !important;
          margin-top: 16px !important;
          padding: 12px 16px !important;
          background: #fff5f5 !important;
          border: 1px solid #fecaca !important;
          border-radius: 6px !important;
          font-size: 14px !important;
        }
        
        @media (max-width: 640px) {
          .tusim-modal {
            max-width: 100% !important;
            margin: 10px !important;
          }
          
          .tusim-form-row {
            grid-template-columns: 1fr !important;
          }
        }
      </style>
    `;

        log("[TuSim:Form] Appending overlay to body");
        document.body.appendChild(overlay);
        log("[TuSim:Form] Overlay appended, setting up event listeners");

        // Initialize Stripe Elements (only for landing pages)
        if (isLandingPage) {
            try {
                const { stripe, elements } = await initializeStripeElements();
                stripeInstance = stripe;
                stripeElements = elements;

                const cardElementContainer = document.getElementById(
                    "tusim-stripe-card-element",
                );
                if (cardElementContainer && !cardElement) {
                    cardElement = elements.create("card", {
                        style: {
                            base: {
                                fontSize: "15px",
                                color: "#0a2540",
                                fontFamily:
                                    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                                "::placeholder": {
                                    color: "#a3acb9",
                                },
                                iconColor: "#635bff",
                            },
                            invalid: {
                                color: "#ef4444",
                                iconColor: "#ef4444",
                            },
                        },
                        hidePostalCode: false,
                    });

                    cardElement.mount(cardElementContainer);

                    cardElement.on("change", (event) => {
                        const errorElement = document.getElementById(
                            "tusim-stripe-card-error",
                        );
                        const cardElementContainer = document.getElementById(
                            "tusim-stripe-card-element",
                        );

                        cardElementComplete = event.complete && !event.error;

                        if (event.error) {
                            errorElement.textContent = event.error.message;
                            errorElement.style.display = "block";
                            if (cardElementContainer) {
                                cardElementContainer.style.borderColor = "#ef4444";
                                cardElementContainer.style.boxShadow =
                                    "0 0 0 3px rgba(239, 68, 68, 0.08)";
                            }
                            cardElementComplete = false;
                        } else {
                            errorElement.style.display = "none";
                            if (cardElementContainer) {
                                if (event.complete) {
                                    cardElementContainer.style.borderColor = "#10b981";
                                    cardElementContainer.style.boxShadow =
                                        "0 0 0 3px rgba(16, 185, 129, 0.08)";
                                } else {
                                    cardElementContainer.style.borderColor = "#cbd6e2";
                                    cardElementContainer.style.boxShadow = "none";
                                }
                            }
                        }
                        updateSubmitButton();
                    });

                    cardElement.on("focus", () => {
                        const cardElementContainer = document.getElementById(
                            "tusim-stripe-card-element",
                        );
                        if (cardElementContainer) {
                            cardElementContainer.style.borderColor = "#635bff";
                            cardElementContainer.style.boxShadow =
                                "0 0 0 3px rgba(99, 91, 255, 0.08)";
                        }
                    });

                    cardElement.on("blur", () => {
                        const cardElementContainer = document.getElementById(
                            "tusim-stripe-card-element",
                        );
                        if (
                            cardElementContainer &&
                            !cardElementContainer.style.borderColor.includes("#ef4444")
                        ) {
                            cardElementContainer.style.borderColor = "#cbd6e2";
                            cardElementContainer.style.boxShadow = "none";
                        }
                    });

                    log("[TuSim:Stripe] Card element mounted");
                    cardElementComplete = false;
                    updateSubmitButton();
                }
            } catch (err) {
                error("[TuSim:Stripe] Error setting up Stripe card element", err);
                showErrorMessage(
                    "tusim-error",
                    T[LANG].paymentInitError,
                );
            }
        } else {
            // Initialize payment methods for product pages (web)
            // Web: Stripe for cards, MercadoPago for PSE/Efecty
            const paymentMethodSelect = document.getElementById(
                "tusim-payment-method",
            );
            const creditCardFields = document.getElementById(
                "tusim-credit-card-fields",
            );
            const pseFields = document.getElementById("tusim-pse-fields");
            const efectyFields = document.getElementById("tusim-efecty-fields");

            if (paymentMethodSelect) {
                paymentMethodSelect.addEventListener("change", async (e) => {
                    const selectedMethod = e.target.value;

                    // Hide all payment-specific fields and unmount Stripe if mounted
                    if (creditCardFields) creditCardFields.style.display = "none";
                    if (pseFields) pseFields.style.display = "none";
                    if (efectyFields) efectyFields.style.display = "none";

                    // Unmount Stripe card element if switching away from credit card
                    if (cardElement && selectedMethod !== "credit_card") {
                        cardElement.unmount();
                        cardElement = null;
                        cardElementComplete = false;
                        stripeInstance = null;
                        stripeElements = null;
                    }

                    // Show selected payment method fields
                    if (selectedMethod === "credit_card" && creditCardFields) {
                        creditCardFields.style.display = "block";

                        // Initialize Stripe Elements for credit card in web
                        try {
                            const { stripe, elements } = await initializeStripeElements();
                            stripeInstance = stripe;
                            stripeElements = elements;

                            const cardElementContainer = document.getElementById(
                                "tusim-stripe-card-element",
                            );
                            if (cardElementContainer && !cardElement) {
                                cardElement = elements.create("card", {
                                    style: {
                                        base: {
                                            fontSize: "15px",
                                            color: "#0a2540",
                                            fontFamily:
                                                "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                                            "::placeholder": {
                                                color: "#a3acb9",
                                            },
                                            iconColor: "#635bff",
                                        },
                                        invalid: {
                                            color: "#ef4444",
                                            iconColor: "#ef4444",
                                        },
                                    },
                                    hidePostalCode: false,
                                });

                                cardElement.mount(cardElementContainer);

                                cardElement.on("change", (event) => {
                                    const errorElement = document.getElementById(
                                        "tusim-stripe-card-error",
                                    );
                                    const cardElementContainer = document.getElementById(
                                        "tusim-stripe-card-element",
                                    );

                                    cardElementComplete = event.complete && !event.error;

                                    if (event.error) {
                                        errorElement.textContent = event.error.message;
                                        errorElement.style.display = "block";
                                        if (cardElementContainer) {
                                            cardElementContainer.style.borderColor = "#ef4444";
                                            cardElementContainer.style.boxShadow =
                                                "0 0 0 3px rgba(239, 68, 68, 0.08)";
                                        }
                                        cardElementComplete = false;
                                    } else {
                                        errorElement.style.display = "none";
                                        if (cardElementContainer) {
                                            if (event.complete) {
                                                cardElementContainer.style.borderColor = "#10b981";
                                                cardElementContainer.style.boxShadow =
                                                    "0 0 0 3px rgba(16, 185, 129, 0.08)";
                                            } else {
                                                cardElementContainer.style.borderColor = "#cbd6e2";
                                                cardElementContainer.style.boxShadow = "none";
                                            }
                                        }
                                    }
                                    updateSubmitButton();
                                });

                                cardElement.on("focus", () => {
                                    const cardElementContainer = document.getElementById(
                                        "tusim-stripe-card-element",
                                    );
                                    if (cardElementContainer) {
                                        cardElementContainer.style.borderColor = "#635bff";
                                        cardElementContainer.style.boxShadow =
                                            "0 0 0 3px rgba(99, 91, 255, 0.08)";
                                    }
                                });

                                cardElement.on("blur", () => {
                                    const cardElementContainer = document.getElementById(
                                        "tusim-stripe-card-element",
                                    );
                                    if (
                                        cardElementContainer &&
                                        !cardElementContainer.style.borderColor.includes("#ef4444")
                                    ) {
                                        cardElementContainer.style.borderColor = "#cbd6e2";
                                        cardElementContainer.style.boxShadow = "none";
                                    }
                                });

                                log("[TuSim:Stripe] Card element mounted for web");
                                cardElementComplete = false;
                                updateSubmitButton();
                            }
                        } catch (err) {
                            error(
                                "[TuSim:Stripe] Error setting up Stripe card element for web",
                                err,
                            );
                            showErrorMessage(
                                "tusim-error",
                                T[LANG].paymentInitError,
                            );
                        }
                    } else if (selectedMethod === "pse" && pseFields) {
                        pseFields.style.display = "block";
                        await loadPseBanks();
                    } else if (selectedMethod === "efecty" && efectyFields) {
                        efectyFields.style.display = "block";
                    }

                    updateSubmitButton();
                });

                if (window.isRoyalScenic || window.isAssistCardBR) {
                    setTimeout(() => {
                        paymentMethodSelect.dispatchEvent(new Event("change"));
                    }, 100);
                }
            }
        }

        // Force visibility
        setTimeout(() => {
            const overlayEl = document.getElementById("tusim-overlay");
            if (overlayEl) {
                overlayEl.style.display = "flex";
                overlayEl.style.visibility = "visible";
                overlayEl.style.opacity = "1";
                log("[TuSim:Form] Overlay visibility forced");
            }
        }, 100);

        // Initialize phone field with IP-based country detection
        let detectedCountryCode = "CO";
        let currentPhonePrefix = "+57";
        let isPhoneFieldInitialized = false;

        try {
            const phoneInputEl = document.getElementById("tusim-phone-input");
            if (phoneInputEl) {
                // Detect country by IP and set prefix
                detectedCountryCode = await getUserCountryByIP();
                currentPhonePrefix = getPhonePrefixForCountry(detectedCountryCode);

                log("[TuSim:Phone] Setting up phone with IP-based country", {
                    countryCode: detectedCountryCode,
                    prefix: currentPhonePrefix
                });

                // Set initial prefix in the input
                phoneInputEl.value = currentPhonePrefix;
                phoneInputEl.dataset.prefix = currentPhonePrefix;
                phoneInputEl.dataset.countryCode = detectedCountryCode;
                isPhoneFieldInitialized = true;

                // Handle input to ensure prefix stays and validate
                phoneInputEl.addEventListener("input", function () {
                    // Only enforce prefix on empty field or if user cleared everything
                    if (this.value.length === 0 || this.value === "") {
                        this.value = currentPhonePrefix;
                    }

                    // If user deleted the prefix, restore it
                    const currentValue = this.value.trim();
                    if (!currentValue.startsWith(currentPhonePrefix) && currentValue.length > 0) {
                        // Check if it's just missing the prefix (user typed digits directly)
                        if (/^\d/.test(currentValue)) {
                            this.value = currentPhonePrefix + currentValue;
                        }
                    }

                    // Validate phone number (simple validation - at least 7 digits after prefix)
                    const phoneNumber = this.value.replace(currentPhonePrefix, "").replace(/\s/g, "");
                    const errorEl = document.getElementById("tusim-phone-error");

                    if (errorEl) {
                        if (phoneNumber.length > 0 && phoneNumber.length < 7) {
                            errorEl.textContent = T[LANG].validPhone;
                            errorEl.style.display = "block";
                        } else {
                            errorEl.style.display = "none";
                        }
                    }
                    updateSubmitButton();
                });

                // Handle paste event
                phoneInputEl.addEventListener("paste", function (e) {
                    e.preventDefault();
                    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                    const cleaned = pastedText.replace(/[^\d]/g, '');
                    this.value = currentPhonePrefix + cleaned;
                    updateSubmitButton();
                });

                log("[TuSim:Phone] Phone input configured with IP-based country detection");
            }
        } catch (err) {
            error("[TuSim:Phone] Error setting up phone field", err);
        }

        document.getElementById("tusim-cancel")?.addEventListener("click", () => {
            clearDiscountUI();
            if (cardElement) {
                cardElement.unmount();
                cardElement = null;
            }
            cardElementComplete = false;
            if (!isLandingPage) {
                stripeInstance = null;
                stripeElements = null;
            }
            overlay.remove();
        });

        const applyDiscountBtn = document.getElementById("tusim-apply-discount");
        if (applyDiscountBtn) {
            applyDiscountBtn.addEventListener("click", async () => {
                const codeInput = document.getElementById("tusim-discount-code");
                const emailInput = document.querySelector('[name="email"]');
                const phoneInput = document.querySelector('[name="phone"]');

                const code = codeInput?.value?.trim();
                const email = emailInput?.value?.trim();
                const phone = phoneInput?.value?.trim();

                if (!code) {
                    updateDiscountUI(false, "Por favor ingresa un código");
                    return;
                }

                if (!email) {
                    updateDiscountUI(false, "Por favor ingresa tu email primero");
                    return;
                }

                applyDiscountBtn.disabled = true;
                applyDiscountBtn.textContent = T[LANG].validating;

                const validation = await validateDiscountCode(code, email, phone);

                if (validation.valid) {
                    appliedDiscountCode = validation.code;
                    appliedDiscountPercentage = validation.discount_percentage;
                    discountValidationResult = validation;
                    updateDiscountUI(
                        true,
                        `${T[LANG].discountCodeApplied}${validation.code}${T[LANG].discountCodeCorrectly}`,
                        validation.discount_percentage,
                    );
                    log("[TuSim:Discount] Discount code applied", {
                        code: validation.code,
                        percentage: validation.discount_percentage,
                    });
                } else {
                    updateDiscountUI(false, validation.error_message);
                    applyDiscountBtn.disabled = false;
                    applyDiscountBtn.textContent = T[LANG].apply;
                }
            });
        }

        const codeInput = document.getElementById("tusim-discount-code");
        if (codeInput) {
            codeInput.addEventListener("input", (e) => {
                e.target.value = e.target.value.toUpperCase();
            });
        }

        // Add listeners to form fields to update submit button
        const formFields = document.querySelectorAll(
            "#tusim-client-form input[required], #tusim-client-form select[required]",
        );
        formFields.forEach((field) => {
            field.addEventListener("input", updateSubmitButton);
            field.addEventListener("change", updateSubmitButton);
        });

        // Handle shipping country selection for physical SIMs
        if (hasPhysicalSim) {
            const shippingCountrySelect = document.getElementById(
                "tusim-shipping-country",
            );
            if (shippingCountrySelect) {
                shippingCountrySelect.addEventListener("change", async (e) => {
                    const countryCode = e.target.value;
                    if (countryCode) {
                        log("[TuSim:Shipping] Country selected in form", { countryCode });
                        const shippingRate = await getShippingRate(countryCode);

                        const cart = getCart();
                        const shippingItem = getShippingItem(cart);

                        if (shippingItem) {
                            const submitBtn = document.getElementById("tusim-submit-btn");
                            const errorDiv = document.getElementById("tusim-error");

                            if (shippingRate) {
                                shippingItem.country_code = shippingRate.country_code;
                                shippingItem.country_name = shippingRate.country_name;
                                shippingItem.custom_name = shippingRate.custom_name;
                                shippingItem.price = shippingRate.price;
                                shippingItem.pending = false;
                                shippingItem.unavailable = false;

                                // Hide error message if exists
                                if (errorDiv) {
                                    errorDiv.style.display = "none";
                                    errorDiv.textContent = "";
                                }

                                updateSubmitButton();
                            } else {
                                shippingItem.country_code = countryCode;
                                shippingItem.country_name = countryCode;
                                shippingItem.custom_name = "Envío";
                                shippingItem.price = 0;
                                shippingItem.pending = true;
                                shippingItem.unavailable = true;

                                // Show error message
                                if (errorDiv) {
                                    errorDiv.textContent =
                                        "No hay envío disponible para este país. Por favor selecciona otro país.";
                                    errorDiv.style.display = "block";
                                    errorDiv.style.color = "#dc2626";
                                }

                                updateSubmitButton();
                            }

                            cart.items = cart.items.map((item) =>
                                item.id === shippingItem.id ? shippingItem : item,
                            );

                            cart.total = cart.items.reduce(
                                (sum, item) => sum + (item.price || 0) * (item.quantity || 1),
                                0,
                            );

                            localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));

                            // Update display
                            const shippingDisplay = document.getElementById(
                                "tusim-shipping-display",
                            );
                            const totalDisplay = document.getElementById(
                                "tusim-total-display",
                            );

                            if (shippingDisplay && totalDisplay) {
                                if (shippingRate) {
                                    const shippingPrice = shippingItem.price || 0;
                                    const newTotal = subtotal + shippingPrice;

                                    shippingDisplay.textContent =
                                        shippingPrice === 0
                                            ? T[LANG].free
                                            : `${window.formatCurrency(shippingPrice)}`;
                                    shippingDisplay.className =
                                        shippingPrice === 0
                                            ? "tusim-shipping-amount tusim-free-shipping-text"
                                            : "tusim-shipping-amount";

                                    totalDisplay.textContent = `${window.formatCurrency(newTotal)}`;
                                } else {
                                    shippingDisplay.textContent = T[LANG].notAvailable;
                                    shippingDisplay.className =
                                        "tusim-shipping-amount tusim-shipping-unavailable";
                                    totalDisplay.textContent = `${window.formatCurrency(subtotal)}`;
                                }

                                log("[TuSim:Shipping] Shipping price updated", {
                                    countryCode,
                                    shippingPrice: shippingItem.price,
                                    shippingAvailable: !!shippingRate,
                                    newTotal: subtotal + (shippingItem.price || 0),
                                });
                            } else {
                                log("[TuSim:Shipping] Display elements not found", {
                                    shippingDisplay: !!shippingDisplay,
                                    totalDisplay: !!totalDisplay,
                                });
                            }
                        }
                    }
                });

                // Validate shipping on initial load if country is already selected
                if (shippingCountrySelect.value) {
                    const initialCountryCode = shippingCountrySelect.value;
                    const cart = getCart();
                    const shippingItem = getShippingItem(cart);

                    if (shippingItem) {
                        getShippingRate(initialCountryCode).then((shippingRate) => {
                            if (!shippingRate) {
                                shippingItem.pending = true;
                                shippingItem.unavailable = true;
                                shippingItem.price = 0;

                                const errorDiv = document.getElementById("tusim-error");
                                const submitBtn = document.getElementById("tusim-submit-btn");

                                if (errorDiv) {
                                    errorDiv.textContent =
                                        "No hay envío disponible para este país. Por favor selecciona otro país.";
                                    errorDiv.style.display = "block";
                                    errorDiv.style.color = "#dc2626";
                                }

                                if (submitBtn) {
                                    submitBtn.disabled = true;
                                }

                                const shippingDisplay = document.getElementById(
                                    "tusim-shipping-display",
                                );
                                if (shippingDisplay) {
                                    shippingDisplay.textContent = T[LANG].notAvailable;
                                    shippingDisplay.className =
                                        "tusim-shipping-amount tusim-shipping-unavailable";
                                }
                            }
                        });
                    }
                }
            }
        }

        // Also listen to PSE bank select and type ID changes
        const pseBankSelect = document.getElementById("tusim-pse-bank-select");
        const pseTypeIdSelect = document.getElementById("tusim-pse-type-id");
        const efectyTypeIdSelect = document.getElementById("tusim-efecty-type-id");

        if (pseBankSelect) {
            pseBankSelect.addEventListener("change", updateSubmitButton);
        }
        if (pseTypeIdSelect) {
            pseTypeIdSelect.addEventListener("change", updateSubmitButton);
        }
        if (efectyTypeIdSelect) {
            efectyTypeIdSelect.addEventListener("change", updateSubmitButton);
        }

        // Initial button state update
        setTimeout(updateSubmitButton, 100);

        const formElement = document.getElementById("tusim-client-form");
        if (formElement) {
            const handleSubmit = async (e) => {
                e.preventDefault();
                e.stopPropagation();

                const submitBtn = document.getElementById("tusim-submit-btn");
                if (submitBtn && submitBtn.disabled) {
                    log("[TuSim:Form] Submit already in progress, ignoring");
                    return;
                }

                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = T[LANG].processing;
                }

                const formData = new FormData(e.target);

                if (isLandingPage) {
                    if (!cardElement || !stripeInstance) {
                        showErrorMessage(
                            "tusim-error",
                            "Por favor, completa la información de la tarjeta para continuar",
                        );
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = plan
                                ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                                : T[LANG].continuePayment;
                        }
                        return;
                    }

                    if (!cardElementComplete) {
                        showErrorMessage(
                            "tusim-error",
                            "Por favor, completa correctamente todos los datos de la tarjeta",
                        );
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = plan
                                ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                                : T[LANG].continuePayment;
                        }
                        return;
                    }
                } else {
                    // Web: Validate payment method selection
                    const paymentMethod = formData.get("paymentMethod");

                    if (paymentMethod === "credit_card") {
                        // Web: Validate Stripe for credit card
                        if (!cardElement || !stripeInstance) {
                            showErrorMessage(
                                "tusim-error",
                                "Por favor, completa la información de la tarjeta para continuar",
                            );
                            if (submitBtn) {
                                submitBtn.disabled = false;
                                submitBtn.textContent = plan
                                    ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                                    : T[LANG].continuePayment;
                            }
                            return;
                        }

                        if (!cardElementComplete) {
                            showErrorMessage(
                                "tusim-error",
                                "Por favor, completa correctamente todos los datos de la tarjeta",
                            );
                            if (submitBtn) {
                                submitBtn.disabled = false;
                                submitBtn.textContent = plan
                                    ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                                    : T[LANG].continuePayment;
                            }
                            return;
                        }
                    }
                }

                const clientData = {
                    firstName: formData.get("firstName"),
                    lastName: formData.get("lastName"),
                    email: formData.get("email"),
                    phone: formData.get("phone").replace(/\s/g, ""),
                    dni: formData.get("dni"),
                };

                // Process phone with country info (IP-based geolocation)
                const phoneInputEl = document.getElementById("tusim-phone-input");
                if (phoneInputEl) {
                    const countryCode = phoneInputEl.dataset.countryCode || "CO";
                    const prefix = phoneInputEl.dataset.prefix || "+57";
                    const countryName = getCountryFromCode(countryCode);

                    clientData.phoneCountry = countryName;
                    clientData.phoneCountryCode = countryCode;

                    // Clean phone number (remove all spaces)
                    clientData.phone = clientData.phone.replace(/\s/g, "");

                    log("[TuSim:Phone] Phone processed with IP-based country", {
                        phone: clientData.phone,
                        country: countryName,
                        countryCode: countryCode,
                        prefix: prefix,
                    });

                    // Validate phone - at least 7 digits after prefix
                    const phoneNumber = clientData.phone.replace(prefix, "").replace(/\s/g, "");
                    if (phoneNumber.length < 7) {
                        showErrorMessage(
                            "tusim-phone-error",
                            T[LANG].validPhoneAlt,
                        );
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = plan
                                ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                                : T[LANG].continuePayment;
                        }
                        return;
                    }
                }

                const currentCart = getCart();
                const itemsToProcess = isCartCheckout
                    ? currentCart?.items || []
                    : cartItems;

                if (hasPhysicalSim) {
                    const shippingItem = itemsToProcess.find(
                        (item) => item.type === "shipping",
                    );

                    // Validate that shipping is available and configured
                    if (
                        !shippingItem ||
                        shippingItem.pending ||
                        shippingItem.unavailable
                    ) {
                        if (submitBtn) {
                            submitBtn.disabled = true;
                            // Restore button text by calling updateSubmitButtonPrice if it exists
                            if (typeof updateSubmitButtonPrice === "function") {
                                updateSubmitButtonPrice();
                            } else {
                                submitBtn.textContent = T[LANG].continuePayment;
                            }
                        }
                        showErrorMessage(
                            "tusim-error",
                            "No hay envío disponible para el país seleccionado. Por favor selecciona otro país.",
                        );
                        return;
                    }

                    clientData.shipping = {
                        country: formData.get("shippingCountry"),
                        address: formData.get("shippingAddress"),
                        city: formData.get("shippingCity"),
                        department: formData.get("shippingDepartment"),
                        price: shippingItem ? shippingItem.price || 0 : 0,
                        custom_name: shippingItem ? shippingItem.custom_name || null : null,
                    };
                }

                const errorDiv = document.getElementById("tusim-error");
                if (errorDiv) {
                    errorDiv.style.display = "none";
                    errorDiv.textContent = "";
                }

                try {
                    if (isLandingPage) {
                        // Landing pages use Stripe
                        if (isCartCheckout) {
                            await processCartOrderWithStripe(itemsToProcess, clientData);
                            clearCart();
                            updateCartBadge(0);
                        } else {
                            await processOrderWithStripe(
                                singleItem.shopifyData,
                                singleItem.planId,
                                clientData,
                                singleItem.plan,
                            );
                        }
                    } else {
                        // Product pages (web): Stripe for cards, MercadoPago for PSE/Efecty
                        const paymentMethod = formData.get("paymentMethod");

                        if (isCartCheckout) {
                            if (paymentMethod === "credit_card") {
                                // Web: Use Stripe for credit card
                                await processCartOrderWithStripe(itemsToProcess, clientData);
                            } else if (paymentMethod === "pse") {
                                await processCartOrderWithPse(itemsToProcess, clientData);
                            } else if (paymentMethod === "efecty") {
                                await processCartOrderWithEfecty(itemsToProcess, clientData);
                            }
                            clearCart();
                            updateCartBadge(0);
                        } else {
                            if (paymentMethod === "credit_card") {
                                // Web: Use Stripe for credit card
                                await processOrderWithStripe(
                                    singleItem.shopifyData,
                                    singleItem.planId,
                                    clientData,
                                    singleItem.plan,
                                );
                            } else if (paymentMethod === "pse") {
                                await processOrderWithPse(
                                    singleItem.shopifyData,
                                    singleItem.planId,
                                    clientData,
                                    singleItem.plan,
                                );
                            } else if (paymentMethod === "efecty") {
                                await processOrderWithEfecty(
                                    singleItem.shopifyData,
                                    singleItem.planId,
                                    clientData,
                                    singleItem.plan,
                                );
                            }
                        }
                    }

                    const form = e.target;
                    form.reset();

                    if (cardElement) {
                        cardElement.clear();
                        cardElementComplete = false;
                    }

                    // Clean up Stripe instance for web when not landing page
                    if (!isLandingPage && cardElement) {
                        cardElement.unmount();
                        cardElement = null;
                        stripeInstance = null;
                        stripeElements = null;
                    }

                    clearDiscountUI();
                } catch (err) {
                    error("[TuSim:Form] Error processing form", err);
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.textContent = plan
                            ? `${T[LANG].pay} ${window.formatCurrency(plan.price || 0)}`
                            : T[LANG].continuePayment;
                    }
                    const errorDiv = document.getElementById("tusim-error");
                    if (errorDiv) {
                        errorDiv.style.display = "block";
                        errorDiv.textContent =
                            err.message ||
                            T[LANG].processOrderError;
                    }
                }
            };

            formElement.removeEventListener("submit", handleSubmit);
            formElement.addEventListener("submit", handleSubmit);
        }
    }

    async function processOrderWithStripe(
        shopifyData,
        planId,
        clientData,
        plan = null,
    ) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            if (!plan && planId) {
                log("[TuSim:Order] Fetching plan details", { planId });

                plan = await app.service("plans").get(planId, {
                    query: {
                        $client: {
                            filterPrice: "true",
                            organization_id: TUSIM_CONFIG.organizationId,
                        },
                    },
                });

                log("[TuSim:Order] Plan fetched", { plan });
            } else if (plan) {
                log("[TuSim:Order] Using provided plan", {
                    planId: plan.id,
                    price: plan.price,
                    fromShopify: plan.fromShopify,
                });
            }

            if (!plan || !plan.price) {
                throw new Error("El plan no tiene precio configurado");
            }

            const discountedPrice = calculateDiscountedPrice(
                plan.price,
                appliedDiscountPercentage || 0,
            );
            const totalAmount = Math.round(discountedPrice * 100);

            log("[TuSim:Stripe] Creating payment intent", {
                totalAmount,
                originalPrice: plan.price,
                discount: appliedDiscountPercentage,
                discountedPrice,
            });

            let checkoutAmount = totalAmount;
            let checkoutCurrency = "usd";
            if (window.isAssistCardBR) {
                checkoutAmount = Math.round((discountedPrice * window.USD_TO_BRL_RATE) * 100);
                checkoutCurrency = "brl";
            }

            const paymentIntentResponse = await app.service("stripe").create({
                action: "create-payment-intent",
                userId: null,
                amount: checkoutAmount,
                currency: checkoutCurrency,
                email: clientData.email,
                name: `${clientData.firstName} ${clientData.lastName}`,
                metadata: {
                    planId: plan.id,
                    organizationId: TUSIM_CONFIG.organizationId,
                    organizationBranchId: TUSIM_CONFIG.organizationBranchId,
                },
            });

            paymentIntentClientSecret = paymentIntentResponse.client_secret;
            log("[TuSim:Stripe] Payment intent created", {
                clientSecret: paymentIntentClientSecret,
            });

            log("[TuSim:Stripe] Confirming payment with card element");

            const { error: confirmError, paymentIntent } =
                await stripeInstance.confirmCardPayment(paymentIntentClientSecret, {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: `${clientData.firstName} ${clientData.lastName}`,
                            email: clientData.email,
                            phone: clientData.phone,
                        },
                    },
                });

            if (confirmError) {
                log("[TuSim:Stripe] Payment confirmation error", confirmError);

                const orderItem = {
                    id: `shopify-${Date.now()}`,
                    simType: shopifyData.simType,
                    plan: {
                        id: plan.id || null,
                        price: parseFloat(plan.price) || 0,
                        price_cop:
                            parseFloat(plan.price_cop) ||
                            parseFloat(plan.price) * 3719.71 ||
                            0,
                        fromShopify: plan.fromShopify || false,
                    },
                    quantity: shopifyData.quantity,
                    clientDetails: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        email: clientData.email,
                        phone: clientData.phone,
                        activationDate: getActivationDate(shopifyData.travelDate),
                        travelStartDate: shopifyData.travelDate,
                    },
                    discount: appliedDiscountPercentage || 0,
                };

                const failedPayload = {
                    payment_method: "stripe",
                    organization_id: TUSIM_CONFIG.organizationId,
                    organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                    order_items: [orderItem],
                    integration_order_id: `shopify-${Date.now()}`,
                    discount_code: appliedDiscountCode || null,
                    partner_name: TUSIM_CONFIG.partnerName || null,
                    landing_url: window.TuSimLandingUrl || null,
                    stripe_payment_error: {
                        code: confirmError.code || "card_declined",
                        decline_code: confirmError.decline_code || null,
                        message: confirmError.message || T[LANG].processPaymentError,
                        type: confirmError.type || "card_error",
                    },
                    billing_dni: clientData.dni,
                    billing_name: `${clientData.firstName} ${clientData.lastName}`,
                    billing_email: clientData.email,
                    billing_phone: clientData.phone,
                    phone_country_code: clientData.phoneCountryCode || null,
                };

                log(
                    "[TuSim:Order] Creating failed order for admin visibility",
                    failedPayload,
                );
                await app.service("pre-process-orders").create(failedPayload);

                const errorMessage =
                    confirmError.message || T[LANG].processPaymentError;
                showErrorMessage("tusim-error", errorMessage);
                throw new Error(errorMessage);
            }

            log("[TuSim:Stripe] Payment intent confirmed", {
                id: paymentIntent.id,
                status: paymentIntent.status,
            });

            if (paymentIntent.status === "succeeded") {
                log("[TuSim:Stripe] Payment succeeded, creating order");

                const orderItem = {
                    id: `shopify-${Date.now()}`,
                    simType: shopifyData.simType,
                    plan: {
                        id: plan.id || null,
                        price: parseFloat(plan.price) || 0,
                        price_cop:
                            parseFloat(plan.price_cop) ||
                            parseFloat(plan.price) * 3719.71 ||
                            0,
                        fromShopify: plan.fromShopify || false,
                    },
                    quantity: shopifyData.quantity,
                    clientDetails: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        email: clientData.email,
                        phone: clientData.phone,
                        activationDate: getActivationDate(shopifyData.travelDate),
                        travelStartDate: shopifyData.travelDate,
                    },
                    discount: appliedDiscountPercentage || 0,
                };

                const payload = {
                    payment_method: "stripe",
                    organization_id: TUSIM_CONFIG.organizationId,
                    organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                    order_items: [orderItem],
                    integration_order_id: `shopify-${Date.now()}`,
                    discount_code: appliedDiscountCode || null,
                    partner_name: TUSIM_CONFIG.partnerName || null,
                    landing_url: window.TuSimLandingUrl || null,
                    stripe_payment_intent_id: paymentIntent.id,
                    billing_dni: clientData.dni,
                    billing_name: `${clientData.firstName} ${clientData.lastName}`,
                    billing_email: clientData.email,
                    billing_phone: clientData.phone,
                    phone_country_code: clientData.phoneCountryCode || null,
                };

                log("[TuSim:Order] Creating order with Stripe payment", payload);

                const orderResponse = await app
                    .service("pre-process-orders")
                    .create(payload);
                log("[TuSim:Order] Order created", orderResponse);

                showOrderResult(
                    "success",
                    T[LANG].paymentApproved,
                    T[LANG].orderProcessed,
                    orderResponse.id,
                    orderResponse.total,
                );
            } else {
                throw new Error(`${T[LANG].paymentStatus}${paymentIntent.status}`);
            }
        } catch (err) {
            error("[TuSim:Order] Error processing order with Stripe", err);
            const errorMessage =
                err.message ||
                T[LANG].processOrderErrorAlt;
            showErrorMessage("tusim-error", errorMessage);
            throw err;
        }
    }

    async function processCartOrderWithStripe(cartItems, clientData) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            log("[TuSim:Order] Processing cart order with Stripe", {
                itemsCount: cartItems.length,
            });

            cartItems = apply2x1DiscountToItems(cartItems);
            cartItems = applyNDiscountToItems(cartItems);

            const shippingItem = cartItems.find((item) => item.type === "shipping");
            const shippingPrice =
                shippingItem && !shippingItem.pending
                    ? (shippingItem.price || 0) * (shippingItem.quantity || 1)
                    : 0;

            const originalTotal =
                cartItems.reduce((sum, item) => {
                    if (item.type === "shipping") return sum;
                    return sum + item.plan.price * item.quantity;
                }, 0) + shippingPrice;

            const discountedTotal = calculateDiscountedPrice(
                originalTotal,
                appliedDiscountPercentage || 0,
            );
            const totalAmountCents = Math.round(discountedTotal * 100);

            log("[TuSim:Stripe] Creating payment intent for cart", {
                totalAmountCents,
                originalTotal,
                discount: appliedDiscountPercentage,
                discountedTotal,
            });

            let checkoutAmountCart = totalAmountCents;
            let checkoutCurrencyCart = "usd";
            if (window.isAssistCardBR) {
                checkoutAmountCart = Math.round((discountedTotal * window.USD_TO_BRL_RATE) * 100);
                checkoutCurrencyCart = "brl";
            }

            const paymentIntentResponse = await app.service("stripe").create({
                action: "create-payment-intent",
                userId: null,
                amount: checkoutAmountCart,
                currency: checkoutCurrencyCart,
                email: clientData.email,
                name: `${clientData.firstName} ${clientData.lastName}`,
                metadata: {
                    organizationId: TUSIM_CONFIG.organizationId,
                    organizationBranchId: TUSIM_CONFIG.organizationBranchId,
                    itemsCount: cartItems.length,
                },
            });

            paymentIntentClientSecret = paymentIntentResponse.client_secret;
            log("[TuSim:Stripe] Payment intent created", {
                clientSecret: paymentIntentClientSecret,
            });

            log("[TuSim:Stripe] Confirming payment with card element for cart");

            const { error: confirmError, paymentIntent } =
                await stripeInstance.confirmCardPayment(paymentIntentClientSecret, {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: `${clientData.firstName} ${clientData.lastName}`,
                            email: clientData.email,
                            phone: clientData.phone,
                        },
                    },
                });

            if (confirmError) {
                log("[TuSim:Stripe] Payment confirmation error for cart", confirmError);
                const orderItems = [];

                for (const item of cartItems.filter(
                    (item) => item.type !== "shipping" && item.shopifyData,
                )) {

                    const orderItem = {
                        id: `shopify-${Date.now()}-${Math.random()
                            .toString(36)
                            .substr(2, 9)}`,
                        simType: item.shopifyData.simType,
                        plan: {
                            id: item.plan.id,
                            price: parseFloat(item.plan.price) || 0,
                            price_cop:
                                parseFloat(item.plan.price_cop) ||
                                parseFloat(item.plan.price) * 3719.71 ||
                                0,
                        },
                        quantity: item.quantity,
                        clientDetails: {
                            firstName: clientData.firstName,
                            lastName: clientData.lastName,
                            email: clientData.email,
                            phone: clientData.phone,
                            activationDate: getActivationDate(item.shopifyData.travelDate),
                            travelStartDate: item.shopifyData.travelDate,
                        },
                        discount: appliedDiscountPercentage || 0,
                    };

                    orderItems.push(orderItem);
                }

                const shopifyProducts = cartItems
                    .filter((item) => item.type !== "shipping" && item.shopifyData)
                    .map((item) => ({
                        shopifyData: item.shopifyData,
                        shopifyProduct: item.shopifyProduct || null,
                        shopifyVariant: item.shopifyVariant || null,
                        plan: item.plan,
                        quantity: item.quantity,
                    }));

                const shippingItem = cartItems.find((item) => item.type === "shipping");
                const shippingData = shippingItem
                    ? {
                        ...shippingItem,
                        ...(clientData.shipping || {}),
                    }
                    : null;

                const failedPayload = {
                    payment_method: "stripe",
                    organization_id: TUSIM_CONFIG.organizationId,
                    organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                    order_items: orderItems,
                    integration_order_id: `shopify-cart-${Date.now()}`,
                    discount_code: appliedDiscountCode || null,
                    partner_name: TUSIM_CONFIG.partnerName || null,
                    landing_url: window.TuSimLandingUrl || null,
                    stripe_payment_error: {
                        code: confirmError.code || "card_declined",
                        decline_code: confirmError.decline_code || null,
                        message: confirmError.message || T[LANG].processPaymentError,
                        type: confirmError.type || "card_error",
                    },
                    billing_dni: clientData.dni,
                    billing_name: `${clientData.firstName} ${clientData.lastName}`,
                    billing_email: clientData.email,
                    billing_phone: clientData.phone,
                    phone_country_code: clientData.phoneCountryCode || null,
                    shopify_products_json:
                        shopifyProducts.length > 0 ? shopifyProducts : null,
                    shipping_data_json: shippingData,
                };

                log(
                    "[TuSim:Order] Creating failed cart order for admin visibility",
                    failedPayload,
                );
                await app.service("pre-process-orders").create(failedPayload);

                const errorMessage =
                    confirmError.message || T[LANG].processPaymentError;
                showErrorMessage("tusim-error", errorMessage);
                throw new Error(errorMessage);
            }

            log("[TuSim:Stripe] Payment intent confirmed for cart", {
                id: paymentIntent.id,
                status: paymentIntent.status,
            });

            if (paymentIntent.status === "succeeded") {
                log("[TuSim:Stripe] Cart payment succeeded, creating order");
                const orderItems = [];

                for (const item of cartItems.filter(
                    (item) => item.type !== "shipping" && item.shopifyData,
                )) {

                    const orderItem = {
                        id: `shopify-${Date.now()}-${Math.random()
                            .toString(36)
                            .substr(2, 9)}`,
                        simType: item.shopifyData.simType,
                        plan: {
                            id: item.plan.id,
                            price: parseFloat(item.plan.price) || 0,
                            price_cop:
                                parseFloat(item.plan.price_cop) ||
                                parseFloat(item.plan.price) * 3719.71 ||
                                0,
                        },
                        quantity: item.quantity,
                        clientDetails: {
                            firstName: clientData.firstName,
                            lastName: clientData.lastName,
                            email: clientData.email,
                            phone: clientData.phone,
                            activationDate: getActivationDate(item.shopifyData.travelDate),
                            travelStartDate: item.shopifyData.travelDate,
                        },
                        discount: appliedDiscountPercentage || 0,
                    };

                    orderItems.push(orderItem);
                }

                const shopifyProducts = cartItems
                    .filter((item) => item.type !== "shipping" && item.shopifyData)
                    .map((item) => ({
                        shopifyData: item.shopifyData,
                        shopifyProduct: item.shopifyProduct || null,
                        shopifyVariant: item.shopifyVariant || null,
                        plan: item.plan,
                        quantity: item.quantity,
                    }));

                const shippingItem = cartItems.find((item) => item.type === "shipping");
                const shippingData = shippingItem
                    ? {
                        ...shippingItem,
                        ...(clientData.shipping || {}),
                    }
                    : null;

                const payload = {
                    payment_method: "stripe",
                    organization_id: TUSIM_CONFIG.organizationId,
                    organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                    order_items: orderItems,
                    integration_order_id: `shopify-cart-${Date.now()}`,
                    discount_code: appliedDiscountCode || null,
                    partner_name: TUSIM_CONFIG.partnerName || null,
                    landing_url: window.TuSimLandingUrl || null,
                    stripe_payment_intent_id: paymentIntent.id,
                    billing_dni: clientData.dni,
                    billing_name: `${clientData.firstName} ${clientData.lastName}`,
                    billing_email: clientData.email,
                    billing_phone: clientData.phone,
                    phone_country_code: clientData.phoneCountryCode || null,
                    shopify_products_json:
                        shopifyProducts.length > 0 ? shopifyProducts : null,
                    shipping_data_json: shippingData,
                };

                log("[TuSim:Order] Creating cart order with Stripe payment", payload);

                const orderResponse = await app
                    .service("pre-process-orders")
                    .create(payload);
                log("[TuSim:Order] Cart order created successfully", orderResponse);

                showOrderResult(
                    "success",
                    T[LANG].purchaseSuccess,
                    `${orderItems.length} ${T[LANG].productsProcessed}`,
                    orderResponse.id,
                    orderResponse.total,
                );
            } else {
                throw new Error(`${T[LANG].paymentStatus}${paymentIntent.status}`);
            }
        } catch (err) {
            error("[TuSim:Order] Error processing cart order with Stripe", err);
            const errorDiv = document.getElementById("tusim-error");
            if (errorDiv) {
                errorDiv.style.display = "block";
                errorDiv.textContent =
                    err.message ||
                    T[LANG].processOrderError;
            }
            throw err;
        }
    }

    // NOTE: PSE/Efecty/Credit Card functions are NOT used in landing pages (only Stripe is used)
    // These functions are for product pages with MercadoPago

    async function processOrderWithCreditCard(
        shopifyData,
        planId,
        clientData,
        plan = null,
    ) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const creditCardToken = document.getElementById(
                "tusim-credit-card-token",
            )?.value;
            const mercadopagoCustomerId = document.getElementById(
                "tusim-mercadopago-customer-id",
            )?.value;
            const mercadopagoCreditCardId = document.getElementById(
                "tusim-mercadopago-credit-card-id",
            )?.value;

            if (!creditCardToken && !mercadopagoCreditCardId) {
                throw new Error("Por favor agrega una tarjeta de crédito/débito");
            }

            if (!plan && planId) {
                log("[TuSim:Order] Fetching plan details for Credit Card", { planId });

                plan = await app.service("plans").get(planId, {
                    query: {
                        $client: {
                            filterPrice: "true",
                            organization_id: TUSIM_CONFIG.organizationId,
                        },
                    },
                });
            } else if (plan) {
                log("[TuSim:Order] Using provided plan for Credit Card", {
                    planId: plan.id,
                    price: plan.price,
                    fromShopify: plan.fromShopify,
                });
            }

            if (!plan || !plan.price) {
                throw new Error("El plan no tiene precio configurado");
            }


            const orderItem = {
                id: `shopify-${Date.now()}`,
                simType: shopifyData.simType,
                plan: {
                    id: plan.id || null,
                    price: plan.price,
                    price_cop: plan.price_cop || plan.price * 3719.71,
                    fromShopify: plan.fromShopify || false,
                },
                quantity: shopifyData.quantity,
                clientDetails: {
                    firstName: clientData.firstName,
                    lastName: clientData.lastName,
                    email: clientData.email,
                    phone: clientData.phone,
                    activationDate: getActivationDate(shopifyData.travelDate),
                    travelStartDate: shopifyData.travelDate,
                },
                discount: appliedDiscountPercentage || 0,
            };

            const payload = {
                payment_method: "credit_card",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: [orderItem],
                integration_order_id: `shopify-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                email: clientData.email,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_dni: clientData.dni,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
                billing_person_type: "natural",
                billing_identification_type: "31",
            };

            if (mercadopagoCreditCardId && mercadopagoCustomerId) {
                payload.mercadopago_credit_card_id = mercadopagoCreditCardId;
                payload.mercadopago_customer_id = mercadopagoCustomerId;
                const cardCvv = document.getElementById("tusim-card-cvv")?.value;
                if (cardCvv) {
                    payload.cvv = cardCvv;
                }
                log("[TuSim:Payment] Using MercadoPago saved card", {
                    mercadopago_credit_card_id: mercadopagoCreditCardId,
                    mercadopago_customer_id: mercadopagoCustomerId,
                });
            } else if (creditCardToken) {
                payload.token = creditCardToken;
                log("[TuSim:Payment] Using credit card token");
            }

            log("[TuSim:Order] Creating order with Credit Card payment", payload);

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log("[TuSim:Order] Order created with Credit Card", orderResponse);

            if (orderResponse.paymentResponse?.status === "approved") {
                showOrderResult(
                    "success",
                    T[LANG].paymentApproved,
                    T[LANG].orderProcessed,
                    orderResponse.id,
                    orderResponse.total,
                );
            } else if (orderResponse.paymentResponse?.status === "in_process") {
                showOrderResult(
                    "processing",
                    T[LANG].paymentPending,
                    T[LANG].paymentPendingMsg,
                    orderResponse.id,
                );
            } else {
                showOrderResult(
                    "error",
                    T[LANG].paymentError,
                    `Estado: ${orderResponse.paymentResponse?.status || "unknown"} - ${orderResponse.paymentResponse?.status_detail || ""
                    }`,
                    orderResponse.id,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing order with Credit Card", err);
            const errorMessage =
                err.message ||
                T[LANG].processOrderErrorAlt;
            showErrorMessage("tusim-error", errorMessage);
            throw err;
        }
    }

    async function processOrderWithPse(
        shopifyData,
        planId,
        clientData,
        plan = null,
    ) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const pseBankSelect = document.getElementById("tusim-pse-bank-select");
            const pseTypeIdSelect = document.getElementById("tusim-pse-type-id");

            if (!pseBankSelect || !pseBankSelect.value) {
                throw new Error("Por favor selecciona un banco");
            }

            if (!pseTypeIdSelect || !pseTypeIdSelect.value) {
                throw new Error("Por favor selecciona el tipo de identificación");
            }

            if (!plan && planId) {
                log("[TuSim:Order] Fetching plan details for PSE", { planId });

                plan = await app.service("plans").get(planId, {
                    query: {
                        $client: {
                            filterPrice: "true",
                            organization_id: TUSIM_CONFIG.organizationId,
                        },
                    },
                });
            } else if (plan) {
                log("[TuSim:Order] Using provided plan for PSE", {
                    planId: plan.id,
                    price: plan.price,
                    fromShopify: plan.fromShopify,
                });
            }

            if (!plan || !plan.price) {
                throw new Error("El plan no tiene precio configurado");
            }


            const orderItem = {
                id: `shopify-${Date.now()}`,
                simType: shopifyData.simType,
                plan: {
                    id: plan.id || null,
                    price: plan.price,
                    price_cop: plan.price_cop || plan.price * 3719.71,
                    fromShopify: plan.fromShopify || false,
                },
                quantity: shopifyData.quantity,
                clientDetails: {
                    firstName: clientData.firstName,
                    lastName: clientData.lastName,
                    email: clientData.email,
                    phone: clientData.phone,
                    activationDate: getActivationDate(shopifyData.travelDate),
                    travelStartDate: shopifyData.travelDate,
                },
                discount: appliedDiscountPercentage || 0,
            };

            const payload = {
                payment_method: "pse",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: [orderItem],
                integration_order_id: `shopify-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                first_name: clientData.firstName,
                last_name: clientData.lastName,
                type: pseTypeIdSelect.value,
                dni: clientData.dni,
                financial_institution: pseBankSelect.value,
                email: clientData.email,
                billing_dni: clientData.dni,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
            };

            log("[TuSim:Order] Creating order with PSE payment", payload);

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log("[TuSim:Order] Order created with PSE", orderResponse);

            if (
                orderResponse.paymentResponse?.transaction_details
                    ?.external_resource_url
            ) {
                window.location.href =
                    orderResponse.paymentResponse.transaction_details.external_resource_url;
            } else {
                showOrderResult(
                    "success",
                    T[LANG].orderSuccess,
                    T[LANG].orderProcessedMsg,
                    orderResponse.id,
                    orderResponse.total,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing order with PSE", err);
            const errorMessage =
                err.message ||
                T[LANG].processOrderErrorAlt;
            showErrorMessage("tusim-error", errorMessage);
            throw err;
        }
    }

    async function processOrderWithEfecty(
        shopifyData,
        planId,
        clientData,
        plan = null,
    ) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const efectyTypeIdSelect = document.getElementById(
                "tusim-efecty-type-id",
            );

            if (!efectyTypeIdSelect || !efectyTypeIdSelect.value) {
                throw new Error("Por favor selecciona el tipo de identificación");
            }

            if (!plan && planId) {
                log("[TuSim:Order] Fetching plan details for Efecty", { planId });

                plan = await app.service("plans").get(planId, {
                    query: {
                        $client: {
                            filterPrice: "true",
                            organization_id: TUSIM_CONFIG.organizationId,
                        },
                    },
                });
            } else if (plan) {
                log("[TuSim:Order] Using provided plan for Efecty", {
                    planId: plan.id,
                    price: plan.price,
                    fromShopify: plan.fromShopify,
                });
            }

            if (!plan || !plan.price) {
                throw new Error("El plan no tiene precio configurado");
            }


            const orderItem = {
                id: `shopify-${Date.now()}`,
                simType: shopifyData.simType,
                plan: {
                    id: plan.id || null,
                    price: plan.price,
                    price_cop: plan.price_cop || plan.price * 3719.71,
                    fromShopify: plan.fromShopify || false,
                },
                quantity: shopifyData.quantity,
                clientDetails: {
                    firstName: clientData.firstName,
                    lastName: clientData.lastName,
                    email: clientData.email,
                    phone: clientData.phone,
                    activationDate: getActivationDate(shopifyData.travelDate),
                    travelStartDate: shopifyData.travelDate,
                },
                discount: appliedDiscountPercentage || 0,
            };

            const payload = {
                payment_method: "efecty",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: [orderItem],
                integration_order_id: `shopify-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                type: efectyTypeIdSelect.value,
                dni: clientData.dni,
                email: clientData.email,
                billing_dni: clientData.dni,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
            };

            log("[TuSim:Order] Creating order with Efecty payment", payload);

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log("[TuSim:Order] Order created with Efecty", orderResponse);

            if (
                orderResponse.paymentResponse?.transaction_details
                    ?.external_resource_url
            ) {
                window.location.href =
                    orderResponse.paymentResponse.transaction_details.external_resource_url;
            } else {
                showOrderResult(
                    "success",
                    T[LANG].orderSuccess,
                    T[LANG].orderProcessedMsg,
                    orderResponse.id,
                    orderResponse.total,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing order with Efecty", err);
            const errorMessage =
                err.message ||
                T[LANG].processOrderErrorAlt;
            showErrorMessage("tusim-error", errorMessage);
            throw err;
        }
    }

    async function processCartOrderWithCreditCard(cartItems, clientData) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const creditCardToken = document.getElementById(
                "tusim-credit-card-token",
            )?.value;
            const mercadopagoCustomerId = document.getElementById(
                "tusim-mercadopago-customer-id",
            )?.value;
            const mercadopagoCreditCardId = document.getElementById(
                "tusim-mercadopago-credit-card-id",
            )?.value;

            if (!creditCardToken && !mercadopagoCreditCardId) {
                throw new Error("Por favor agrega una tarjeta de crédito/débito");
            }

            log("[TuSim:Order] Processing cart order with Credit Card", {
                itemsCount: cartItems.length,
            });

            cartItems = apply2x1DiscountToItems(cartItems);
            cartItems = applyNDiscountToItems(cartItems);

            const orderItems = [];

            for (const item of cartItems.filter(
                (item) => item.type !== "shipping" && item.shopifyData,
            )) {

                const orderItem = {
                    id: `shopify-${Date.now()}-${Math.random()
                        .toString(36)
                        .substr(2, 9)}`,
                    simType: item.shopifyData.simType,
                    plan: {
                        id: item.plan.id,
                        price: parseFloat(item.plan.price) || 0,
                        price_cop:
                            parseFloat(item.plan.price_cop) ||
                            parseFloat(item.plan.price) * 3719.71 ||
                            0,
                    },
                    quantity: item.quantity,
                    clientDetails: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        email: clientData.email,
                        phone: clientData.phone,
                        activationDate: getActivationDate(item.shopifyData.travelDate),
                        travelStartDate: item.shopifyData.travelDate,
                    },
                    discount: appliedDiscountPercentage || 0,
                };

                orderItems.push(orderItem);
            }

            const shopifyProducts = cartItems
                .filter((item) => item.type !== "shipping" && item.shopifyData)
                .map((item) => ({
                    shopifyData: item.shopifyData,
                    shopifyProduct: item.shopifyProduct || null,
                    shopifyVariant: item.shopifyVariant || null,
                    plan: item.plan,
                    quantity: item.quantity,
                }));

            const shippingItem = cartItems.find((item) => item.type === "shipping");
            const shippingData = shippingItem
                ? {
                    ...shippingItem,
                    ...(clientData.shipping || {}),
                }
                : null;

            const payload = {
                payment_method: "credit_card",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: orderItems,
                integration_order_id: `shopify-cart-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                email: clientData.email,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_dni: clientData.dni,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
                billing_person_type: "natural",
                billing_identification_type: "31",
                shopify_products_json:
                    shopifyProducts.length > 0 ? shopifyProducts : null,
                shipping_data_json: shippingData,
            };

            if (mercadopagoCreditCardId && mercadopagoCustomerId) {
                payload.mercadopago_credit_card_id = mercadopagoCreditCardId;
                payload.mercadopago_customer_id = mercadopagoCustomerId;
                const cardCvv = document.getElementById("tusim-card-cvv")?.value;
                if (cardCvv) {
                    payload.cvv = cardCvv;
                }
                log("[TuSim:Payment] Using MercadoPago saved card for cart", {
                    mercadopago_credit_card_id: mercadopagoCreditCardId,
                    mercadopago_customer_id: mercadopagoCustomerId,
                });
            } else if (creditCardToken) {
                payload.token = creditCardToken;
                log("[TuSim:Payment] Using credit card token for cart");
            }

            log(
                "[TuSim:Order] Creating cart order with Credit Card payment",
                payload,
            );

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log(
                "[TuSim:Order] Cart order created successfully with Credit Card",
                orderResponse,
            );

            if (orderResponse.paymentResponse?.status === "approved") {
                showOrderResult(
                    "success",
                    T[LANG].purchaseSuccess,
                    `${orderItems.length} ${T[LANG].productsProcessed}`,
                    orderResponse.id,
                    orderResponse.total,
                );
            } else if (orderResponse.paymentResponse?.status === "in_process") {
                showOrderResult(
                    "processing",
                    T[LANG].paymentPending,
                    T[LANG].paymentPendingMsg,
                    orderResponse.id,
                );
            } else {
                showOrderResult(
                    "error",
                    T[LANG].paymentError,
                    `Estado: ${orderResponse.paymentResponse?.status || "unknown"} - ${orderResponse.paymentResponse?.status_detail || ""
                    }`,
                    orderResponse.id,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing cart order with Credit Card", err);
            const errorDiv = document.getElementById("tusim-error");
            if (errorDiv) {
                errorDiv.style.display = "block";
                errorDiv.textContent =
                    err.message ||
                    T[LANG].processOrderError;
            }
            throw err;
        }
    }

    async function processCartOrderWithPse(cartItems, clientData) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const pseBankSelect = document.getElementById("tusim-pse-bank-select");
            const pseTypeIdSelect = document.getElementById("tusim-pse-type-id");

            if (!pseBankSelect || !pseBankSelect.value) {
                throw new Error("Por favor selecciona un banco");
            }

            if (!pseTypeIdSelect || !pseTypeIdSelect.value) {
                throw new Error("Por favor selecciona el tipo de identificación");
            }

            log("[TuSim:Order] Processing cart order with PSE", {
                itemsCount: cartItems.length,
            });

            cartItems = apply2x1DiscountToItems(cartItems);
            cartItems = applyNDiscountToItems(cartItems);

            const orderItems = [];

            for (const item of cartItems.filter(
                (item) => item.type !== "shipping" && item.shopifyData,
            )) {

                const orderItem = {
                    id: `shopify-${Date.now()}-${Math.random()
                        .toString(36)
                        .substr(2, 9)}`,
                    simType: item.shopifyData.simType,
                    plan: {
                        id: item.plan.id,
                        price: parseFloat(item.plan.price) || 0,
                        price_cop:
                            parseFloat(item.plan.price_cop) ||
                            parseFloat(item.plan.price) * 3719.71 ||
                            0,
                    },
                    quantity: item.quantity,
                    clientDetails: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        email: clientData.email,
                        phone: clientData.phone,
                        activationDate: getActivationDate(item.shopifyData.travelDate),
                        travelStartDate: item.shopifyData.travelDate,
                    },
                    discount: appliedDiscountPercentage || 0,
                };

                orderItems.push(orderItem);
            }

            const shopifyProducts = cartItems
                .filter((item) => item.type !== "shipping" && item.shopifyData)
                .map((item) => ({
                    shopifyData: item.shopifyData,
                    shopifyProduct: item.shopifyProduct || null,
                    shopifyVariant: item.shopifyVariant || null,
                    plan: item.plan,
                    quantity: item.quantity,
                }));

            const shippingItem = cartItems.find((item) => item.type === "shipping");
            const shippingData = shippingItem
                ? {
                    ...shippingItem,
                    ...(clientData.shipping || {}),
                }
                : null;

            const payload = {
                payment_method: "pse",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: orderItems,
                integration_order_id: `shopify-cart-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                first_name: clientData.firstName,
                last_name: clientData.lastName,
                type: pseTypeIdSelect.value,
                dni: clientData.dni,
                financial_institution: pseBankSelect.value,
                email: clientData.email,
                billing_dni: clientData.dni,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
                shopify_products_json:
                    shopifyProducts.length > 0 ? shopifyProducts : null,
                shipping_data_json: shippingData,
            };

            log("[TuSim:Order] Creating cart order with PSE payment", payload);

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log(
                "[TuSim:Order] Cart order created successfully with PSE",
                orderResponse,
            );

            if (
                orderResponse.paymentResponse?.transaction_details
                    ?.external_resource_url
            ) {
                window.location.href =
                    orderResponse.paymentResponse.transaction_details.external_resource_url;
            } else {
                showOrderResult(
                    "success",
                    T[LANG].purchaseSuccess,
                    `${orderItems.length} ${T[LANG].productsProcessed}`,
                    orderResponse.id,
                    orderResponse.total,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing cart order with PSE", err);
            const errorDiv = document.getElementById("tusim-error");
            if (errorDiv) {
                errorDiv.style.display = "block";
                errorDiv.textContent =
                    err.message ||
                    T[LANG].processOrderError;
            }
            throw err;
        }
    }

    async function processCartOrderWithEfecty(cartItems, clientData) {
        try {
            const errorDiv = document.getElementById("tusim-error");
            errorDiv.style.display = "none";

            const efectyTypeIdSelect = document.getElementById(
                "tusim-efecty-type-id",
            );

            if (!efectyTypeIdSelect || !efectyTypeIdSelect.value) {
                throw new Error("Por favor selecciona el tipo de identificación");
            }

            log("[TuSim:Order] Processing cart order with Efecty", {
                itemsCount: cartItems.length,
            });

            cartItems = apply2x1DiscountToItems(cartItems);
            cartItems = applyNDiscountToItems(cartItems);

            const orderItems = [];

            for (const item of cartItems.filter(
                (item) => item.type !== "shipping" && item.shopifyData,
            )) {

                const orderItem = {
                    id: `shopify-${Date.now()}-${Math.random()
                        .toString(36)
                        .substr(2, 9)}`,
                    simType: item.shopifyData.simType,
                    plan: {
                        id: item.plan.id,
                        price: parseFloat(item.plan.price) || 0,
                        price_cop:
                            parseFloat(item.plan.price_cop) ||
                            parseFloat(item.plan.price) * 3719.71 ||
                            0,
                    },
                    quantity: item.quantity,
                    clientDetails: {
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        email: clientData.email,
                        phone: clientData.phone,
                        activationDate: getActivationDate(item.shopifyData.travelDate),
                        travelStartDate: item.shopifyData.travelDate,
                    },
                    discount: appliedDiscountPercentage || 0,
                };

                orderItems.push(orderItem);
            }

            const shopifyProducts = cartItems
                .filter((item) => item.type !== "shipping" && item.shopifyData)
                .map((item) => ({
                    shopifyData: item.shopifyData,
                    shopifyProduct: item.shopifyProduct || null,
                    shopifyVariant: item.shopifyVariant || null,
                    plan: item.plan,
                    quantity: item.quantity,
                }));

            const shippingItem = cartItems.find((item) => item.type === "shipping");
            const shippingData = shippingItem
                ? {
                    ...shippingItem,
                    ...(clientData.shipping || {}),
                }
                : null;

            const payload = {
                payment_method: "efecty",
                organization_id: TUSIM_CONFIG.organizationId,
                organization_branch_id: TUSIM_CONFIG.organizationBranchId,
                order_items: orderItems,
                integration_order_id: `shopify-cart-${Date.now()}`,
                discount_code: appliedDiscountCode || null,
                partner_name: TUSIM_CONFIG.partnerName || null,
                landing_url: window.TuSimLandingUrl || null,
                type: efectyTypeIdSelect.value,
                dni: clientData.dni,
                email: clientData.email,
                billing_dni: clientData.dni,
                billing_name: `${clientData.firstName} ${clientData.lastName}`,
                billing_email: clientData.email,
                billing_phone: clientData.phone,
                phone_country_code: clientData.phoneCountryCode || null,
                shopify_products_json:
                    shopifyProducts.length > 0 ? shopifyProducts : null,
                shipping_data_json: shippingData,
            };

            log("[TuSim:Order] Creating cart order with Efecty payment", payload);

            const orderResponse = await app
                .service("pre-process-orders")
                .create(payload);
            log(
                "[TuSim:Order] Cart order created successfully with Efecty",
                orderResponse,
            );

            if (
                orderResponse.paymentResponse?.transaction_details
                    ?.external_resource_url
            ) {
                window.location.href =
                    orderResponse.paymentResponse.transaction_details.external_resource_url;
            } else {
                showOrderResult(
                    "success",
                    T[LANG].purchaseSuccess,
                    `${orderItems.length} ${T[LANG].productsProcessed}`,
                    orderResponse.id,
                    orderResponse.total,
                );
            }
        } catch (err) {
            error("[TuSim:Order] Error processing cart order with Efecty", err);
            const errorDiv = document.getElementById("tusim-error");
            if (errorDiv) {
                errorDiv.style.display = "block";
                errorDiv.textContent =
                    err.message ||
                    T[LANG].processOrderError;
            }
            throw err;
        }
    }

    // NOTE: This function is NOT used in landing pages (only Stripe is used)
    // This function uses MercadoPago and is only for product pages
    async function processCartOrder(cartItems, clientData) {
        throw new Error(
            "[TuSim:Widget] processCartOrder is not available for landing pages. Use processCartOrderWithStripe instead.",
        );
    }

    async function validateDiscountCode(code, customerEmail, customerPhone) {
        try {
            log("[TuSim:Discount] Validating discount code", { code });

            const response = await fetch(
                `${TUSIM_CONFIG.apiUrl}/discount-code-validation`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        code: code.toUpperCase(),
                        partner_name: TUSIM_CONFIG.partnerName,
                        customer_email: customerEmail,
                        customer_phone: customerPhone || null,
                    }),
                },
            );

            const result = await response.json();
            log("[TuSim:Discount] Validation result", result);

            return result;
        } catch (err) {
            error("[TuSim:Discount] Error validating discount code", err);
            return {
                valid: false,
                error_message: T[LANG].validateDiscountError,
            };
        }
    }

    function calculateDiscountedPrice(originalPrice, discountPercentage) {
        if (!discountPercentage || discountPercentage <= 0) {
            return originalPrice;
        }
        return originalPrice * (1 - discountPercentage / 100);
    }

    function updateOrderSummaryWithDiscount() {
        const summaryContainer = document.querySelector(".tusim-order-summary");
        if (!summaryContainer) return;

        const isCartCheckout = summaryContainer.querySelector(
            ".tusim-summary-total-only",
        );

        if (isCartCheckout) {
            // Cart checkout - update total
            const originalTotalStr = summaryContainer.getAttribute(
                "data-original-total",
            );
            const originalTotal = originalTotalStr ? parseFloat(originalTotalStr) : 0;
            const discountAmount =
                appliedDiscountPercentage > 0
                    ? originalTotal * (appliedDiscountPercentage / 100)
                    : 0;
            const finalTotal = calculateDiscountedPrice(
                originalTotal,
                appliedDiscountPercentage,
            );

            const totalAmountEl = summaryContainer.querySelector(
                ".tusim-total-amount",
            );
            const totalInfoEl = summaryContainer.querySelector(".tusim-total-info");
            const cart = getCart();

            if (totalAmountEl && totalInfoEl) {
                if (appliedDiscountPercentage > 0) {
                    totalInfoEl.innerHTML = `
            <span class="tusim-items-count">${cart.items.length
                        } ${T[LANG].items}</span>
            <div style="margin-top: 4px; font-size: 12px; line-height: 1.3;">
              <div style="display: flex; justify-content: space-between;">
                <span style="color: #697386;">${T[LANG].subtotal}:</span>
                <span style="color: #697386; text-decoration: line-through;">${window.formatCurrency(originalTotal)}</span>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <span style="color: #10b981;">${T[LANG].discountLabel} ${appliedDiscountPercentage}%:</span>
                <span style="color: #10b981;">-${window.formatCurrency(discountAmount)}</span>
              </div>
            </div>
            <span class="tusim-total-label" style="margin-top: 4px; display: block; font-size: 13px;">${T[LANG].total}:</span>
          `;
                    totalAmountEl.textContent = `${window.formatCurrency(finalTotal)}`;
                    totalAmountEl.style.color = "#10b981";
                    totalAmountEl.style.fontSize = "24px";
                } else {
                    totalInfoEl.innerHTML = `
            <span class="tusim-items-count">${cart.items.length} ${T[LANG].items}</span>
            <span class="tusim-total-label" style="margin-top: 4px; display: block;">${T[LANG].total}:</span>
          `;
                    totalAmountEl.textContent = `${window.formatCurrency(originalTotal)}`;
                    totalAmountEl.style.color = "#0a2540";
                    totalAmountEl.style.fontSize = "28px";
                }
            }
        } else {
            // Single product checkout - update plan price
            const planPriceEl = summaryContainer.querySelector(".tusim-plan-price");
            const summaryCard = summaryContainer.querySelector(".tusim-summary-card");

            if (planPriceEl && summaryCard) {
                const originalPriceStr =
                    planPriceEl.getAttribute("data-original-price") ||
                    summaryContainer.getAttribute("data-original-price");
                const originalPrice = originalPriceStr
                    ? parseFloat(originalPriceStr)
                    : 0;
                const discountAmount =
                    appliedDiscountPercentage > 0
                        ? originalPrice * (appliedDiscountPercentage / 100)
                        : 0;
                const finalPrice = calculateDiscountedPrice(
                    originalPrice,
                    appliedDiscountPercentage,
                );

                if (appliedDiscountPercentage > 0) {
                    // Update price display inline - more compact
                    planPriceEl.innerHTML = `
            <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 2px;">
              <span style="font-size: 12px; color: #697386; text-decoration: line-through;">${window.formatCurrency(originalPrice)}</span>
              <span style="font-size: 20px; font-weight: 600; color: #10b981;">${window.formatCurrency(finalPrice)}</span>
              <span style="font-size: 10px; color: #10b981; margin-top: 1px;">-${appliedDiscountPercentage}% (${window.formatCurrency(discountAmount)})</span>
            </div>
          `;
                } else {
                    // Remove discount breakdown if exists
                    const discountBreakdown = summaryCard.querySelector(
                        ".tusim-discount-breakdown",
                    );
                    if (discountBreakdown) {
                        discountBreakdown.remove();
                    }
                    planPriceEl.innerHTML = `${window.formatCurrency(originalPrice)}`;
                    planPriceEl.style.textDecoration = "none";
                    planPriceEl.style.color = "#0a2540";
                    planPriceEl.style.fontSize = "20px";
                }
            }
        }

        // Update submit button
        updateSubmitButtonPrice();
    }

    function updateSubmitButtonPrice() {
        const submitBtn = document.getElementById("tusim-submit-btn");
        if (!submitBtn) return;

        const summaryContainer = document.querySelector(".tusim-order-summary");
        if (!summaryContainer) return;

        const isCartCheckout = summaryContainer.querySelector(
            ".tusim-summary-total-only",
        );

        if (isCartCheckout) {
            const originalTotalStr = summaryContainer.getAttribute(
                "data-original-total",
            );
            const originalTotal = originalTotalStr ? parseFloat(originalTotalStr) : 0;
            const finalTotal = calculateDiscountedPrice(
                originalTotal,
                appliedDiscountPercentage,
            );
            submitBtn.textContent = `${T[LANG].pay} ${window.formatCurrency(finalTotal)}`;
        } else {
            const planPriceEl = summaryContainer.querySelector(".tusim-plan-price");
            if (planPriceEl) {
                const originalPriceStr =
                    planPriceEl.getAttribute("data-original-price") ||
                    summaryContainer.getAttribute("data-original-price");
                const originalPrice = originalPriceStr
                    ? parseFloat(originalPriceStr)
                    : 0;
                const finalPrice = calculateDiscountedPrice(
                    originalPrice,
                    appliedDiscountPercentage,
                );
                submitBtn.textContent = `${T[LANG].pay} ${window.formatCurrency(finalPrice)}`;
            } else {
                // Fallback: try to get from summary container
                const originalPriceStr = summaryContainer.getAttribute(
                    "data-original-price",
                );
                if (originalPriceStr) {
                    const originalPrice = parseFloat(originalPriceStr);
                    const finalPrice = calculateDiscountedPrice(
                        originalPrice,
                        appliedDiscountPercentage,
                    );
                    submitBtn.textContent = `${T[LANG].pay} ${window.formatCurrency(finalPrice)}`;
                }
            }
        }
    }

    function updateDiscountUI(isValid, message, percentage = 0) {
        const messageDiv = document.getElementById("tusim-discount-message");
        const discountInput = document.getElementById("tusim-discount-code");
        const applyBtn = document.getElementById("tusim-apply-discount");

        if (!messageDiv) return;

        messageDiv.style.display = "block";

        if (isValid) {
            messageDiv.style.color = "#10b981";
            messageDiv.innerHTML = `✅ ${message} (${percentage}${T[LANG].percentDiscount}`;
            if (discountInput) discountInput.style.borderColor = "#10b981";
            if (discountInput) discountInput.disabled = true;
            if (applyBtn) {
                applyBtn.textContent = T[LANG].applied;
                applyBtn.disabled = true;
                applyBtn.style.backgroundColor = "#10b981";
            }

            // Update order summary with discount
            updateOrderSummaryWithDiscount();
        } else {
            messageDiv.style.color = "#ef4444";
            messageDiv.innerHTML = `❌ ${message}`;
            if (discountInput) discountInput.style.borderColor = "#ef4444";
            appliedDiscountCode = null;
            appliedDiscountPercentage = 0;
            discountValidationResult = null;

            // Reset order summary
            updateOrderSummaryWithDiscount();
        }
    }

    function clearDiscountUI() {
        const messageDiv = document.getElementById("tusim-discount-message");
        const discountInput = document.getElementById("tusim-discount-code");
        const applyBtn = document.getElementById("tusim-apply-discount");

        if (messageDiv) {
            messageDiv.style.display = "none";
            messageDiv.textContent = "";
        }

        if (discountInput) {
            discountInput.value = "";
            discountInput.style.borderColor = "";
            discountInput.disabled = false;
        }

        if (applyBtn) {
            applyBtn.textContent = T[LANG].apply;
            applyBtn.disabled = false;
            applyBtn.style.backgroundColor = "#552387";
        }

        appliedDiscountCode = null;
        appliedDiscountPercentage = 0;
        discountValidationResult = null;

        // Reset order summary
        updateOrderSummaryWithDiscount();
    }

    // NOTE: This function is NOT used in landing pages (only Stripe is used)
    // This function uses MercadoPago and is only for product pages
    async function processOrder(shopifyData, planId, clientData) {
        throw new Error(
            "[TuSim:Widget] processOrder is not available for landing pages. Use processOrderWithStripe instead.",
        );
    }

    function showOrderResult(status, title, message, orderId, orderTotal) {
        const overlay = document.getElementById("tusim-overlay");
        if (!overlay) return;

        const formContainer = overlay.querySelector(".tusim-modal");
        if (!formContainer) return;

        const iconMap = {
            success: `<svg class="tusim-result-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>`,
            error: `<svg class="tusim-result-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>`,
            processing: `<svg class="tusim-result-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`,
            pending: `<svg class="tusim-result-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>`,
        };

        const colorMap = {
            success: "#10b981",
            error: "#ef4444",
            processing: "#3b82f6",
            pending: "#f59e0b",
        };

        if (status === "success" && typeof gtag === "function") {
            gtag("event", "conversion", {
                'send_to': 'AW-16694183104/ybfCCMHz6r0cEMCJtJg-',
                'value': parseFloat(orderTotal) || 0,
                'currency': 'USD',
                'transaction_id': orderId || ''
            });
        }
        if (status === "success") {
            var landingOrigen = localStorage.getItem('landing_origen') || document.referrer;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'purchase',
                'transaction_id': orderId || '',
                'value': parseFloat(orderTotal) || 0,
                'currency': 'USD',
                'landing_origen': landingOrigen
            });
        }
        if (status === "success") {
            try {
                if (typeof window.clarity === "function") {
                    window.clarity("set", "tusim_order_id", String(orderId || ""));
                }
            } catch (err) {
                error("[TuSim:Clarity] Error tagging order id", err);
            }
        }

        formContainer.innerHTML = `
      <div class="tusim-order-result">
        <div class="tusim-result-header">
          <div class="tusim-result-icon-container" style="background: ${colorMap[status]
            }20; color: ${colorMap[status]};">
            ${iconMap[status]}
          </div>
          <h2 class="tusim-result-title">${title}</h2>
          <p class="tusim-result-message">${message}</p>
          ${orderId ? `<div class="tusim-order-id">Orden #${orderId}</div>` : ""
            }
        </div>

        <button 
          onclick="document.getElementById('tusim-overlay').remove()" 
          class="tusim-result-button tusim-primary-button"
          style="background: ${colorMap[status]} !important;"
        >
          Aceptar
        </button>
      </div>

      <style>
        .tusim-order-result {
          padding: 40px 30px !important;
          text-align: center !important;
        }

        .tusim-result-header {
          margin-bottom: 32px !important;
        }

        .tusim-result-icon-container {
          width: 80px !important;
          height: 80px !important;
          margin: 0 auto 24px !important;
          border-radius: 50% !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .tusim-result-icon {
          width: 48px !important;
          height: 48px !important;
        }

        .tusim-result-title {
          font-size: 24px !important;
          font-weight: 700 !important;
          color: #0a2540 !important;
          margin: 0 0 12px 0 !important;
          letter-spacing: -0.02em !important;
        }

        .tusim-result-message {
          font-size: 15px !important;
          color: #697386 !important;
          margin: 0 0 16px 0 !important;
          line-height: 1.6 !important;
        }

        .tusim-order-id {
          display: inline-block !important;
          background: #f6f9fc !important;
          padding: 8px 16px !important;
          border-radius: 6px !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #635bff !important;
          border: 1px solid #e3e8ef !important;
        }

        .tusim-result-button {
          width: 100% !important;
          padding: 14px 24px !important;
          border: none !important;
          border-radius: 6px !important;
          font-size: 15px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          letter-spacing: -0.01em !important;
          text-decoration: none !important;
          display: block !important;
          text-align: center !important;
          box-sizing: border-box !important;
        }

        .tusim-primary-button {
          color: #ffffff !important;
          box-shadow: 0 2px 8px rgba(99, 91, 255, 0.24) !important;
        }

        .tusim-primary-button:hover {
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 12px rgba(99, 91, 255, 0.32) !important;
        }
      </style>
    `;
    }

    let productConfig = null;

    function attachClickListener(element) {
        if (element.dataset.tusimIntercepted) return;

        // Skip if this is a button marked as internal or inside our own modals
        if (
            element.dataset.tusimInternal === "true" ||
            element.closest("#tusim-overlay") ||
            element.closest("#tusim-add-card-dialog")
        ) {
            log("Button is internal Tusim button, skipping interception");
            return;
        }

        element.dataset.tusimIntercepted = "true";

        element.addEventListener(
            "click",
            async (e) => {
                // Skip if click originated from inside our modals
                if (
                    e.target.closest("#tusim-overlay") ||
                    e.target.closest("#tusim-add-card-dialog")
                ) {
                    log("Click originated from Tusim modal, skipping interception");
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                // Prevent multiple clicks
                if (element.dataset.tusimProcessing === "true") {
                    log("Button click already processing, ignoring...");
                    return;
                }

                element.dataset.tusimProcessing = "true";

                try {
                    log("[TuSim:AddToCart] Button clicked, capturing form data...");
                    const shopifyData = await captureShopifyFormData();

                    if (!shopifyData) {
                        error("[TuSim:AddToCart] Failed to capture form data");
                        if (window.__tusimDateBlocked) {
                            window.__tusimDateBlocked = false;
                            element.dataset.tusimProcessing = "false";
                            return;
                        }
                        alert(
                            T[LANG].formCaptureError,
                        );
                        element.dataset.tusimProcessing = "false";
                        return;
                    }

                    log("[TuSim:AddToCart] Form data captured successfully", shopifyData);

                    const path = window.location.pathname;
                    const match = path.match(/\/products\/([^\/]+)/);
                    const productHandle = match ? match[1] : null;

                    let planId = null;
                    let plan = null;
                    let planLookupMethod = null;

                    log("[TuSim:AddToCart] Captured shopify data", shopifyData);

                    // Priority 1: Try to get plan ID directly from variant metafield
                    let variantInfo = null;
                    if (shopifyData.variantId && productHandle) {
                        log(
                            "[TuSim:AddToCart] Attempting to get plan ID from variant metafield",
                            {
                                variantId: shopifyData.variantId,
                                productHandle,
                            },
                        );
                        const result = await getVariantPlanId(
                            productHandle,
                            shopifyData.variantId,
                        );

                        if (typeof result === "number") {
                            // Got a plan ID directly from metafield
                            planId = result;
                            planLookupMethod = "variant_metafield";
                            log(
                                "[TuSim:AddToCart] ✅ Got plan ID from variant metafield",
                                planId,
                            );
                        } else if (result && result.variant) {
                            // Got variant object, extract duration from title
                            variantInfo = result.variant;
                            log(
                                "[TuSim:AddToCart] Got variant info, will extract duration from title",
                                {
                                    variantTitle: variantInfo.title,
                                },
                            );

                            const extractedDuration =
                                extractDurationFromText(variantInfo.title) ||
                                shopifyData.duration;

                            log("[TuSim:AddToCart] Extracted duration from variant title", {
                                title: variantInfo.title,
                                extractedDuration,
                            });

                            // Update shopifyData with extracted duration
                            shopifyData.duration = extractedDuration;
                            shopifyData.variantTitle = variantInfo.title;
                        } else {
                            log("[TuSim:AddToCart] ❌ No plan ID found in variant metafield");
                        }
                    }

                    // Priority 2: Try product metafields (plan_id_XXdias) based on captured duration
                    if (!planId) {
                        log("[TuSim:AddToCart] Trying product metafields", {
                            hasProductConfig: !!productConfig,
                            hasPlanIds: !!productConfig?.planIds,
                            duration: shopifyData.duration,
                            durationAsString: String(shopifyData.duration),
                            allPlanIds: productConfig?.planIds,
                        });

                        if (productConfig && productConfig.planIds) {
                            planId = productConfig.planIds[shopifyData.duration];
                            if (planId) planLookupMethod = "product_metafield";

                            log("[TuSim:AddToCart] Looking up plan with duration", {
                                duration: shopifyData.duration,
                                foundPlanId: planId,
                                planIdsKeys: Object.keys(productConfig.planIds),
                                planIdsValues: Object.values(productConfig.planIds),
                            });

                            if (planId) {
                                log(
                                    "[TuSim:AddToCart] ✅ Got plan ID from product metafield for duration",
                                    { duration: shopifyData.duration, planId },
                                );
                            } else {
                                log(
                                    "[TuSim:AddToCart] ❌ No plan ID found in product metafields for this duration",
                                    {
                                        duration: shopifyData.duration,
                                        availableDurations: Object.keys(
                                            productConfig.planIds,
                                        ).filter((k) => productConfig.planIds[k]),
                                    },
                                );
                            }
                        } else {
                            log(
                                "[TuSim:AddToCart] ❌ No product config or plan IDs available",
                            );
                        }
                    }

                    // Get Shopify product info first (needed for price comparison and fallback)
                    let shopifyProduct = null;
                    let shopifyVariant = null;
                    let shopifyPrice = null;

                    if (productHandle) {
                        try {
                            const productResponse = await fetch(
                                `/products/${productHandle}.json`,
                            );
                            if (productResponse.ok) {
                                const productData = await productResponse.json();
                                shopifyProduct = productData.product || productData;

                                if (shopifyData.variantId && shopifyProduct.variants) {
                                    shopifyVariant = shopifyProduct.variants.find(
                                        (v) => String(v.id) === String(shopifyData.variantId),
                                    );
                                    if (shopifyVariant && shopifyVariant.price) {
                                        // Shopify prices come in USD (dollars), not cents
                                        shopifyPrice = parseFloat(shopifyVariant.price);
                                        log("[TuSim:AddToCart] Found Shopify variant price", {
                                            variantId: shopifyVariant.id,
                                            rawPrice: shopifyVariant.price,
                                            finalPrice: shopifyPrice,
                                        });
                                    }
                                }

                                log("[TuSim:AddToCart] Shopify product info", {
                                    title: shopifyProduct.title,
                                    handle: shopifyProduct.handle,
                                    shopifyPrice,
                                });
                            }
                        } catch (err) {
                            error("[TuSim:AddToCart] Error fetching Shopify product", err);
                        }
                    }

                    // Priority 3: Search by product name intelligently
                    if (!planId && productHandle && shopifyProduct) {
                        const productName =
                            shopifyProduct.title || shopifyProduct.name || "";

                        let variantTitle = shopifyData.variantTitle || null;

                        if (!variantTitle && variantInfo && variantInfo.title) {
                            variantTitle = variantInfo.title;
                        }

                        if (
                            !variantTitle &&
                            shopifyData.variantId &&
                            shopifyProduct.variants
                        ) {
                            const variant = shopifyProduct.variants.find(
                                (v) => String(v.id) === String(shopifyData.variantId),
                            );
                            if (variant && variant.title) {
                                variantTitle = variant.title;
                            }
                        }

                        log(
                            "[TuSim:AddToCart] Attempting to find plan by product name intelligently",
                            {
                                productName,
                                variantTitle,
                                duration: shopifyData.duration,
                                simType: shopifyData.simType,
                                shopifyPrice,
                            },
                        );

                        planId = await findPlanByProductInfo(
                            productName,
                            shopifyData.duration,
                            shopifyData.simType,
                            variantTitle,
                            shopifyPrice,
                        );

                        if (planId) {
                            planLookupMethod = "intelligent_search";
                            log(
                                "[TuSim:AddToCart] ✅ Found plan ID by intelligent search",
                                planId,
                            );
                        } else {
                            log("[TuSim:AddToCart] ❌ No plan found by intelligent search");
                        }
                    }

                    // If no plan found, use Shopify price
                    if (!planId) {
                        if (shopifyPrice !== null && shopifyPrice > 0) {
                            planLookupMethod = "shopify_price_fallback";
                            log("[TuSim:AddToCart] ⚠️ No plan found, using Shopify price", {
                                shopifyPrice,
                            });

                            plan = {
                                id: null,
                                name: shopifyProduct?.title || T[LANG].shopifyProductFallback,
                                price: shopifyPrice,
                                price_cop: shopifyPrice * 3719.71,
                                duration: shopifyData.duration || null,
                                coverage: null,
                                fromShopify: true,
                            };

                            planId = null;
                        } else {
                            alert(
                                T[LANG].planConfigError,
                            );
                            element.dataset.tusimProcessing = "false";
                            return;
                        }
                    } else {
                        // Fetch full plan details
                        try {
                            const planResponse = await fetch(
                                `${TUSIM_CONFIG.apiUrl}/plans/${planId}`,
                                {
                                    method: "GET",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${TUSIM_CONFIG.jwtToken}`,
                                    },
                                },
                            );

                            if (planResponse.ok) {
                                plan = await planResponse.json();
                                log("[TuSim:AddToCart] Fetched plan details", plan);

                                if (shopifyPrice !== null && shopifyPrice > 0) {
                                    log(
                                        "[TuSim:AddToCart] Overriding plan price with Shopify price",
                                        {
                                            planId: plan.id,
                                            planPrice: plan.price,
                                            shopifyPrice,
                                        },
                                    );
                                    plan.price = shopifyPrice;
                                    plan.price_cop = shopifyPrice * 3719.71;
                                    plan.fromShopify = true;
                                }
                            } else {
                                error("[TuSim:AddToCart] Failed to fetch plan details");

                                if (shopifyPrice !== null && shopifyPrice > 0) {
                                    log(
                                        "[TuSim:AddToCart] ⚠️ Plan fetch failed, using Shopify price",
                                        {
                                            shopifyPrice,
                                        },
                                    );

                                    plan = {
                                        id: planId,
                                        name: shopifyProduct?.title || T[LANG].shopifyProductFallback,
                                        price: shopifyPrice,
                                        price_cop: shopifyPrice * 3719.71,
                                        duration: shopifyData.duration || null,
                                        coverage: null,
                                        fromShopify: true,
                                    };

                                    planId = null;
                                } else {
                                    alert(
                                        T[LANG].planDetailsError,
                                    );
                                    element.dataset.tusimProcessing = "false";
                                    return;
                                }
                            }
                        } catch (err) {
                            error("[TuSim:AddToCart] Error fetching plan", err);

                            if (shopifyPrice !== null && shopifyPrice > 0) {
                                log(
                                    "[TuSim:AddToCart] ⚠️ Plan fetch error, using Shopify price",
                                    {
                                        shopifyPrice,
                                        error: err.message,
                                    },
                                );

                                plan = {
                                    id: planId,
                                    name: shopifyProduct?.title || T[LANG].shopifyProductFallback,
                                    price: shopifyPrice,
                                    price_cop: shopifyPrice * 3719.71,
                                    duration: shopifyData.duration || null,
                                    coverage: null,
                                    fromShopify: true,
                                };

                                planId = null;
                            } else {
                                alert(
                                    T[LANG].planDetailsError,
                                );
                                element.dataset.tusimProcessing = "false";
                                return;
                            }
                        }
                    }

                    // Add to cart instead of opening form directly
                    shopifyData.planLookupMethod = planLookupMethod;
                    log("[TuSim:AddToCart] Adding product to cart", {
                        planId,
                        planLookupMethod,
                    });
                    const cartItem = {
                        planId,
                        plan: {
                            ...plan,
                            price: parseFloat(plan.price) || 0,
                            price_cop:
                                parseFloat(plan.price_cop) ||
                                parseFloat(plan.price) * 3719.71 ||
                                0,
                        },
                        shopifyData,
                        shopifyProduct: shopifyProduct || null,
                        shopifyVariant: shopifyVariant || null,
                        quantity: shopifyData.quantity || 1,
                        price: parseFloat(plan.price) || 0,
                    };

                    const updatedCart = await addToCart(cartItem);
                    showAddToCartConfirmation(plan, updatedCart, cartItem.shopifyProduct);
                    updateCartBadge(updatedCart.items.length);
                } catch (err) {
                    error("[TuSim:AddToCart] Error processing add to cart", err);
                    alert(
                        T[LANG].addToCartError,
                    );
                } finally {
                    element.dataset.tusimProcessing = "false";
                }
            },
            true,
        );
    }

    async function interceptButtons() {
        if (!productConfig) {
            productConfig = await checkLandingPageEnabled();
        }

        if (!productConfig.enabled) return;

        const validSelectors = [
            'button[name="add"]',
            'button[data-testid="buy-now-button"]',
            'form[action*="/cart/add"] button[type="submit"]',
            'button[type="submit"]',
            '[data-product-form] button[type="submit"]',
            ".product-form__cart-submit",
            "#AddToCart",
        ];

        validSelectors.forEach((selector) => {
            try {
                const elements = document.querySelectorAll(selector);
                elements.forEach((element) => {
                    attachClickListener(element);
                });
            } catch (err) {
                error(`Invalid selector: ${selector}`, err);
            }
        });

        const textBasedButtons = findButtonByText([
            "Agregar al carrito",
            "Add to cart",
            "Adicionar ao carrinho",
            "Comprar con G Pay",
            "Buy with G Pay",
            "Comprar ahora",
            "Buy now",
        ]);

        if (textBasedButtons) {
            attachClickListener(textBasedButtons);
        }

        const allButtons = document.querySelectorAll("button");
        allButtons.forEach((button) => {
            const text = (button.textContent || button.innerText || "").trim();
            if (
                (text.includes("Agregar") && text.includes("carrito")) ||
                (text.includes("Add") && text.includes("cart")) ||
                (text.includes("Adicionar") && text.includes("carrinho")) ||
                (text.includes("Comprar") && text.includes("con")) ||
                (text.includes("Buy") && text.includes("G Pay"))
            ) {
                attachClickListener(button);
            }
        });
    }

    function interceptCheckoutButtons() {
        const checkoutSelectors = [
            'a[href*="/checkout"]',
            'button[name="checkout"]',
            "[data-checkout-button]",
            ".cart__checkout",
            'button[type="submit"][name="checkout"]',
            '[href="/checkout"]',
            ".shopify-payment-button",
        ];

        checkoutSelectors.forEach((selector) => {
            try {
                document.querySelectorAll(selector).forEach((element) => {
                    if (element.dataset.tusimCheckoutIntercepted) return;

                    element.dataset.tusimCheckoutIntercepted = "true";

                    element.addEventListener(
                        "click",
                        (e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            log("[TuSim:Checkout] Intercepted Shopify checkout button");

                            const cart = getCart();
                            if (cart.items.length > 0) {
                                log(
                                    "[TuSim:Checkout] Opening cart modal with items",
                                    cart.items.length,
                                );
                                openCartModal();
                            } else {
                                log("[TuSim:Checkout] Cart is empty, showing message");
                                alert(
                                    "Tu carrito está vacío. Agrega productos de TuSim para continuar.",
                                );
                            }
                        },
                        true,
                    );

                    log("[TuSim:Checkout] Intercepted checkout button", {
                        selector,
                        element,
                    });
                });
            } catch (err) {
                error(`[TuSim:Checkout] Error with selector: ${selector}`, err);
            }
        });
    }

    function initTusimButtons() {
        document.querySelectorAll('[data-tusim-btn]').forEach((btn) => {
            if (btn.dataset.tusimTextUpdated) return;
            const textSpan = btn.querySelector('.tusim-btn-text');
            if (btn.disabled === false && textSpan) {
                textSpan.textContent = T[LANG].addToCartBtn;
                btn.dataset.tusimTextUpdated = 'true';
            }
        });
    }

    // Initialize cart badge and start intercepting
    async function initializeWidget() {
        if (window.isAssistCardBR || window.isAssistCardES) {
            log("[TuSim:Widget] Fetching BRL/EUR exchange rate");
            const loader = document.createElement('div');
            loader.id = 'tusim-brl-loader';
            loader.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.8);z-index:999999;display:flex;justify-content:center;align-items:center;';
            loader.innerHTML = '<div style="width:40px;height:40px;border:4px solid #f3f3f3;border-top:4px solid #5d1c84;border-radius:50%;animation:spin 1s linear infinite;"></div><style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>';
            document.body.appendChild(loader);

            try {
                const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
                const data = await res.json();
                window.USD_TO_BRL_RATE = data.rates.BRL;
                window.USD_TO_EUR_RATE = data.rates.EUR;
                log("[TuSim:Widget] BRL rate fetched:", window.USD_TO_BRL_RATE);
                log("[TuSim:Widget] EUR rate fetched:", window.USD_TO_EUR_RATE);
            } catch (err) {
                error("[TuSim:Widget] Error fetching BRL rate, using fallback", err);
                window.USD_TO_BRL_RATE = 5.5;
                window.USD_TO_EUR_RATE = 0.92;
            }

            if (loader.parentNode) loader.parentNode.removeChild(loader);

            // Update Shopify native product prices
            const updateNativePrices = () => {
                const regularPrices = document.querySelectorAll('.price-item.price-item--regular');
                regularPrices.forEach(el => {
                    const text = el.textContent;
                    const match = text.match(/\$\s*([0-9,.]+)/);
                    if (match && !el.dataset.brlUpdated) {
                        const amount = parseFloat(match[1].replace(/,/g, ''));
                        if (!isNaN(amount)) {
                            el.textContent = window.formatCurrency(amount);
                            el.dataset.brlUpdated = "true";
                            el.classList.add(window.isAssistCardBR ? "brl-loaded" : "euro-loaded");
                        }
                    }
                });

                const salePrices = document.querySelectorAll('.price .price-item.price-item--sale');
                salePrices.forEach(el => {
                    const text = el.textContent;
                    const match = text.match(/\$\s*([0-9,.]+)/);
                    if (match && !el.dataset.brlUpdated) {
                        const amount = parseFloat(match[1].replace(/,/g, ''));
                        if (!isNaN(amount)) {
                            const prefix = text.includes('A partir de') ? 'A partir de ' : '';
                            el.textContent = prefix + window.formatCurrency(amount);
                            el.dataset.brlUpdated = "true";
                            el.classList.add(window.isAssistCardBR ? "brl-loaded" : "euro-loaded");
                        }
                    }
                });
            };

            updateNativePrices();
            const priceObserver = new MutationObserver(() => {
                updateNativePrices();
            });
            const priceContainer = document.querySelector('.price');
            if (priceContainer) {
                priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
            }
            // Also observe whole document for variant changes (price elements may be replaced)
            const variantObserver = new MutationObserver(() => {
                updateNativePrices();
            });
            variantObserver.observe(document.body, { childList: true, subtree: true });
        }

        log("[TuSim:Widget] Initializing widget");
        createCartBadge();
        interceptButtons();
        interceptCheckoutButtons();
        initTusimButtons();
        initDateValidation();
    }

    function initDateValidation() {
        const dateInput = document.querySelector('#delivery_date');
        if (!dateInput || dateInput.dataset.tusimDateListenerAttached) return;

        dateInput.dataset.tusimDateListenerAttached = 'true';

        let errorEl = dateInput.parentElement.querySelector('.tusim-date-error');
        if (!errorEl) {
            errorEl = document.createElement('span');
            errorEl.className = 'tusim-date-error';
            errorEl.style.cssText = 'color:#e74c3c;font-size:12px;display:none;margin-top:4px;';
            dateInput.parentElement.appendChild(errorEl);
        }

        function showDateError(msg) {
            errorEl.textContent = msg;
            errorEl.style.display = 'block';
            dateInput.style.borderColor = '#e74c3c';
        }

        function clearDateError() {
            errorEl.style.display = 'none';
            dateInput.style.borderColor = '';
        }

        dateInput.addEventListener('change', function () {
            const val = this.value;
            if (val && !isValidDate(val)) {
                log('[TuSim:Date] Invalid date detected', { original: val });
                showDateError('Fecha no válida. Selecciona una fecha del calendario.');
                this.value = '';
            } else {
                clearDateError();
            }
        });

        dateInput.addEventListener('blur', function () {
            const val = this.value;
            if (val && !isValidDate(val)) {
                log('[TuSim:Date] Invalid date detected on blur', { original: val });
                showDateError('Fecha no válida. Selecciona una fecha del calendario.');
                this.value = '';
            }
        });
    }

    // Expose public API
    window.TuSimWidget = {
        openCart: openCartModal,
        getCart: getCart,
        clearCart: () => {
            clearCart();
            updateCartBadge(0);
            log("[TuSim:API] Cart cleared via public API");
        },
        addToCart: async (item) => {
            const cart = await addToCart(item);
            updateCartBadge(cart.items.length);
            log("[TuSim:API] Item added via public API");
            return cart;
        },
        version: "2.0.0",
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            setTimeout(initializeWidget, 1000);
        });
    } else {
        setTimeout(initializeWidget, 1000);
    }

    const observer = new MutationObserver(() => {
        interceptButtons();
        interceptCheckoutButtons();
        initTusimButtons();
        initDateValidation();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Periodic checkout interception for dynamic buttons
    setInterval(interceptCheckoutButtons, 2000);

    log("[TuSim:Widget] Widget loaded successfully");
})();